export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };

      export type PossibleTypesResultData = {
  "possibleTypes": {
    "PolicyUnionType": [
      "AutoPolicyType",
      "HomePolicyType",
      "LifePolicyType",
      "PetPolicyType",
      "PolicyType",
      "RenterPolicyType"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "PolicyUnionType": [
      "AutoPolicyType",
      "HomePolicyType",
      "LifePolicyType",
      "PetPolicyType",
      "PolicyType",
      "RenterPolicyType"
    ]
  }
};
      export default result;
    
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  DateTime: string;
  Decimal: any;
  JSONString: any;
  UUID: string;
};

export type AcceptSharedAccess = {
  __typename: 'AcceptSharedAccess';
  ok?: Maybe<Scalars['Boolean']>;
};

export type ActivityPaginatedType = {
  __typename: 'ActivityPaginatedType';
  hasNext?: Maybe<Scalars['Boolean']>;
  hasPrev?: Maybe<Scalars['Boolean']>;
  objects?: Maybe<Array<ActivityType>>;
  orderBy?: Maybe<Array<OrderByType>>;
  page?: Maybe<Scalars['Int']>;
  pages?: Maybe<Scalars['Int']>;
  totalResults?: Maybe<Scalars['Int']>;
};

export type ActivityType = {
  __typename: 'ActivityType';
  activityType: ActivityTypeType;
  concept: Scalars['String'];
  date: Scalars['Date'];
  id: Scalars['UUID'];
  isDonation?: Maybe<Scalars['Boolean']>;
  marbles: Scalars['Int'];
  message?: Maybe<Scalars['String']>;
  money: Scalars['Float'];
  status?: Maybe<StatusType>;
};

/** An enumeration. */
export type ActivityTypeType =
  | 'REDEEM'
  | 'REWARD';

export type AddEngagementCardAction = {
  __typename: 'AddEngagementCardAction';
  ok?: Maybe<Scalars['Boolean']>;
};

export type AnswerFeedbackQuestion = {
  __typename: 'AnswerFeedbackQuestion';
  ok?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export type AntiTheftProtectionsType =
  | 'AUTOMATIC_ALARM'
  | 'LOJACK'
  | 'NONE'
  | 'PASSIVE_ALARM'
  | 'STARTER_CUTOFF_SWITCH'
  | 'VIN_ETCHINGS';

export type AppUpdateReminderType = {
  __typename: 'AppUpdateReminderType';
  body: Scalars['String'];
  header?: Maybe<Scalars['String']>;
  updateType: AppUpdateTypeType;
};

/** An enumeration. */
export type AppUpdateTypeType =
  | 'BANNER'
  | 'REQUIRED_SCREEN';

export type ArchiveHealthPolicy = {
  __typename: 'ArchiveHealthPolicy';
  ok?: Maybe<Scalars['Boolean']>;
};

export type ArchivePolicyInput = {
  archiveReason: ArchiveReasonType;
  id: Scalars['UUID'];
};

/** An enumeration. */
export type ArchiveReasonType =
  | 'USER_ARCHIVE_CANCELED'
  | 'USER_ARCHIVE_CANCELED_REPLACED'
  | 'USER_ARCHIVE_DO_NOT_WANT'
  | 'USER_ARCHIVE_OTHER'
  | 'USER_REQUEST_FIX';

export type ArchiveShoppingCart = {
  __typename: 'ArchiveShoppingCart';
  ok?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export type ArchiveShoppingCartType =
  | 'AUTO_RENEWED'
  | 'CARRIERS'
  | 'COVERAGE'
  | 'EFFORT'
  | 'EXPENSIVE'
  | 'NO_OFFERS'
  | 'OTHER';

export type AuthorizePaymentDisplay = {
  __typename: 'AuthorizePaymentDisplay';
  ok?: Maybe<Scalars['Boolean']>;
};

export type AuthorizePaymentDisplayInput = {
  nonce: Scalars['String'];
  paymentMethod: PaymentMethodType;
  paymentTokenId: Scalars['UUID'];
};

export type AutoPolicyType = {
  __typename: 'AutoPolicyType';
  address?: Maybe<Scalars['String']>;
  archiveDate?: Maybe<Scalars['DateTime']>;
  basicSyncFailed: Scalars['Boolean'];
  canopyEmbeddedCarrier?: Maybe<Scalars['String']>;
  carrier?: Maybe<CarrierType>;
  category?: Maybe<CategoryType>;
  continuous: Scalars['Boolean'];
  coverageSynced: Scalars['Boolean'];
  documents?: Maybe<Array<PolicyDocumentType>>;
  drivers: Array<DriverType>;
  endDate?: Maybe<Scalars['Date']>;
  fees?: Maybe<Scalars['Float']>;
  historyId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  isOnRenewal?: Maybe<Scalars['Boolean']>;
  isPolicyOwner?: Maybe<Scalars['Boolean']>;
  namedInsured?: Maybe<Array<Scalars['String']>>;
  nextPaymentDue?: Maybe<Scalars['Date']>;
  policyHistory?: Maybe<Array<PolicyHistoryType>>;
  policyNumber?: Maybe<Scalars['String']>;
  policyPremium?: Maybe<Scalars['Float']>;
  premiumPeriod?: Maybe<PremiumPeriodType>;
  shareableId?: Maybe<Scalars['UUID']>;
  sharedAccess?: Maybe<Array<SharedAccessType>>;
  showSyncAnimation: Scalars['Boolean'];
  startDate?: Maybe<Scalars['Date']>;
  syncFailureReason?: Maybe<SyncFailureReasonType>;
  synced: Scalars['Boolean'];
  total?: Maybe<Scalars['Float']>;
  user: UserType;
  vehicles: Array<VehicleAssetType>;
  wrongDocumentType?: Maybe<WrongDocumentTypeType>;
};

/** An enumeration. */
export type BannerPage =
  /** Insurance Insider */
  | 'INSURANCE_INSIDER'
  /** Login page */
  | 'LOGIN_PAGE'
  /** Register page */
  | 'REGISTER_PAGE'
  /** Rewards */
  | 'REWARDS'
  /** Shopping */
  | 'SHOPPING'
  /** Wallet */
  | 'WALLET'
  /** Wallet - Pending Basic Sync */
  | 'WALLET_PENDING_BASIC_SYNC';

export type BannerType = {
  __typename: 'BannerType';
  activeOnMobile: Scalars['Boolean'];
  activeOnWeb: Scalars['Boolean'];
  created?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['Date']>;
  id: Scalars['UUID'];
  modified?: Maybe<Scalars['DateTime']>;
  page?: Maybe<BannerPage>;
  startDate?: Maybe<Scalars['Date']>;
  text: Scalars['String'];
  title: Scalars['String'];
};

export type BeneficiaryType = {
  __typename: 'BeneficiaryType';
  created?: Maybe<Scalars['DateTime']>;
  dob?: Maybe<Scalars['Date']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  lastName?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  percentage?: Maybe<Scalars['Float']>;
  policy: LifePolicyType;
};

export type BindableOfferType = {
  __typename: 'BindableOfferType';
  assetName?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  paymentDetailsSubmitted?: Maybe<Scalars['Boolean']>;
};

export type BiometricsDeletePublicKey = {
  __typename: 'BiometricsDeletePublicKey';
  ok?: Maybe<Scalars['Boolean']>;
};

export type BiometricsLoginInput = {
  signature: Scalars['String'];
  userId: Scalars['UUID'];
};

export type BiometricsUpdatePublicKey = {
  __typename: 'BiometricsUpdatePublicKey';
  ok?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export type BodilyInjuryCoverageType =
  | 'A_25SLASH50'
  | 'A_50SLASH50'
  | 'A_50SLASH100'
  | 'A_100SLASH100'
  | 'A_100SLASH300'
  | 'A_100SPACECSL'
  | 'A_250SLASH500'
  | 'A_300SLASH300'
  | 'A_300SPACECSL'
  | 'A_500SLASH500'
  | 'A_500SPACECSL'
  | 'A_1000SLASH1000'
  | 'A_StateSPACEMinimum';

export type CanopyAuthInput = {
  insurerName: Scalars['String'];
  insurerPassword?: InputMaybe<Scalars['String']>;
  insurerThirdField?: InputMaybe<Scalars['String']>;
  insurerUsername: Scalars['String'];
  pullId: Scalars['String'];
  pullJwt: Scalars['String'];
};

export type CanopyConnectResponseType = {
  __typename: 'CanopyConnectResponseType';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  loginErrorMessage?: Maybe<Scalars['String']>;
  mfaHelperText?: Maybe<Scalars['String']>;
  mfaOptions?: Maybe<Scalars['JSONString']>;
  phone?: Maybe<Scalars['String']>;
  pullId?: Maybe<Scalars['String']>;
  pullJwt?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['UUID']>;
};

export type CanopyConsentInput = {
  captchaValue?: InputMaybe<Scalars['String']>;
  category: CategoryType;
  insurerName: Scalars['String'];
  insurerPassword?: InputMaybe<Scalars['String']>;
  insurerThirdField?: InputMaybe<Scalars['String']>;
  insurerUsername: Scalars['String'];
  policyId?: InputMaybe<Scalars['UUID']>;
  termsVersion: Scalars['Int'];
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  utmTerm?: InputMaybe<Scalars['String']>;
};

export type CanopyMfaAnswer = {
  __typename: 'CanopyMFAAnswer';
  shouldPoll?: Maybe<Scalars['Boolean']>;
};

export type CanopyMfaAnswerInput = {
  mfaValue: Scalars['String'];
  pullId: Scalars['String'];
  pullJwt: Scalars['String'];
};

export type CanopyMfaOption = {
  __typename: 'CanopyMFAOption';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CanopyMfaOptionInput = {
  optionKey: Scalars['String'];
  pullId: Scalars['String'];
  pullJwt: Scalars['String'];
};

export type CanopyReconnect = {
  __typename: 'CanopyReconnect';
  shouldPoll?: Maybe<Scalars['Boolean']>;
};

export type CanopyTosType = {
  __typename: 'CanopyTosType';
  termsHtml?: Maybe<Scalars['String']>;
  termsVersion?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export type CareerStatusType =
  | 'DISABLED'
  | 'EMPLOYED'
  | 'RETIRED'
  | 'STUDENT'
  | 'UNEMPLOYED';

export type CarrierPaginatedType = {
  __typename: 'CarrierPaginatedType';
  hasNext?: Maybe<Scalars['Boolean']>;
  hasPrev?: Maybe<Scalars['Boolean']>;
  objects?: Maybe<Array<CarrierType>>;
  orderBy?: Maybe<Array<OrderByType>>;
  page?: Maybe<Scalars['Int']>;
  pages?: Maybe<Scalars['Int']>;
  totalResults?: Maybe<Scalars['Int']>;
};

export type CarrierReviewInput = {
  carrierId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  rating: Scalars['Int'];
};

export type CarrierReviewType = {
  __typename: 'CarrierReviewType';
  carrierId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
};

export type CarrierScoreType = {
  __typename: 'CarrierScoreType';
  category?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['String']>;
};

export type CarrierType = {
  __typename: 'CarrierType';
  avgRating?: Maybe<Scalars['Float']>;
  canopyId?: Maybe<Scalars['String']>;
  /** Company code that is human readable and will be used for short links. */
  carrierSymbol: Scalars['String'];
  categories?: Maybe<Array<Scalars['String']>>;
  claimUrl?: Maybe<Scalars['String']>;
  claimsRank?: Maybe<Scalars['Int']>;
  claimsScore?: Maybe<Scalars['Int']>;
  considerations?: Maybe<Array<Maybe<Scalars['String']>>>;
  contactUrl?: Maybe<Scalars['String']>;
  createAccountUrl?: Maybe<Scalars['String']>;
  decTipsUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  disablePasswordField?: Maybe<Scalars['Boolean']>;
  discounts?: Maybe<Array<Maybe<Scalars['String']>>>;
  goodFor?: Maybe<Array<Maybe<Scalars['String']>>>;
  hideInsider: Scalars['Boolean'];
  id: Scalars['UUID'];
  logo?: Maybe<Scalars['String']>;
  marbleScore?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  numRatings?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['Int']>;
  resetPasswordUrl?: Maybe<Scalars['String']>;
  scores?: Maybe<Array<Maybe<CarrierScoreType>>>;
  thirdFieldPlaceholder?: Maybe<Scalars['String']>;
  usernameFieldPlaceholder?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export type CategoryType =
  | 'AUTO'
  | 'HOME'
  | 'LIFE'
  | 'PET'
  | 'RENTER';

export type ChangePasswordInput = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
  repeatPassword: Scalars['String'];
};

export type CommonLandingDataType = {
  __typename: 'CommonLandingDataType';
  created?: Maybe<Scalars['DateTime']>;
  footerCta?: Maybe<Scalars['String']>;
  footerTitle?: Maybe<Scalars['String']>;
  headerTitle?: Maybe<Scalars['String']>;
  mainImage?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  partnerlandingconfigSet: Array<MarketingLandingDataType>;
  subheader1Text?: Maybe<Scalars['String']>;
  subheader1Title?: Maybe<Scalars['String']>;
  subheader2Text?: Maybe<Scalars['String']>;
  subheader2Title?: Maybe<Scalars['String']>;
  subheader3Text?: Maybe<Scalars['String']>;
  subheader3Title?: Maybe<Scalars['String']>;
  subheader4Text?: Maybe<Scalars['String']>;
  subheader4Title?: Maybe<Scalars['String']>;
  testimonials?: Maybe<Array<Maybe<TestimonialType>>>;
};

/** An enumeration. */
export type ComprehensiveAndCollisionDeductibleType =
  | 'A_0'
  | 'A_50'
  | 'A_100'
  | 'A_200'
  | 'A_250'
  | 'A_500'
  | 'A_1000'
  | 'A_2000'
  | 'A_2500'
  | 'A_NoSPACECoverage';

export type ConfirmLegalName = {
  __typename: 'ConfirmLegalName';
  ok?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export type ConstructionType =
  | 'ADOBE'
  | 'ALUMINUM_FRAME'
  | 'ALUMINUM_SIDING'
  | 'ALUMINUM_VINYL'
  | 'ARCHED_DOME'
  | 'A_FRAME'
  | 'BLOCK_BRICK'
  | 'BLOCK_METAL'
  | 'BLOCK_STEEL'
  | 'BRICK'
  | 'BRICK_CINDER_BLOCK'
  | 'BRICK_CONCRETE'
  | 'BRICK_FRAME'
  | 'BRICK_METAL'
  | 'BRICK_STEEL'
  | 'BRICK_STONE'
  | 'BRICK_STUCCO'
  | 'BRICK_VENEER'
  | 'CINDER_BLOCK'
  | 'CLAPBOARD'
  | 'COMBINATION'
  | 'CONCRETE'
  | 'CONCRETE_BLOCK'
  | 'CONCRETE_MASONRY'
  | 'CONCRETE_STEEL'
  | 'CUSTOM'
  | 'DOME'
  | 'FLEXIBLE_FLEXICORE'
  | 'FRAME'
  | 'FRAME_MASONRY'
  | 'FRAME_STEEL'
  | 'FRAME_STUCCO'
  | 'GLASS'
  | 'HEAVY'
  | 'LIGHT'
  | 'LOG'
  | 'MANUFACTURED_MODULAR'
  | 'MASONRY'
  | 'MASONRY_TILT_UP'
  | 'METAL'
  | 'NONE'
  | 'POLE_FRAME'
  | 'PREFAB_METAL'
  | 'STEEL'
  | 'STEEL_MASONRY'
  | 'STEEL_STUCCO'
  | 'STEEL_WOOD'
  | 'STONE_ROCK'
  | 'STONE_VENEER'
  | 'STUCCO'
  | 'TILT_UP'
  | 'TILT_UP_BRICK_METAL'
  | 'TILT_UP_CONCRETE'
  | 'TYPE_NOT_SPECIFIED'
  | 'TYPE_UNKNOWN'
  | 'WOOD'
  | 'WOOD_BRICK'
  | 'WOOD_FRAME'
  | 'WOOD_FRAME_CONCRETE_BLOCK'
  | 'WOOD_FRAME_METAL'
  | 'WOOD_STEEL'
  | 'WOOD_STONE'
  | 'WOOD_STUCCO';

/** An enumeration. */
export type ContinuousCoverageLengthType =
  | 'EIGHT_YEARS'
  | 'FIVE_YEARS'
  | 'FOUR_YEARS'
  | 'NINE_YEARS'
  | 'ONE_YEAR'
  | 'OVER_TEN_YEARS'
  | 'SEVEN_YEARS'
  | 'SIX_YEARS'
  | 'TEN_YEARS'
  | 'THREE_YEARS'
  | 'TWO_YEARS'
  | 'UNDER_1Y'
  | 'UNDER_6M';

export type CoverageDetailsType = {
  __typename: 'CoverageDetailsType';
  beneficiaries?: Maybe<Array<Maybe<ShoppingBeneficiaryType>>>;
  cashValue?: Maybe<Scalars['Decimal']>;
  coinsurance?: Maybe<Scalars['Int']>;
  collisionDeductible?: Maybe<Scalars['Decimal']>;
  comprehensiveDeductible?: Maybe<Scalars['Decimal']>;
  deathBenefit?: Maybe<Scalars['Decimal']>;
  deductible?: Maybe<Scalars['Decimal']>;
  deductibleWind?: Maybe<Scalars['Decimal']>;
  dwelling?: Maybe<Scalars['Decimal']>;
  isGroup?: Maybe<Scalars['Boolean']>;
  lossUse?: Maybe<Scalars['Decimal']>;
  medicalOthers?: Maybe<Scalars['Decimal']>;
  otherStructures?: Maybe<Scalars['Decimal']>;
  otherTermYears?: Maybe<Scalars['Int']>;
  othersBodilyAccident?: Maybe<Scalars['Decimal']>;
  othersBodilyPerson?: Maybe<Scalars['Decimal']>;
  othersPropertyAccident?: Maybe<Scalars['Decimal']>;
  personalLiability?: Maybe<Scalars['Decimal']>;
  personalProperty?: Maybe<Scalars['Decimal']>;
  personalProtectionAccident?: Maybe<Scalars['Decimal']>;
  personalProtectionPerson?: Maybe<Scalars['Decimal']>;
  planType?: Maybe<LifePolicyPlanType>;
  reimbursement?: Maybe<Scalars['Int']>;
  riders?: Maybe<Array<Maybe<Scalars['String']>>>;
  totalPremium?: Maybe<Scalars['Decimal']>;
  uninsuredMotoristAccident?: Maybe<Scalars['Decimal']>;
  uninsuredMotoristPerson?: Maybe<Scalars['Decimal']>;
  uninsuredPropertyAccident?: Maybe<Scalars['Decimal']>;
};

export type CoverageItemInfoExampleType = {
  __typename: 'CoverageItemInfoExampleType';
  coverageItemInfo: CoverageItemInfoType;
  created?: Maybe<Scalars['DateTime']>;
  exampleType: ExampleTypeType;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  modified?: Maybe<Scalars['DateTime']>;
  order: Scalars['Int'];
  title: Scalars['String'];
  videoUrl?: Maybe<Scalars['String']>;
};

export type CoverageItemInfoType = {
  __typename: 'CoverageItemInfoType';
  coverageItem: CoverageItemType;
  created?: Maybe<Scalars['DateTime']>;
  definition: Scalars['String'];
  examples: Array<CoverageItemInfoExampleType>;
  id: Scalars['UUID'];
  modified?: Maybe<Scalars['DateTime']>;
};

/** An enumeration. */
export type CoverageItemType =
  | 'AUTO_DEDUCTIBLE_COLLISION'
  | 'AUTO_DEDUCTIBLE_COMPREHENSIVE'
  | 'AUTO_LIABILITY_BODILY'
  | 'AUTO_LIABILITY_PROPERTY'
  | 'AUTO_MEDICAL_PAYMENTS'
  | 'AUTO_PERSONAL_INJURY'
  | 'AUTO_RENTAL_REIMBURSEMENT'
  | 'AUTO_ROADSIDE_ASSISTANCE'
  | 'AUTO_UNINSURED_MOTORIST'
  | 'AUTO_UNINSURED_PROPERTY'
  | 'HOME_DEDUCTIBLE'
  | 'HOME_DEDUCTIBLE_WIND'
  | 'HOME_DWELLING'
  | 'HOME_LOSS_USE'
  | 'HOME_MEDICAL_PAYMENTS'
  | 'HOME_OTHER_STRUCTURES'
  | 'HOME_PERSONAL_LIABILITY'
  | 'HOME_PERSONAL_PROPERTY'
  | 'PET_ANNUAL_DEDUCTIBLE'
  | 'PET_COINSURANCE'
  | 'PET_REIMBURSEMENT'
  | 'RENTER_DEDUCTIBLE'
  | 'RENTER_LOSS_USE'
  | 'RENTER_MEDICAL_PAYMENTS'
  | 'RENTER_PERSONAL_LIABILITY'
  | 'RENTER_PERSONAL_PROPERTY';

export type CreateCarrierReview = {
  __typename: 'CreateCarrierReview';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateLeadGenEmailOnly = {
  __typename: 'CreateLeadGenEmailOnly';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateLink = {
  __typename: 'CreateLink';
  contentType?: Maybe<Scalars['String']>;
  retrieveUrl?: Maybe<Scalars['String']>;
  uploadUrl?: Maybe<Scalars['String']>;
};

export type CreateOrUpdateNamedInsuredInput = {
  category: CategoryType;
  dob: Scalars['Date'];
  firstName: Scalars['String'];
  gender: GenderType;
  lastName: Scalars['String'];
  namedInsuredId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type CreateOrUpdateRenewalOffer = {
  __typename: 'CreateOrUpdateRenewalOffer';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateReminderInput = {
  id?: InputMaybe<Scalars['UUID']>;
  notes?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  policyCategory?: InputMaybe<CategoryType>;
  policyId?: InputMaybe<Scalars['UUID']>;
  reminderCategory?: InputMaybe<ReminderCategoryType>;
  reminderDate: Scalars['Date'];
  reminderMethod: ReminderMethodType;
};

export type CreateShareableId = {
  __typename: 'CreateShareableId';
  shareableId?: Maybe<Scalars['UUID']>;
};

/** An enumeration. */
export type CreditScoreType =
  | 'AVERAGE'
  | 'BELOW_AVERAGE'
  | 'EXCELLENT'
  | 'GOOD'
  | 'POOR';

/** An enumeration. */
export type CurrentCoverageLevelType =
  | 'FIFTY'
  | 'FIVE_HUNDRED'
  | 'HUNDRED'
  | 'OVER_FIVE_HUNDRED'
  | 'THREE_HUNDRED';

/** An enumeration. */
export type CurrentPremiumPeriodType =
  | 'MONTH'
  | 'SIX_MONTHS'
  | 'YEAR';

export type DeleteOtherPolicy = {
  __typename: 'DeleteOtherPolicy';
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeletePolicyDocument = {
  __typename: 'DeletePolicyDocument';
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteReminder = {
  __typename: 'DeleteReminder';
  ok?: Maybe<Scalars['Boolean']>;
};

export type DesiredCoveragesInput = {
  bodilyInjury?: InputMaybe<BodilyInjuryCoverageType>;
  collisionDeductible?: InputMaybe<ComprehensiveAndCollisionDeductibleType>;
  comprehensiveDeductible?: InputMaybe<ComprehensiveAndCollisionDeductibleType>;
  propertyDamage?: InputMaybe<PropertyDamageCoverageType>;
  rental?: InputMaybe<RentalCoverageType>;
  towing?: InputMaybe<TowingCoverageType>;
  underinsuredMotorist?: InputMaybe<UnAndUnderInsuredCoverageType>;
  uninsuredMotorist?: InputMaybe<UnAndUnderInsuredCoverageType>;
  uninsuredMotoristPropertyDamage?: InputMaybe<PropertyDamageCoverageType>;
};

export type DesiredCoveragesType = {
  __typename: 'DesiredCoveragesType';
  bodilyInjury?: Maybe<BodilyInjuryCoverageType>;
  collisionDeductible?: Maybe<ComprehensiveAndCollisionDeductibleType>;
  comprehensiveDeductible?: Maybe<ComprehensiveAndCollisionDeductibleType>;
  created?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  modified?: Maybe<Scalars['DateTime']>;
  propertyDamage?: Maybe<PropertyDamageCoverageType>;
  rental?: Maybe<RentalCoverageType>;
  towing?: Maybe<TowingCoverageType>;
  underinsuredMotorist?: Maybe<UnAndUnderInsuredCoverageType>;
  uninsuredMotorist?: Maybe<UnAndUnderInsuredCoverageType>;
  uninsuredMotoristPropertyDamage?: Maybe<PropertyDamageCoverageType>;
  vehicle: VehicleType;
};

export type DiscardReward = {
  __typename: 'DiscardReward';
  ok?: Maybe<Scalars['Boolean']>;
};

export type DismissOffer = {
  __typename: 'DismissOffer';
  ok?: Maybe<Scalars['Boolean']>;
};

export type DismissOfferInput = {
  dismissReason: DismissReasonType;
  offerId: Scalars['UUID'];
};

/** An enumeration. */
export type DismissReasonType =
  | 'COVERAGE'
  | 'DISLIKED_CARRIER'
  | 'EFFORT'
  | 'EXPENSIVE'
  | 'OTHER'
  | 'UNKNOWN_CARRIER';

export type DocumentInput = {
  documentSize: Scalars['Int'];
  documentType: DocumentTypeType;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  urlFile: Scalars['String'];
};

/** An enumeration. */
export type DocumentTypeType =
  | 'DOCUMENT_BACK'
  | 'DOCUMENT_DEC'
  | 'DOCUMENT_FRONT'
  | 'DOCUMENT_ID'
  | 'DOCUMENT_OTHER';

/** An enumeration. */
export type DriverCurrentCoverageLevel =
  /** $25,000/$50,000 */
  | 'FIFTY'
  /** $250,000/$500,000 */
  | 'FIVE_HUNDRED'
  /** $50,000/$100,000 */
  | 'HUNDRED'
  /** Higher */
  | 'OVER_FIVE_HUNDRED'
  /** $100,000/$300,000 */
  | 'THREE_HUNDRED';

/** An enumeration. */
export type DriverCurrentPremiumPeriod =
  /** Monthly */
  | 'MONTH'
  /** 6 Months */
  | 'SIX_MONTHS'
  /** Yearly */
  | 'YEAR';

export type DriverInput = {
  accidents?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  adultsInAddress?: InputMaybe<Scalars['Int']>;
  ageFirstLicensed?: InputMaybe<Scalars['Int']>;
  careerStatus?: InputMaybe<CareerStatusType>;
  childrenInAddress?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  comprehensiveClaims?: InputMaybe<Scalars['Boolean']>;
  currentCoverageLevel?: InputMaybe<CurrentCoverageLevelType>;
  currentInsurance?: InputMaybe<Scalars['Boolean']>;
  currentInsurer?: InputMaybe<Scalars['String']>;
  currentOccupation?: InputMaybe<Scalars['String']>;
  currentPolicyExpiry?: InputMaybe<Scalars['Date']>;
  currentPremiumPeriod?: InputMaybe<CurrentPremiumPeriodType>;
  currentPremiumTotal?: InputMaybe<Scalars['Decimal']>;
  dob?: InputMaybe<Scalars['Date']>;
  driversLicenseNumber?: InputMaybe<Scalars['String']>;
  driversLicenseState?: InputMaybe<Scalars['UUID']>;
  dui?: InputMaybe<Scalars['Boolean']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<GenderType>;
  hasHighGpa?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  lastName?: InputMaybe<Scalars['String']>;
  lengthOfContinuousCoverage?: InputMaybe<ContinuousCoverageLengthType>;
  licenseStatus?: InputMaybe<LicenseStatusType>;
  maritalStatus?: InputMaybe<MaritalStatusType>;
  moveInDate?: InputMaybe<Scalars['Date']>;
  otherFamiliesInAddress?: InputMaybe<Scalars['Int']>;
  relationToMarbleMember?: InputMaybe<RelationShipToMarbleMemberType>;
  relationshipToPrimaryDriver?: InputMaybe<RelationshipToPrimaryType>;
  roommatesInAddress?: InputMaybe<Scalars['Int']>;
  sameAddressWithPrimary?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['UUID']>;
  tickets?: InputMaybe<Scalars['Boolean']>;
  usePrimaryAddress?: InputMaybe<Scalars['Boolean']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export type DriverLengthOfContinuousCoverage =
  /** 8 years */
  | 'EIGHT_YEARS'
  /** 5 years */
  | 'FIVE_YEARS'
  /** 4 years */
  | 'FOUR_YEARS'
  /** 9 years */
  | 'NINE_YEARS'
  /** 1 year */
  | 'ONE_YEAR'
  /** 11+ years */
  | 'OVER_TEN_YEARS'
  /** 7 years */
  | 'SEVEN_YEARS'
  /** 6 years */
  | 'SIX_YEARS'
  /** 10 years */
  | 'TEN_YEARS'
  /** 3 years */
  | 'THREE_YEARS'
  /** 2 years */
  | 'TWO_YEARS'
  /** 6-12 months */
  | 'UNDER_1Y'
  /** 0-6 months */
  | 'UNDER_6M';

/** An enumeration. */
export type DriverLicenseStatus =
  /** Cancelled */
  | 'CANCELLED'
  /** Expired */
  | 'EXPIRED'
  /** Not Licensed */
  | 'NOT_LICENSED'
  /** Permanently Revoked */
  | 'PERMANENTLY_REVOKED'
  /** Permit */
  | 'PERMIT'
  /** Suspended */
  | 'SUSPENDED'
  /** Valid */
  | 'VALID';

/** An enumeration. */
export type DriverRelationshipToPrimaryDriver =
  /** Child */
  | 'CHILD'
  /** Domestic Partner */
  | 'DOMESTIC_PARTNER'
  /** Other */
  | 'OTHER'
  /** Parent */
  | 'PARENT'
  /** Spouse */
  | 'SPOUSE';

export type DriverType = {
  __typename: 'DriverType';
  accidents?: Maybe<Scalars['Boolean']>;
  address?: Maybe<Scalars['String']>;
  adultsInAddress?: Maybe<Scalars['Int']>;
  ageFirstLicensed?: Maybe<Scalars['Int']>;
  aiqData?: Maybe<Scalars['Boolean']>;
  altNames?: Maybe<Array<Scalars['String']>>;
  autoPolicies: Array<AutoPolicyType>;
  careerStatus?: Maybe<NamedInsuredBaseCareerStatus>;
  childrenInAddress?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  comprehensiveClaims?: Maybe<Scalars['Boolean']>;
  created?: Maybe<Scalars['DateTime']>;
  currentCoverageLevel?: Maybe<DriverCurrentCoverageLevel>;
  currentInsurance?: Maybe<Scalars['Boolean']>;
  currentInsurer?: Maybe<Scalars['String']>;
  currentOccupation?: Maybe<Scalars['String']>;
  currentPolicyExpiry?: Maybe<Scalars['Date']>;
  currentPremiumPeriod?: Maybe<DriverCurrentPremiumPeriod>;
  currentPremiumTotal?: Maybe<Scalars['Float']>;
  dob?: Maybe<Scalars['Date']>;
  driversLicenseNumber?: Maybe<Scalars['String']>;
  driversLicenseState?: Maybe<StateType>;
  dui?: Maybe<Scalars['Boolean']>;
  educationLevel?: Maybe<NamedInsuredBaseEducationLevel>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<GenderType>;
  hasHighGpa?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  lastName?: Maybe<Scalars['String']>;
  lengthOfContinuousCoverage?: Maybe<DriverLengthOfContinuousCoverage>;
  licenseStatus?: Maybe<DriverLicenseStatus>;
  maritalStatus?: Maybe<NamedInsuredBaseMaritalStatus>;
  modified?: Maybe<Scalars['DateTime']>;
  moveInDate?: Maybe<Scalars['Date']>;
  name?: Maybe<Scalars['String']>;
  namedinsuredbasePtr: NamedInsuredReturnType;
  otherFamiliesInAddress?: Maybe<Scalars['Int']>;
  parentId?: Maybe<Scalars['UUID']>;
  primaryDriverVehicles: Array<VehicleType>;
  relationToMarbleMember?: Maybe<NamedInsuredBaseRelationToMarbleMember>;
  relationshipToPrimaryDriver?: Maybe<DriverRelationshipToPrimaryDriver>;
  roommatesInAddress?: Maybe<Scalars['Int']>;
  sameAddressWithPrimary?: Maybe<Scalars['Boolean']>;
  shoppingCarts: Array<ShoppingCartType>;
  state?: Maybe<StateType>;
  tickets?: Maybe<Scalars['Boolean']>;
  usePrimaryAddress?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserType>;
  vehicles: Array<VehicleType>;
  zipCode?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export type EducationLevelType =
  | 'DOCTORATE'
  | 'FOUR_YEAR_COLLEGE'
  | 'GRADUATE_DEGREE'
  | 'HIGH_SCHOOL'
  | 'LESS_THAN_HIGH_SCHOOL'
  | 'SOME_COLLEGE'
  | 'TWO_YEAR_COLLEGE'
  | 'VOCATIONAL';

export type EngagementCardActionInput = {
  actionTaken?: InputMaybe<Scalars['Boolean']>;
  booleanAnswer?: InputMaybe<Scalars['Boolean']>;
  choicesAnswer?: InputMaybe<Array<Scalars['UUID']>>;
  dateAnswer?: InputMaybe<Scalars['Date']>;
  engagementCardId: Scalars['UUID'];
  textAnswer?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export type EngagementCardActionType =
  | 'BOOLEAN_ANSWER'
  | 'DATE_ANSWER'
  | 'LINK'
  | 'MULTIPLE_CHOICE_ANSWER'
  | 'TEXT_ANSWER';

export type EngagementCardAnswerChoiceType = {
  __typename: 'EngagementCardAnswerChoiceType';
  id: Scalars['UUID'];
  order?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
};

export type EngagementCardType = {
  __typename: 'EngagementCardType';
  actionType: EngagementCardActionType;
  actionUrl?: Maybe<Scalars['String']>;
  answerChoices: Array<EngagementCardAnswerChoiceType>;
  created?: Maybe<Scalars['DateTime']>;
  /** This field is only used for link engagement cards */
  ctaCopy?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  id: Scalars['UUID'];
  /** Note: images should be 284px wide and saved as .webp */
  image?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  modified?: Maybe<Scalars['DateTime']>;
  questionText: Scalars['String'];
  rewardAmount?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['Date']>;
  userengagementcardactionSet: Array<UserEngagementCardActionType>;
};

export type ErrorType = {
  __typename: 'ErrorType';
  field: Scalars['String'];
  messages: Array<Scalars['String']>;
};

/** An enumeration. */
export type ExampleTypeType =
  | 'SIMPLE'
  | 'VIDEO';

export type FeatureItemType = {
  __typename: 'FeatureItemType';
  date?: Maybe<Scalars['Date']>;
  description: Scalars['String'];
  featureType: FeatureTypeType;
  featured: Scalars['Boolean'];
  id: Scalars['UUID'];
  image?: Maybe<Scalars['String']>;
  imageBgcolor?: Maybe<Scalars['String']>;
  read: Scalars['Boolean'];
  title: Scalars['String'];
};

export type FeatureToggleType = {
  __typename: 'FeatureToggleType';
  isEnabled: Scalars['Boolean'];
  /** One word in all caps without spaces */
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  siteConfig: SiteConfigurationType;
};

/** An enumeration. */
export type FeatureTypeType =
  | 'COMING_SOON'
  | 'WHATS_NEW';

/** An enumeration. */
export type FeedbackActionType =
  | 'II_RATING'
  | 'POLICY_SYNC'
  | 'REDEMPTION_COMPLETE';

export type FeedbackAnswerInput = {
  questionId: Scalars['UUID'];
  value: Scalars['Int'];
};

export type FeedbackQuestionType = {
  __typename: 'FeedbackQuestionType';
  action?: Maybe<FeedbackActionType>;
  feedbackType: FeedbackTypeType;
  id: Scalars['UUID'];
  /** Path where the question should show (e.g. /insurance-insider) */
  pagePath: Scalars['String'];
  questionText: Scalars['String'];
};

/** An enumeration. */
export type FeedbackTypeType =
  | 'CES'
  | 'CSAT'
  | 'NPS';

export type FinalizeQuote = {
  __typename: 'FinalizeQuote';
  ok?: Maybe<Scalars['Boolean']>;
};

export type FinalizeQuoteInput = {
  method: MethodType;
  offerId: Scalars['UUID'];
  phone?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export type FoundationType =
  | 'BASEMENT'
  | 'BLOCK'
  | 'BLOCK_UNSPECIFIED'
  | 'BRICK'
  | 'BRICK_UNSPECIFIED'
  | 'CLOSED_PIERS'
  | 'CONCRETE'
  | 'CONCRETE_BEAM'
  | 'CONCRETE_BEAM_SLAB'
  | 'CONCRETE_BLOCK'
  | 'CONTINUOUS_FOOTING'
  | 'CONTINUOUS_WALL'
  | 'CROSS_BRIDGED_WALLS'
  | 'DIRT_EARTH'
  | 'FOOTING'
  | 'FOOTING_CONTINUOUS_STRIP'
  | 'FOOTING_SPREAD'
  | 'GRADE_BEAM'
  | 'MASONRY'
  | 'MASONRY_UNSPECIFIED'
  | 'MAT_RAFT_FOUNDATION'
  | 'MUD_SILL'
  | 'NONE'
  | 'NOT_STATED'
  | 'NO_FOUNDATION'
  | 'NP'
  | 'OPEN_PIERS'
  | 'PIER'
  | 'PIER_POST_BEAM'
  | 'PIER_POST_CONCRETE'
  | 'PIER_POST_WOOD'
  | 'PILE'
  | 'PILE_CONCRETE'
  | 'PILE_END_BEARING'
  | 'PILE_FRICTION'
  | 'PILE_WOOD_TIMBER'
  | 'PILINGS'
  | 'PIPE_IRON'
  | 'PRE_FAB'
  | 'RAISED'
  | 'RAISED_BASEMENT'
  | 'RAISED_CRAWLSPACE'
  | 'RAISED_UNSPECIFIED'
  | 'RETAINING_WALL'
  | 'SLAB'
  | 'SPREAD_FOOTING'
  | 'STANDARD'
  | 'STEEL'
  | 'STEM_WALL'
  | 'STEM_WALL_CRAWLSPACE'
  | 'STONE'
  | 'STONE_UNSPECIFIED'
  | 'TYPE_NOT_SPECIFIED'
  | 'TYPE_UNKNOWN'
  | 'TYPE_UNKNOWN_BASEMENT'
  | 'TYPE_UNKNOWN_CRAWLSPACE'
  | 'TYPE_UNKNOWN_PART_BASEMENT'
  | 'UNAVAILABLE'
  | 'UNKNOWN'
  | 'WOOD'
  | 'WOOD_UNSPECIFIED';

/** An enumeration. */
export type GenderType =
  | 'FEMALE'
  | 'MALE'
  | 'OTHER';

export type HealthCarrierType = {
  __typename: 'HealthCarrierType';
  categories?: Maybe<Array<Maybe<HealthCategoryType>>>;
  claimUrl?: Maybe<Scalars['String']>;
  contactUrl?: Maybe<Scalars['String']>;
  dentalPlanNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  healthPlanNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['UUID'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  visionPlanNames?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** An enumeration. */
export type HealthCategoryType =
  | 'DENTAL'
  | 'HEALTH'
  | 'VISION';

export type HealthInsuredType = {
  __typename: 'HealthInsuredType';
  address?: Maybe<Scalars['String']>;
  aiqData?: Maybe<Scalars['Boolean']>;
  altNames?: Maybe<Array<Scalars['String']>>;
  careerStatus?: Maybe<NamedInsuredBaseCareerStatus>;
  city?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  dob?: Maybe<Scalars['Date']>;
  driversLicenseNumber?: Maybe<Scalars['String']>;
  driversLicenseState?: Maybe<StateType>;
  educationLevel?: Maybe<NamedInsuredBaseEducationLevel>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<NamedInsuredBaseGender>;
  id: Scalars['UUID'];
  lastName?: Maybe<Scalars['String']>;
  maritalStatus?: Maybe<NamedInsuredBaseMaritalStatus>;
  modified?: Maybe<Scalars['DateTime']>;
  namedInsureds: Array<HealthPolicyType>;
  namedinsuredbasePtr: NamedInsuredReturnType;
  parentId?: Maybe<Scalars['UUID']>;
  relationToMarbleMember?: Maybe<NamedInsuredBaseRelationToMarbleMember>;
  state?: Maybe<StateType>;
  usePrimaryAddress?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserType>;
  zipCode?: Maybe<Scalars['String']>;
};

export type HealthNamedInsuredInput = {
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  lastName: Scalars['String'];
};

export type HealthPolicyInput = {
  carrierId: Scalars['UUID'];
  category: HealthCategoryType;
  documents?: InputMaybe<Array<InputMaybe<DocumentInput>>>;
  groupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  memberId?: InputMaybe<Scalars['String']>;
  namedInsureds?: InputMaybe<Array<InputMaybe<HealthNamedInsuredInput>>>;
  planName: Scalars['String'];
};

export type HealthPolicyType = {
  __typename: 'HealthPolicyType';
  archiveDate?: Maybe<Scalars['DateTime']>;
  carrier: HealthCarrierType;
  category?: Maybe<HealthCategoryType>;
  documents?: Maybe<Array<PolicyDocumentType>>;
  groupId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  memberId?: Maybe<Scalars['String']>;
  namedInsureds: Array<HealthInsuredType>;
  planName: Scalars['String'];
};

/** An enumeration. */
export type HomeCategoryType =
  | 'HOME'
  | 'RENTER';

/** An enumeration. */
export type HomeDeductibleLimitType =
  | 'A_1PERCENT'
  | 'A_1SLASH2PERCENT'
  | 'A_100'
  | 'A_250'
  | 'A_500'
  | 'A_750'
  | 'A_1000'
  | 'A_2000'
  | 'A_2500'
  | 'A_3000'
  | 'A_4000'
  | 'A_5000';

export type HomeOwnerInput = {
  address?: InputMaybe<Scalars['String']>;
  careerStatus?: InputMaybe<CareerStatusType>;
  city?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['Date']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<GenderType>;
  id?: InputMaybe<Scalars['UUID']>;
  lastName?: InputMaybe<Scalars['String']>;
  maritalStatus?: InputMaybe<MaritalStatusType>;
  relationToMarbleMember?: InputMaybe<RelationShipToMarbleMemberType>;
  relationshipToPrimaryOwner?: InputMaybe<RelationshipToPrimaryType>;
  state?: InputMaybe<Scalars['UUID']>;
  usePrimaryAddress?: InputMaybe<Scalars['Boolean']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export type HomeOwnerRelationshipToPrimaryOwner =
  /** Child */
  | 'CHILD'
  /** Domestic Partner */
  | 'DOMESTIC_PARTNER'
  /** Other */
  | 'OTHER'
  /** Parent */
  | 'PARENT'
  /** Spouse */
  | 'SPOUSE';

export type HomeOwnerType = {
  __typename: 'HomeOwnerType';
  address?: Maybe<Scalars['String']>;
  aiqData?: Maybe<Scalars['Boolean']>;
  altNames?: Maybe<Array<Scalars['String']>>;
  careerStatus?: Maybe<NamedInsuredBaseCareerStatus>;
  city?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  dob?: Maybe<Scalars['Date']>;
  driversLicenseNumber?: Maybe<Scalars['String']>;
  driversLicenseState?: Maybe<StateType>;
  educationLevel?: Maybe<NamedInsuredBaseEducationLevel>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<GenderType>;
  homeOwnerPolicies: Array<HomePolicyType>;
  id: Scalars['UUID'];
  lastName?: Maybe<Scalars['String']>;
  maritalStatus?: Maybe<NamedInsuredBaseMaritalStatus>;
  modified?: Maybe<Scalars['DateTime']>;
  namedinsuredbasePtr: NamedInsuredReturnType;
  parentId?: Maybe<Scalars['UUID']>;
  relationToMarbleMember?: Maybe<NamedInsuredBaseRelationToMarbleMember>;
  relationshipToPrimaryOwner?: Maybe<HomeOwnerRelationshipToPrimaryOwner>;
  shoppingCarts: Array<ShoppingCartType>;
  state?: Maybe<StateType>;
  usePrimaryAddress?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserType>;
  zipCode?: Maybe<Scalars['String']>;
};

export type HomePolicyType = {
  __typename: 'HomePolicyType';
  address?: Maybe<Scalars['String']>;
  archiveDate?: Maybe<Scalars['DateTime']>;
  basicSyncFailed: Scalars['Boolean'];
  canopyEmbeddedCarrier?: Maybe<Scalars['String']>;
  carrier?: Maybe<CarrierType>;
  category?: Maybe<CategoryType>;
  continuous: Scalars['Boolean'];
  coverageSynced: Scalars['Boolean'];
  deductible?: Maybe<Scalars['Float']>;
  deductibleWind?: Maybe<Scalars['Float']>;
  documents?: Maybe<Array<PolicyDocumentType>>;
  dwelling?: Maybe<Scalars['Float']>;
  endDate?: Maybe<Scalars['Date']>;
  fees?: Maybe<Scalars['Float']>;
  historyId?: Maybe<Scalars['UUID']>;
  homeOwners: Array<HomeOwnerType>;
  id: Scalars['UUID'];
  isOnRenewal?: Maybe<Scalars['Boolean']>;
  isPolicyOwner?: Maybe<Scalars['Boolean']>;
  lossUse?: Maybe<Scalars['Float']>;
  medicalOthers?: Maybe<Scalars['Float']>;
  namedInsured?: Maybe<Array<Scalars['String']>>;
  nextPaymentDue?: Maybe<Scalars['Date']>;
  otherStructures?: Maybe<Scalars['Float']>;
  personalLiability?: Maybe<Scalars['Float']>;
  personalProperty?: Maybe<Scalars['Float']>;
  policyHistory?: Maybe<Array<PolicyHistoryType>>;
  policyNumber?: Maybe<Scalars['String']>;
  policyPremium?: Maybe<Scalars['Float']>;
  premiumPeriod?: Maybe<PremiumPeriodType>;
  properties: Array<PropertyType>;
  shareableId?: Maybe<Scalars['UUID']>;
  sharedAccess?: Maybe<Array<SharedAccessType>>;
  showSyncAnimation: Scalars['Boolean'];
  startDate?: Maybe<Scalars['Date']>;
  syncFailureReason?: Maybe<SyncFailureReasonType>;
  synced: Scalars['Boolean'];
  total?: Maybe<Scalars['Float']>;
  user: UserType;
  wrongDocumentType?: Maybe<WrongDocumentTypeType>;
};

export type ImpressionGroupType = {
  __typename: 'ImpressionGroupType';
  created?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  /** Example: AUTO,HOME,RENTER,PET,LIFE,OTHER */
  insuranceTypes: Array<Scalars['String']>;
  isActive: Scalars['Boolean'];
  /** Number of impressions shown in this group */
  limitPlacements?: Maybe<Scalars['Int']>;
  modified?: Maybe<Scalars['DateTime']>;
  /** If 1, this group would be shown first, if 2, second and so on */
  orderNumber?: Maybe<Scalars['Int']>;
  tags: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type ImpressionType = {
  __typename: 'ImpressionType';
  addressQueryParam?: Maybe<Scalars['String']>;
  bid?: Maybe<Scalars['Float']>;
  carrier?: Maybe<Scalars['String']>;
  clickUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  emailQueryParam?: Maybe<Scalars['String']>;
  fnameQueryParam?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  image?: Maybe<Scalars['String']>;
  imprHtml?: Maybe<Scalars['String']>;
  insuranceTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  integrator?: Maybe<Scalars['String']>;
  integratorDescription?: Maybe<Scalars['String']>;
  integratorHeadline?: Maybe<Scalars['String']>;
  lnameQueryParam?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  staticBid?: Maybe<Scalars['Float']>;
  staticUrl?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  zipQueryParam?: Maybe<Scalars['String']>;
};

export type InactivateAccount = {
  __typename: 'InactivateAccount';
  ok?: Maybe<Scalars['Boolean']>;
};

export type InsuranceInsiderComparisonEmail = {
  __typename: 'InsuranceInsiderComparisonEmail';
  ok?: Maybe<Scalars['Boolean']>;
};

export type InsuranceInsiderComparisonInput = {
  carrier: Scalars['String'];
  compare?: InputMaybe<Scalars['String']>;
  recipientEmail: Scalars['String'];
  recipientName: Scalars['String'];
  senderEmail?: InputMaybe<Scalars['String']>;
  senderName?: InputMaybe<Scalars['String']>;
};

export type LeadGenEmailOnlyInput = {
  email: Scalars['String'];
  utmCampaign: Scalars['String'];
  utmMedium: Scalars['String'];
  utmSource: Scalars['String'];
};

/** An enumeration. */
export type LicenseStatusType =
  | 'CANCELLED'
  | 'EXPIRED'
  | 'NOT_LICENSED'
  | 'PERMANENTLY_REVOKED'
  | 'PERMIT'
  | 'SUSPENDED'
  | 'VALID';

export type LifeInsuredInput = {
  dob?: InputMaybe<Scalars['Date']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  gender?: InputMaybe<GenderType>;
  id?: InputMaybe<Scalars['UUID']>;
  maritalStatus?: InputMaybe<MaritalStatusType>;
  relationToMarbleMember?: InputMaybe<RelationShipToMarbleMemberType>;
};

export type LifeInsuredType = {
  __typename: 'LifeInsuredType';
  address?: Maybe<Scalars['String']>;
  aiqData?: Maybe<Scalars['Boolean']>;
  altNames?: Maybe<Array<Scalars['String']>>;
  careerStatus?: Maybe<NamedInsuredBaseCareerStatus>;
  city?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  dob?: Maybe<Scalars['Date']>;
  driversLicenseNumber?: Maybe<Scalars['String']>;
  driversLicenseState?: Maybe<StateType>;
  educationLevel?: Maybe<NamedInsuredBaseEducationLevel>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<GenderType>;
  id: Scalars['UUID'];
  lastName?: Maybe<Scalars['String']>;
  lifeInsuredPolicies: Array<LifePolicyType>;
  maritalStatus?: Maybe<NamedInsuredBaseMaritalStatus>;
  modified?: Maybe<Scalars['DateTime']>;
  namedinsuredbasePtr: NamedInsuredReturnType;
  parentId?: Maybe<Scalars['UUID']>;
  primary: Scalars['Boolean'];
  relationToMarbleMember?: Maybe<NamedInsuredBaseRelationToMarbleMember>;
  state?: Maybe<StateType>;
  usePrimaryAddress?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserType>;
  zipCode?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export type LifePolicyPlanType =
  | 'PLAN_10YEAR_TERM_LIFE'
  | 'PLAN_15YEAR_TERM_LIFE'
  | 'PLAN_20YEAR_TERM_LIFE'
  | 'PLAN_25YEAR_TERM_LIFE'
  | 'PLAN_30YEAR_TERM_LIFE'
  | 'PLAN_TERM_OTHER'
  | 'PLAN_UNIVERSAL_LIFE'
  | 'PLAN_WHOLE_LIFE';

export type LifePolicyType = {
  __typename: 'LifePolicyType';
  address?: Maybe<Scalars['String']>;
  archiveDate?: Maybe<Scalars['DateTime']>;
  basicSyncFailed: Scalars['Boolean'];
  beneficiaries: Array<BeneficiaryType>;
  canopyEmbeddedCarrier?: Maybe<Scalars['String']>;
  carrier?: Maybe<CarrierType>;
  cashValue?: Maybe<Scalars['Float']>;
  category?: Maybe<CategoryType>;
  continuous: Scalars['Boolean'];
  conversionDate?: Maybe<Scalars['Date']>;
  coverageSynced: Scalars['Boolean'];
  deathBenefit?: Maybe<Scalars['Float']>;
  documents?: Maybe<Array<PolicyDocumentType>>;
  endDate?: Maybe<Scalars['Date']>;
  fees?: Maybe<Scalars['Float']>;
  groupPolicyBenefit?: Maybe<Scalars['String']>;
  groupPolicyName?: Maybe<Scalars['String']>;
  groupPolicyNumber?: Maybe<Scalars['String']>;
  historyId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  isGroup: Scalars['Boolean'];
  isOnRenewal?: Maybe<Scalars['Boolean']>;
  isPolicyOwner?: Maybe<Scalars['Boolean']>;
  lifeInsureds: Array<LifeInsuredType>;
  namedInsured?: Maybe<Array<Scalars['String']>>;
  nextPaymentDue?: Maybe<Scalars['Date']>;
  otherTermYears?: Maybe<Scalars['Int']>;
  planType?: Maybe<LifePolicyPlanType>;
  policyHistory?: Maybe<Array<PolicyHistoryType>>;
  policyNumber?: Maybe<Scalars['String']>;
  policyPremium?: Maybe<Scalars['Float']>;
  premiumPeriod?: Maybe<PremiumPeriodType>;
  riders?: Maybe<Scalars['String']>;
  shareableId?: Maybe<Scalars['UUID']>;
  sharedAccess?: Maybe<Array<SharedAccessType>>;
  showSyncAnimation: Scalars['Boolean'];
  startDate?: Maybe<Scalars['Date']>;
  syncFailureReason?: Maybe<SyncFailureReasonType>;
  synced: Scalars['Boolean'];
  total?: Maybe<Scalars['Float']>;
  user: UserType;
  wrongDocumentType?: Maybe<WrongDocumentTypeType>;
};

export type LoginInput = {
  captchaValue?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
  source?: InputMaybe<SourceType>;
};

/** An enumeration. */
export type MaritalStatusType =
  | 'DIVORCED'
  | 'DOMESTIC_PARTNER'
  | 'MARRIED'
  | 'SEPARATED'
  | 'SINGLE'
  | 'WIDOWED';

export type MarketingLandingDataType = {
  __typename: 'MarketingLandingDataType';
  commonData: CommonLandingDataType;
  commonLandingConfig?: Maybe<CommonLandingDataType>;
  created?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  metadata?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  pageType: PageTypeType;
  partnerLogo?: Maybe<Scalars['String']>;
  partnerSlug: Scalars['String'];
  popupCta?: Maybe<Scalars['String']>;
  popupRedirect?: Maybe<Scalars['String']>;
  popupSubtitle?: Maybe<Scalars['String']>;
  popupTitle?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type MergeNamedInsuredsInput = {
  firstNamedInsuredId: Scalars['UUID'];
  secondNamedInsuredId: Scalars['UUID'];
};

/** An enumeration. */
export type MethodType =
  | 'CALL'
  | 'EMAIL'
  | 'TEXT';

export type Mutation = {
  __typename: 'Mutation';
  acceptSharedAccess?: Maybe<AcceptSharedAccess>;
  addEngagementCardAction?: Maybe<AddEngagementCardAction>;
  answerFeedbackQuestion?: Maybe<AnswerFeedbackQuestion>;
  archiveHealthPolicy?: Maybe<ArchiveHealthPolicy>;
  archivePolicy?: Maybe<Scalars['Boolean']>;
  archiveShoppingCart?: Maybe<ArchiveShoppingCart>;
  authorizePaymentDisplay?: Maybe<AuthorizePaymentDisplay>;
  biometricsDeletePublicKey?: Maybe<BiometricsDeletePublicKey>;
  biometricsLogin?: Maybe<UserType>;
  biometricsUpdatePublicKey?: Maybe<BiometricsUpdatePublicKey>;
  canopyConsent?: Maybe<CanopyConnectResponseType>;
  canopyMfaAnswer?: Maybe<CanopyMfaAnswer>;
  canopyMfaOption?: Maybe<CanopyMfaOption>;
  canopyReconnect?: Maybe<CanopyReconnect>;
  changePassword?: Maybe<UserType>;
  confirmLegalName?: Maybe<ConfirmLegalName>;
  createCarrierReview?: Maybe<CreateCarrierReview>;
  createHealthPolicy?: Maybe<HealthPolicyType>;
  createHealthPolicyDocument?: Maybe<HealthPolicyType>;
  createHomeFromAddress?: Maybe<PropertyOrRentalAddressType>;
  createLeadEmailOnly?: Maybe<CreateLeadGenEmailOnly>;
  createOrUpdateNamedInsured?: Maybe<NamedInsuredReturnType>;
  createOrUpdateRenewalOffer?: Maybe<CreateOrUpdateRenewalOffer>;
  createReminder?: Maybe<ReminderType>;
  createSamsungWalletCard?: Maybe<SamsungWalletType>;
  createShareableId?: Maybe<CreateShareableId>;
  createSharedAccess?: Maybe<SharedAccessType>;
  createShoppingCart?: Maybe<ShoppingCartType>;
  createShoppingCartFromDb?: Maybe<ShoppingCartType>;
  createShoppingCartFromShopFlow?: Maybe<ShoppingCartType>;
  createUserCarrier?: Maybe<PolicyUnionType>;
  createVehicleFromDetails?: Maybe<VehicleType>;
  createVehicleFromVin?: Maybe<VehicleType>;
  createViuLead?: Maybe<NotifyViu>;
  deleteDocument?: Maybe<DeletePolicyDocument>;
  deleteOtherPolicy?: Maybe<DeleteOtherPolicy>;
  deleteReminder?: Maybe<DeleteReminder>;
  discardReward?: Maybe<DiscardReward>;
  dismissOffer?: Maybe<DismissOffer>;
  driver?: Maybe<DriverType>;
  emailReferralLink?: Maybe<ReferralEmail>;
  finalizeQuote?: Maybe<FinalizeQuote>;
  /** If The Zebra offer does not have a link, call the Prepop API to get it. */
  getTzPrepopLink?: Maybe<OfferType>;
  getUploadUrl?: Maybe<CreateLink>;
  homeOwner?: Maybe<HomeOwnerType>;
  inactivateAccount?: Maybe<InactivateAccount>;
  lifeInsured?: Maybe<LifeInsuredType>;
  login?: Maybe<UserType>;
  markPolicySyncAnimationShown?: Maybe<PolicyUnionType>;
  mergeNamedInsureds?: Maybe<Array<Maybe<NamedInsuredType>>>;
  nfpSelectQuote?: Maybe<NotifyNfp>;
  pet?: Maybe<PetType>;
  petOwner?: Maybe<PetOwnerType>;
  postAgentContact?: Maybe<PostAgentContact>;
  property?: Maybe<PropertyType>;
  readAllFeatureItems?: Maybe<ReadAllFeatureItems>;
  readFeatureItem?: Maybe<ReadFeatureItem>;
  register?: Maybe<UserType>;
  removeDriver?: Maybe<RemoveDriver>;
  removeHomeOwner?: Maybe<RemoveHomeOwner>;
  removePet?: Maybe<RemovePetAsset>;
  removePetOwner?: Maybe<RemovePetOwner>;
  removeProperty?: Maybe<RemovePropertyAsset>;
  removeRental?: Maybe<RemoveRentalAsset>;
  removeRenter?: Maybe<RemoveRenter>;
  removeShareableId?: Maybe<RemoveShareableId>;
  removeSharedAccess?: Maybe<RemoveSharedAccess>;
  removeVehicle?: Maybe<RemoveVehicleAsset>;
  renameDocument?: Maybe<PolicyDocumentType>;
  rental?: Maybe<RentalType>;
  renter?: Maybe<RenterType>;
  requestPhoneVerification?: Maybe<RequestPhoneVerificationCode>;
  requestQuoteInfo?: Maybe<RequestQuoteInfo>;
  requestRedemption?: Maybe<RedemptionRequestType>;
  requestResetPassword?: Maybe<ResetPasswordPayload>;
  resetPassword?: Maybe<Scalars['Boolean']>;
  restoreOffer?: Maybe<RestoreOffer>;
  savePaymentToken?: Maybe<SavePaymentToken>;
  saveShopFlowProgress?: Maybe<SaveShopFlowProgress>;
  sendComparisonEmail?: Maybe<InsuranceInsiderComparisonEmail>;
  setPasswordShopFlow?: Maybe<UserType>;
  shopFirstUser?: Maybe<ShopUserProfileType>;
  socialLogin?: Maybe<UserType>;
  splitNamedInsureds?: Maybe<Array<Maybe<NamedInsuredType>>>;
  textMe?: Maybe<TextMe>;
  textReferralLink?: Maybe<ReferralText>;
  updateNamedInsured?: Maybe<NamedInsuredType>;
  updateSavedOffer?: Maybe<UpdateSavedOffer>;
  updateShopFormPath?: Maybe<ShopFormPath>;
  updateVehicleDrivers?: Maybe<VehicleType>;
  uploadOtherPolicyDocument?: Maybe<OtherPolicyType>;
  uploadPolicyDocument?: Maybe<PolicyUnionType>;
  user?: Maybe<UserType>;
  validatePhoneVerification?: Maybe<ValidatePhoneVerificationCode>;
  validateResetToken?: Maybe<Scalars['Boolean']>;
  vehicle?: Maybe<VehicleType>;
};


export type MutationAcceptSharedAccessArgs = {
  sharedAccessId: Scalars['UUID'];
};


export type MutationAddEngagementCardActionArgs = {
  input: EngagementCardActionInput;
};


export type MutationAnswerFeedbackQuestionArgs = {
  input: FeedbackAnswerInput;
};


export type MutationArchiveHealthPolicyArgs = {
  id: Scalars['UUID'];
};


export type MutationArchivePolicyArgs = {
  input: ArchivePolicyInput;
};


export type MutationArchiveShoppingCartArgs = {
  archiveReason: ArchiveShoppingCartType;
  id: Scalars['UUID'];
};


export type MutationAuthorizePaymentDisplayArgs = {
  input: AuthorizePaymentDisplayInput;
};


export type MutationBiometricsLoginArgs = {
  input: BiometricsLoginInput;
};


export type MutationBiometricsUpdatePublicKeyArgs = {
  publicKey: Scalars['String'];
};


export type MutationCanopyConsentArgs = {
  input: CanopyConsentInput;
};


export type MutationCanopyMfaAnswerArgs = {
  input: CanopyMfaAnswerInput;
};


export type MutationCanopyMfaOptionArgs = {
  input: CanopyMfaOptionInput;
};


export type MutationCanopyReconnectArgs = {
  input: CanopyAuthInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationConfirmLegalNameArgs = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};


export type MutationCreateCarrierReviewArgs = {
  input: CarrierReviewInput;
};


export type MutationCreateHealthPolicyArgs = {
  input: HealthPolicyInput;
};


export type MutationCreateHealthPolicyDocumentArgs = {
  input: UploadHealthPolicyDocumentsInput;
};


export type MutationCreateHomeFromAddressArgs = {
  input: PropertyOrRentalAddressInput;
};


export type MutationCreateLeadEmailOnlyArgs = {
  input: LeadGenEmailOnlyInput;
};


export type MutationCreateOrUpdateNamedInsuredArgs = {
  input: CreateOrUpdateNamedInsuredInput;
};


export type MutationCreateOrUpdateRenewalOfferArgs = {
  input: RenewalOfferInput;
};


export type MutationCreateReminderArgs = {
  input: CreateReminderInput;
};


export type MutationCreateSamsungWalletCardArgs = {
  policyId: Scalars['UUID'];
};


export type MutationCreateShareableIdArgs = {
  policyId: Scalars['UUID'];
};


export type MutationCreateSharedAccessArgs = {
  input: SharedAccessInput;
};


export type MutationCreateShoppingCartArgs = {
  input: ShoppingCartInput;
};


export type MutationCreateShoppingCartFromDbArgs = {
  input: ShoppingCartDbInput;
};


export type MutationCreateShoppingCartFromShopFlowArgs = {
  input: ShoppingCartShopFlowInput;
};


export type MutationCreateUserCarrierArgs = {
  input: UserCarrierInput;
};


export type MutationCreateVehicleFromDetailsArgs = {
  input: VehicleAssetDetailInput;
};


export type MutationCreateVehicleFromVinArgs = {
  input: VehicleAssetVinInput;
};


export type MutationCreateViuLeadArgs = {
  offerId: Scalars['UUID'];
};


export type MutationDeleteDocumentArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteOtherPolicyArgs = {
  input: OtherPolicyDeleteInput;
};


export type MutationDeleteReminderArgs = {
  id: Scalars['UUID'];
};


export type MutationDiscardRewardArgs = {
  id: Scalars['UUID'];
};


export type MutationDismissOfferArgs = {
  input: DismissOfferInput;
};


export type MutationDriverArgs = {
  input: DriverInput;
};


export type MutationEmailReferralLinkArgs = {
  input: ReferralEmailInput;
};


export type MutationFinalizeQuoteArgs = {
  input: FinalizeQuoteInput;
};


export type MutationGetTzPrepopLinkArgs = {
  offerId: Scalars['UUID'];
};


export type MutationGetUploadUrlArgs = {
  input: UploadInput;
};


export type MutationHomeOwnerArgs = {
  input: HomeOwnerInput;
};


export type MutationLifeInsuredArgs = {
  input: LifeInsuredInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationMarkPolicySyncAnimationShownArgs = {
  id: Scalars['UUID'];
};


export type MutationMergeNamedInsuredsArgs = {
  input: MergeNamedInsuredsInput;
};


export type MutationNfpSelectQuoteArgs = {
  offerId: Scalars['String'];
};


export type MutationPetArgs = {
  input: PetAssetInput;
};


export type MutationPetOwnerArgs = {
  input: PetOwnerInput;
};


export type MutationPostAgentContactArgs = {
  quoteGid: Scalars['String'];
};


export type MutationPropertyArgs = {
  input: PropertyAssetInput;
};


export type MutationReadFeatureItemArgs = {
  featureId: Scalars['UUID'];
};


export type MutationRegisterArgs = {
  input: RegisterInput;
};


export type MutationRemoveDriverArgs = {
  input: RemoveDriverInput;
};


export type MutationRemoveHomeOwnerArgs = {
  input: RemoveHomeOwnerInput;
};


export type MutationRemovePetArgs = {
  input: RemovePetAssetInput;
};


export type MutationRemovePetOwnerArgs = {
  input: RemovePetOwnerInput;
};


export type MutationRemovePropertyArgs = {
  input: RemovePropertyAssetInput;
};


export type MutationRemoveRentalArgs = {
  input: RemoveRentalAssetInput;
};


export type MutationRemoveRenterArgs = {
  input: RemoveRenterInput;
};


export type MutationRemoveShareableIdArgs = {
  policyId: Scalars['UUID'];
};


export type MutationRemoveSharedAccessArgs = {
  policyId?: InputMaybe<Scalars['UUID']>;
  sharedAccessId?: InputMaybe<Scalars['UUID']>;
};


export type MutationRemoveVehicleArgs = {
  input: RemoveVehicleAssetInput;
};


export type MutationRenameDocumentArgs = {
  input: RenameDocumentInput;
};


export type MutationRentalArgs = {
  input: RentalAssetInput;
};


export type MutationRenterArgs = {
  input: RenterInput;
};


export type MutationRequestPhoneVerificationArgs = {
  phone: Scalars['String'];
};


export type MutationRequestQuoteInfoArgs = {
  input: RequestQuoteInfoInput;
};


export type MutationRequestRedemptionArgs = {
  input: RedemptionRequestInput;
};


export type MutationRequestResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResetPasswordArgs = {
  input: SetPasswordInput;
};


export type MutationRestoreOfferArgs = {
  id: Scalars['UUID'];
};


export type MutationSavePaymentTokenArgs = {
  offerId: Scalars['UUID'];
  paymentTokenId: Scalars['UUID'];
};


export type MutationSaveShopFlowProgressArgs = {
  returnLink: Scalars['String'];
};


export type MutationSendComparisonEmailArgs = {
  input: InsuranceInsiderComparisonInput;
};


export type MutationSetPasswordShopFlowArgs = {
  input: ShopSetPasswordInput;
};


export type MutationShopFirstUserArgs = {
  input: ShopUserInput;
};


export type MutationSocialLoginArgs = {
  input: SocialLoginInput;
};


export type MutationSplitNamedInsuredsArgs = {
  input: SplitNamedInsuredsInput;
};


export type MutationTextMeArgs = {
  input?: InputMaybe<TextMeInput>;
};


export type MutationTextReferralLinkArgs = {
  input?: InputMaybe<ReferralTextInput>;
};


export type MutationUpdateNamedInsuredArgs = {
  input: UpdateNamedInsuredInput;
};


export type MutationUpdateSavedOfferArgs = {
  id: Scalars['UUID'];
};


export type MutationUpdateShopFormPathArgs = {
  path: Scalars['String'];
};


export type MutationUpdateVehicleDriversArgs = {
  input: VehicleDriversInput;
};


export type MutationUploadOtherPolicyDocumentArgs = {
  input: UploadOtherPolicyDocumentsInput;
};


export type MutationUploadPolicyDocumentArgs = {
  input: UploadPolicyDocumentsInput;
};


export type MutationUserArgs = {
  input: ProfileInput;
};


export type MutationValidatePhoneVerificationArgs = {
  code: Scalars['Int'];
};


export type MutationValidateResetTokenArgs = {
  input: ValidateResetTokenInput;
};


export type MutationVehicleArgs = {
  input: VehicleAssetInput;
};

/** An enumeration. */
export type NamedInsuredBaseCareerStatus =
  /** Disabled */
  | 'DISABLED'
  /** Employed */
  | 'EMPLOYED'
  /** Retired */
  | 'RETIRED'
  /** Full-time Student */
  | 'STUDENT'
  /** Unemployed */
  | 'UNEMPLOYED';

/** An enumeration. */
export type NamedInsuredBaseEducationLevel =
  /** Doctorate */
  | 'DOCTORATE'
  /** 4 Year College */
  | 'FOUR_YEAR_COLLEGE'
  /** Graduate Degree */
  | 'GRADUATE_DEGREE'
  /** High School */
  | 'HIGH_SCHOOL'
  /** Less than High School */
  | 'LESS_THAN_HIGH_SCHOOL'
  /** Some College */
  | 'SOME_COLLEGE'
  /** 2 Year College */
  | 'TWO_YEAR_COLLEGE'
  /** Vocational/Tech */
  | 'VOCATIONAL';

/** An enumeration. */
export type NamedInsuredBaseGender =
  /** Female */
  | 'FEMALE'
  /** Male */
  | 'MALE'
  /** Other */
  | 'OTHER';

/** An enumeration. */
export type NamedInsuredBaseMaritalStatus =
  /** Divorced */
  | 'DIVORCED'
  /** Domestic Partner */
  | 'DOMESTIC_PARTNER'
  /** Married */
  | 'MARRIED'
  /** Separated */
  | 'SEPARATED'
  /** Single */
  | 'SINGLE'
  /** Widowed */
  | 'WIDOWED';

/** An enumeration. */
export type NamedInsuredBaseRelationToMarbleMember =
  /** Child */
  | 'CHILD'
  /** Domestic Partner */
  | 'DOMESTIC_PARTNER'
  /** Other */
  | 'OTHER'
  /** Parent */
  | 'PARENT'
  /** Roommate */
  | 'ROOMMATE'
  /** Self */
  | 'SELF'
  /** Spouse */
  | 'SPOUSE';

export type NamedInsuredReturnType = {
  __typename: 'NamedInsuredReturnType';
  dob?: Maybe<Scalars['Date']>;
  educationLevel?: Maybe<NamedInsuredBaseEducationLevel>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<NamedInsuredBaseGender>;
  id: Scalars['UUID'];
  lastName?: Maybe<Scalars['String']>;
  maritalStatus?: Maybe<NamedInsuredBaseMaritalStatus>;
  name?: Maybe<Scalars['String']>;
  relationToMarbleMember?: Maybe<NamedInsuredBaseRelationToMarbleMember>;
};

export type NamedInsuredType = {
  __typename: 'NamedInsuredType';
  altNames?: Maybe<Array<Scalars['String']>>;
  dob?: Maybe<Scalars['Date']>;
  driversLicenseNumber?: Maybe<Scalars['String']>;
  driversLicenseState?: Maybe<StateType>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<NamedInsuredBaseGender>;
  id: Scalars['UUID'];
  lastName?: Maybe<Scalars['String']>;
  namedType?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['UUID']>;
  relationToMarbleMember?: Maybe<NamedInsuredBaseRelationToMarbleMember>;
};

export type NotifyNfp = {
  __typename: 'NotifyNFP';
  ok?: Maybe<Scalars['Boolean']>;
};

export type NotifyViu = {
  __typename: 'NotifyVIU';
  ok?: Maybe<Scalars['Boolean']>;
};

export type OfferCoverageComparisonDataDictType = {
  __typename: 'OfferCoverageComparisonDataDictType';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Decimal']>;
};

export type OfferCoverageComparisonDataType = {
  __typename: 'OfferCoverageComparisonDataType';
  aDwelling?: Maybe<OfferCoverageComparisonDataDictType>;
  bOtherStructures?: Maybe<OfferCoverageComparisonDataDictType>;
  cPersonalProperty?: Maybe<OfferCoverageComparisonDataDictType>;
  cashValue?: Maybe<OfferCoverageComparisonDataDictType>;
  coinsurancePercentage?: Maybe<OfferCoverageComparisonDataDictType>;
  collisionDeductible?: Maybe<OfferCoverageComparisonDataDictType>;
  comprehensiveDeductible?: Maybe<OfferCoverageComparisonDataDictType>;
  dLossUse?: Maybe<OfferCoverageComparisonDataDictType>;
  deathBenefit?: Maybe<OfferCoverageComparisonDataDictType>;
  deductible?: Maybe<OfferCoverageComparisonDataDictType>;
  deductibleWind?: Maybe<OfferCoverageComparisonDataDictType>;
  ePersonalLiability?: Maybe<OfferCoverageComparisonDataDictType>;
  fMedicalOthers?: Maybe<OfferCoverageComparisonDataDictType>;
  othersBodilyAccident?: Maybe<OfferCoverageComparisonDataDictType>;
  othersBodilyPerson?: Maybe<OfferCoverageComparisonDataDictType>;
  othersMedicalPayments?: Maybe<OfferCoverageComparisonDataDictType>;
  othersPropertyAccident?: Maybe<OfferCoverageComparisonDataDictType>;
  reimbursementPercentage?: Maybe<OfferCoverageComparisonDataDictType>;
  uninsuredMotoristPerson?: Maybe<OfferCoverageComparisonDataDictType>;
};

export type OfferCoverageType = {
  __typename: 'OfferCoverageType';
  aDwelling?: Maybe<Scalars['Float']>;
  bOtherStructures?: Maybe<Scalars['Float']>;
  cPersonalProperty?: Maybe<Scalars['Float']>;
  cashValue?: Maybe<Scalars['Float']>;
  coinsurancePercentage?: Maybe<Scalars['Int']>;
  collisionDeductible?: Maybe<Scalars['Float']>;
  comparisonData?: Maybe<OfferCoverageComparisonDataType>;
  comprehensiveDeductible?: Maybe<Scalars['Float']>;
  dLossUse?: Maybe<Scalars['Float']>;
  deathBenefit?: Maybe<Scalars['Float']>;
  deductible?: Maybe<Scalars['Float']>;
  deductibleWind?: Maybe<Scalars['Float']>;
  ePersonalLiability?: Maybe<Scalars['Float']>;
  fMedicalOthers?: Maybe<Scalars['Float']>;
  othersBodilyAccident?: Maybe<Scalars['Float']>;
  othersBodilyPerson?: Maybe<Scalars['Float']>;
  othersMedicalPayments?: Maybe<Scalars['Float']>;
  othersPropertyAccident?: Maybe<Scalars['Float']>;
  reimbursementPercentage?: Maybe<Scalars['Int']>;
  uninsuredMotoristPerson?: Maybe<Scalars['Float']>;
};

export type OfferDocumentInput = {
  id?: InputMaybe<Scalars['UUID']>;
  urlFile: Scalars['String'];
};

/** An enumeration. */
export type OfferStatusType =
  | 'DATA_ERROR'
  | 'DATA_FIXED'
  | 'INELIGIBLE'
  | 'NOT_QUOTED'
  | 'NOT_QUOTED_BUNDLE'
  | 'NOT_QUOTED_LIMITED'
  | 'NOT_QUOTED_REQUEST_INFO'
  | 'QUOTED_BOUND'
  | 'QUOTED_CLOSED'
  | 'QUOTED_PENDING'
  | 'QUOTED_PENDING_CONTACTED'
  | 'QUOTED_PENDING_FINALIZE'
  | 'QUOTED_PENDING_PAYMENT'
  | 'QUOTED_PENDING_PAYMENT_COMPLETE'
  | 'QUOTED_PENDING_PAYMENT_EXPIRED'
  | 'QUOTED_PENDING_REQUEST_INFO';

/** An enumeration. */
export type OfferTemplateCtaIcon =
  /** Call Agent */
  | 'CALL_AGENT'
  /** Fast Quote */
  | 'FAST_QUOTE'
  /** More Info */
  | 'MORE_INFO';

export type OfferTemplateType = {
  __typename: 'OfferTemplateType';
  ctaCopy?: Maybe<Scalars['String']>;
  ctaIcon?: Maybe<OfferTemplateCtaIcon>;
  description?: Maybe<Scalars['String']>;
  finePrint?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export type OfferTier =
  /** Basic */
  | 'BASIC'
  /** Premium */
  | 'PREMIUM'
  /** Standard */
  | 'STANDARD';

export type OfferType = {
  __typename: 'OfferType';
  carrier?: Maybe<Scalars['String']>;
  coverages?: Maybe<OfferCoverageType>;
  expiryDate?: Maybe<Scalars['Date']>;
  id: Scalars['UUID'];
  link?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  offerDocument?: Maybe<Scalars['String']>;
  partner?: Maybe<Scalars['String']>;
  partnerQuoteId?: Maybe<Scalars['String']>;
  policyIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  policyType?: Maybe<Array<Maybe<ShoppingCategoryType>>>;
  premium?: Maybe<Scalars['Float']>;
  savings?: Maybe<Scalars['Float']>;
  shoppingCartId?: Maybe<Scalars['UUID']>;
  status?: Maybe<OfferStatusType>;
  template?: Maybe<OfferTemplateType>;
  termMonths?: Maybe<Scalars['Int']>;
  tier?: Maybe<OfferTier>;
  userSavedDate?: Maybe<Scalars['Date']>;
};

export type OnPolicyDataPullCompleted = {
  __typename: 'OnPolicyDataPullCompleted';
  policyId?: Maybe<Scalars['String']>;
};

export type OnPolicySynced = {
  __typename: 'OnPolicySynced';
  policyId?: Maybe<Scalars['String']>;
  showSyncAnimation?: Maybe<Scalars['Boolean']>;
};

export type OnUserMarblesChanged = {
  __typename: 'OnUserMarblesChanged';
  balanceAnimationValue?: Maybe<Scalars['Int']>;
  marbleAvailable?: Maybe<Scalars['Int']>;
  marbleAvailableConverted?: Maybe<Scalars['Float']>;
};

export type OrderByInputType = {
  field?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Scalars['String']>;
};

export type OrderByType = {
  __typename: 'OrderByType';
  field?: Maybe<Scalars['String']>;
  ordering?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export type OtherCategoryType =
  | 'AD_D'
  | 'BOAT'
  | 'COMMERCIAL'
  | 'DENTAL'
  | 'GROUP_LIFE'
  | 'HEALTH'
  | 'LIFE'
  | 'MOTORCYCLE'
  | 'OTHER'
  | 'TRAVEL'
  | 'UMBRELLA'
  | 'VISION';

export type OtherPolicyDeleteInput = {
  category: OtherCategoryType;
  otherCategory?: InputMaybe<Scalars['String']>;
};

export type OtherPolicyType = {
  __typename: 'OtherPolicyType';
  category?: Maybe<OtherCategoryType>;
  documents: Array<PolicyDocumentType>;
  id: Scalars['UUID'];
  otherCategory?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export type OwnershipStatusType =
  | 'FINANCED'
  | 'LEASED'
  | 'OWNED';

/** An enumeration. */
export type OwnershipType =
  | 'FINANCED'
  | 'OWNED'
  | 'PARENTS'
  | 'RENT';

/** An enumeration. */
export type PageTypeType =
  | 'ACCOUNT'
  | 'ACCOUNT_SHOP'
  | 'LEAD'
  | 'LEAD_REDIRECT'
  | 'LEAD_SHOP';

export type PartnerOfferType = {
  __typename: 'PartnerOfferType';
  active: Scalars['Boolean'];
  cardImage?: Maybe<Scalars['String']>;
  ctaUrl?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  id: Scalars['UUID'];
  modalContent?: Maybe<Scalars['String']>;
  modalImage?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  shortDescription?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  title: Scalars['String'];
};

export type PaymentDetailsType = {
  __typename: 'PaymentDetailsType';
  accountNumber?: Maybe<Scalars['String']>;
  cardBrand?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  expiryMonth?: Maybe<Scalars['Int']>;
  expiryYear?: Maybe<Scalars['Int']>;
  paymentMethod?: Maybe<PaymentMethodType>;
  paymentToken?: Maybe<Scalars['UUID']>;
  routingNumber?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export type PaymentMethodType =
  | 'BANK'
  | 'CARD';

export type PaymentPageType = {
  __typename: 'PaymentPageType';
  assetName?: Maybe<Scalars['String']>;
  carrier?: Maybe<Scalars['String']>;
  carrierLogo?: Maybe<Scalars['String']>;
  category?: Maybe<ShoppingCategoryType>;
  email?: Maybe<Scalars['String']>;
  expiryDate?: Maybe<Scalars['Date']>;
  isPaymentSubmitted?: Maybe<Scalars['Boolean']>;
  monthlyPremium?: Maybe<Scalars['Decimal']>;
  namedInsureds?: Maybe<Scalars['String']>;
  offerDetails?: Maybe<Scalars['String']>;
  offerId?: Maybe<Scalars['UUID']>;
  paymentDetails?: Maybe<PaymentDetailsType>;
  termMonths?: Maybe<Scalars['Int']>;
};

export type PetAssetInput = {
  breed?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['Date']>;
  hasBitten?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  petType?: InputMaybe<PetTypeType>;
  sex?: InputMaybe<PetGenderType>;
};

/** An enumeration. */
export type PetAssetPetType =
  /** Cat */
  | 'CAT'
  /** Dog */
  | 'DOG';

/** An enumeration. */
export type PetGenderType =
  | 'FEMALE'
  | 'MALE';

export type PetOwnerInput = {
  address?: InputMaybe<Scalars['String']>;
  careerStatus?: InputMaybe<CareerStatusType>;
  city?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['Date']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<GenderType>;
  id?: InputMaybe<Scalars['UUID']>;
  lastName?: InputMaybe<Scalars['String']>;
  maritalStatus?: InputMaybe<MaritalStatusType>;
  relationToMarbleMember?: InputMaybe<RelationShipToMarbleMemberType>;
  state?: InputMaybe<Scalars['UUID']>;
  usePrimaryAddress?: InputMaybe<Scalars['Boolean']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type PetOwnerType = {
  __typename: 'PetOwnerType';
  address?: Maybe<Scalars['String']>;
  aiqData?: Maybe<Scalars['Boolean']>;
  altNames?: Maybe<Array<Scalars['String']>>;
  careerStatus?: Maybe<NamedInsuredBaseCareerStatus>;
  city?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  dob?: Maybe<Scalars['Date']>;
  driversLicenseNumber?: Maybe<Scalars['String']>;
  driversLicenseState?: Maybe<StateType>;
  educationLevel?: Maybe<NamedInsuredBaseEducationLevel>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<GenderType>;
  id: Scalars['UUID'];
  lastName?: Maybe<Scalars['String']>;
  maritalStatus?: Maybe<NamedInsuredBaseMaritalStatus>;
  modified?: Maybe<Scalars['DateTime']>;
  namedinsuredbasePtr: NamedInsuredReturnType;
  parentId?: Maybe<Scalars['UUID']>;
  petPolicies: Array<PetPolicyType>;
  relationToMarbleMember?: Maybe<NamedInsuredBaseRelationToMarbleMember>;
  shoppingCarts: Array<ShoppingCartType>;
  state?: Maybe<StateType>;
  usePrimaryAddress?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserType>;
  zipCode?: Maybe<Scalars['String']>;
};

export type PetPolicyType = {
  __typename: 'PetPolicyType';
  address?: Maybe<Scalars['String']>;
  annualDeductible?: Maybe<Scalars['Float']>;
  archiveDate?: Maybe<Scalars['DateTime']>;
  basicSyncFailed: Scalars['Boolean'];
  canopyEmbeddedCarrier?: Maybe<Scalars['String']>;
  carrier?: Maybe<CarrierType>;
  category?: Maybe<CategoryType>;
  coinsurance?: Maybe<Scalars['Int']>;
  continuous: Scalars['Boolean'];
  coverageSynced: Scalars['Boolean'];
  documents?: Maybe<Array<PolicyDocumentType>>;
  endDate?: Maybe<Scalars['Date']>;
  fees?: Maybe<Scalars['Float']>;
  hasBitten?: Maybe<Scalars['Boolean']>;
  historyId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  isOnRenewal?: Maybe<Scalars['Boolean']>;
  isPolicyOwner?: Maybe<Scalars['Boolean']>;
  nextPaymentDue?: Maybe<Scalars['Date']>;
  petBreed?: Maybe<Scalars['String']>;
  petDob?: Maybe<Scalars['String']>;
  petName?: Maybe<Scalars['String']>;
  petOwners: Array<PetOwnerType>;
  petParent?: Maybe<Scalars['String']>;
  petParentAddress?: Maybe<Scalars['String']>;
  petSex?: Maybe<PetGenderType>;
  petType?: Maybe<Scalars['String']>;
  policyHistory?: Maybe<Array<PolicyHistoryType>>;
  policyNumber?: Maybe<Scalars['String']>;
  policyPremium?: Maybe<Scalars['Float']>;
  premiumPeriod?: Maybe<PremiumPeriodType>;
  reimbursement?: Maybe<Scalars['Int']>;
  shareableId?: Maybe<Scalars['UUID']>;
  sharedAccess?: Maybe<Array<SharedAccessType>>;
  showSyncAnimation: Scalars['Boolean'];
  startDate?: Maybe<Scalars['Date']>;
  syncFailureReason?: Maybe<SyncFailureReasonType>;
  synced: Scalars['Boolean'];
  total?: Maybe<Scalars['Float']>;
  user: UserType;
  wrongDocumentType?: Maybe<WrongDocumentTypeType>;
};

export type PetType = {
  __typename: 'PetType';
  breed?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  dob?: Maybe<Scalars['Date']>;
  hasBitten?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  modified?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  petType?: Maybe<PetAssetPetType>;
  policies: Array<PetPolicyType>;
  sex?: Maybe<PetGenderType>;
  shoppingCarts: Array<ShoppingCartType>;
  user: UserType;
};

/** An enumeration. */
export type PetTypeType =
  | 'CAT'
  | 'DOG';

export type PolicyDocumentType = {
  __typename: 'PolicyDocumentType';
  created?: Maybe<Scalars['DateTime']>;
  documentSize: Scalars['Int'];
  documentType: DocumentTypeType;
  id: Scalars['UUID'];
  name: Scalars['String'];
  otherPolicy?: Maybe<OtherPolicyType>;
  policy?: Maybe<PolicyType>;
};

export type PolicyHistoryType = {
  __typename: 'PolicyHistoryType';
  endDate?: Maybe<Scalars['Date']>;
  historyId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  policyNumber?: Maybe<Scalars['String']>;
  premiumPeriod?: Maybe<PremiumPeriodType>;
  startDate?: Maybe<Scalars['Date']>;
  total?: Maybe<Scalars['Float']>;
};

export type PolicyType = {
  __typename: 'PolicyType';
  address?: Maybe<Scalars['String']>;
  archiveDate?: Maybe<Scalars['DateTime']>;
  basicSyncFailed: Scalars['Boolean'];
  canopyEmbeddedCarrier?: Maybe<Scalars['String']>;
  carrier?: Maybe<CarrierType>;
  category?: Maybe<CategoryType>;
  continuous: Scalars['Boolean'];
  coverageSynced: Scalars['Boolean'];
  documents?: Maybe<Array<PolicyDocumentType>>;
  endDate?: Maybe<Scalars['Date']>;
  fees?: Maybe<Scalars['Float']>;
  historyId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  isOnRenewal?: Maybe<Scalars['Boolean']>;
  isPolicyOwner?: Maybe<Scalars['Boolean']>;
  nextPaymentDue?: Maybe<Scalars['Date']>;
  policyHistory?: Maybe<Array<PolicyHistoryType>>;
  policyNumber?: Maybe<Scalars['String']>;
  policyPremium?: Maybe<Scalars['Float']>;
  premiumPeriod?: Maybe<PremiumPeriodType>;
  shareableId?: Maybe<Scalars['UUID']>;
  sharedAccess?: Maybe<Array<SharedAccessType>>;
  showSyncAnimation: Scalars['Boolean'];
  startDate?: Maybe<Scalars['Date']>;
  syncFailureReason?: Maybe<SyncFailureReasonType>;
  synced: Scalars['Boolean'];
  total?: Maybe<Scalars['Float']>;
  user: UserType;
  wrongDocumentType?: Maybe<WrongDocumentTypeType>;
};

export type PolicyUnionType = AutoPolicyType | HomePolicyType | LifePolicyType | PetPolicyType | PolicyType | RenterPolicyType;

export type PolicyUploadRewardType = {
  __typename: 'PolicyUploadRewardType';
  category?: Maybe<Scalars['String']>;
  marbleCount?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export type PoolType =
  | 'ABOVE_GROUND_POOL'
  | 'ADULT_KIDDIE_POOLS'
  | 'BUMPER_BOAT'
  | 'CONCRETE_VINYL'
  | 'FISH_POND'
  | 'HEATED_POOL_GUNITE'
  | 'INDOOR_POOL'
  | 'IN_GROUND_POOL'
  | 'IN_GROUND_VINYL_POOL'
  | 'KIDDIE_PLAY_POOL'
  | 'LAGOON'
  | 'LAP_POOL'
  | 'MULTIPLE_POOLS_UNSPECIFIED'
  | 'NOT_STATED'
  | 'NO_POOL'
  | 'OTHER'
  | 'POOLS_THREE_PLUS_UNSPECIFIED'
  | 'POOLS_TWO_UNSPECIFIED'
  | 'POOL_ARROW_SHAPED'
  | 'POOL_BRICK_MASONRY_STONE'
  | 'POOL_CIRCULAR'
  | 'POOL_CONCRETE'
  | 'POOL_CONCRETE_FENCED'
  | 'POOL_CONCRETE_WITH_CABANA_POOL_HOUSE'
  | 'POOL_CONCRETE_WITH_EQUIPMENT'
  | 'POOL_FIBERGLASS'
  | 'POOL_GUNITE'
  | 'POOL_GUNITE_ENCLOSED'
  | 'POOL_GUNITE_KIDNEY_SHAPED'
  | 'POOL_GUNITE_WITH_HOT_TUB_SPA'
  | 'POOL_GUNITE_WITH_PATIO'
  | 'POOL_IN_GROUND_WITH_HOT_TUB_SPA'
  | 'POOL_IRREGULAR_SHAPED'
  | 'POOL_KIDNEY_SHAPED'
  | 'POOL_L_SHAPED'
  | 'POOL_METAL'
  | 'POOL_OVAL_SHAPED'
  | 'POOL_PLASTIC_VINYL_LINED'
  | 'POOL_PRE_FABRICATED_VINYL'
  | 'POOL_SOLAR_HEATED'
  | 'POOL_SPA_WITH_DECK'
  | 'POOL_STONE_GRANITE'
  | 'POOL_UNSPECIFIED_ENCLOSED'
  | 'POOL_UNSPECIFIED_FENCED'
  | 'POOL_UNSPECIFIED_HEATED'
  | 'POOL_UNSPECIFIED_WITH_COVER'
  | 'POOL_UNSPECIFIED_WITH_DECK'
  | 'POOL_VINYL_KIDNEY_SHAPED'
  | 'POOL_VINYL_LINING_STEEL_WALLED'
  | 'POOL_VINYL_L_SHAPED'
  | 'POOL_VINYL_OVAL_SHAPED'
  | 'POOL_VINYL_WITH_DECK'
  | 'POOL_VINYL_WITH_PATIO'
  | 'POOL_WITH_BAR'
  | 'POOL_WITH_CABANA_POOL_HOUSE'
  | 'POOL_WITH_CANOPY'
  | 'POOL_WITH_DIVING_BOARD'
  | 'POOL_WITH_EQUIPMENT'
  | 'POOL_WITH_FOUNTAIN'
  | 'POOL_WITH_HOT_TUB_SPA'
  | 'POOL_WITH_PATIO'
  | 'POOL_WITH_SAUNA'
  | 'POOL_WITH_WATERFALL'
  | 'PUBLIC_MUNICIPAL_COMMERCIAL'
  | 'SAUNA_ONLY'
  | 'SAUNA_SPA_ONLY'
  | 'SPA_GAZEBO_ONLY'
  | 'SPA_HOT_TUB_DECK_ONLY'
  | 'SPA_HOT_TUB_ONLY'
  | 'TYPE_NOT_SPECIFIED'
  | 'WADING_POOL';

export type PostAgentContact = {
  __typename: 'PostAgentContact';
  ok?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export type PremiumPeriodType =
  | 'PREMIUM_5YEARS'
  | 'PREMIUM_10YEARS'
  | 'PREMIUM_15YEARS'
  | 'PREMIUM_20YEARS'
  | 'PREMIUM_25YEARS'
  | 'PREMIUM_30YEARS'
  | 'PREMIUM_MONTHLY'
  | 'PREMIUM_SIX'
  | 'PREMIUM_YEARLY';

/** An enumeration. */
export type PrimaryUseType =
  | 'BUSINESS'
  | 'COMMUTE'
  | 'PLEASURE';

export type ProfileInput = {
  address?: InputMaybe<Scalars['String']>;
  avatar?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  creditScore?: InputMaybe<CreditScoreType>;
  dob?: InputMaybe<Scalars['Date']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<GenderType>;
  isHomeOwner?: InputMaybe<Scalars['Boolean']>;
  isInsuredForAuto?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  legalNameConfirmed?: InputMaybe<Scalars['Boolean']>;
  moveInDate?: InputMaybe<Scalars['Date']>;
  ownership?: InputMaybe<OwnershipType>;
  phone?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  previousAddress?: InputMaybe<Scalars['String']>;
  previousCity?: InputMaybe<Scalars['String']>;
  previousState?: InputMaybe<Scalars['UUID']>;
  previousZipCode?: InputMaybe<Scalars['String']>;
  shoppingZipCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['UUID']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type ProgressBarType = {
  __typename: 'ProgressBarType';
  action?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export type PropertyAssetBuildingShape =
  /** COMPLEX */
  | 'COMPLEX'
  /** C_SHAPED */
  | 'C_SHAPED'
  /** IRREGULAR */
  | 'IRREGULAR'
  /** L_SHAPED */
  | 'L_SHAPED'
  /** RECTANGLE */
  | 'RECTANGLE'
  /** SLIGHTLY_IRREGULAR */
  | 'SLIGHTLY_IRREGULAR'
  /** SQUARE */
  | 'SQUARE'
  /** VERY_IRREGULAR */
  | 'VERY_IRREGULAR';

/** An enumeration. */
export type PropertyAssetConstruction =
  /** ADOBE */
  | 'ADOBE'
  /** ALUMINUM_FRAME */
  | 'ALUMINUM_FRAME'
  /** ALUMINUM_SIDING */
  | 'ALUMINUM_SIDING'
  /** ALUMINUM_VINYL */
  | 'ALUMINUM_VINYL'
  /** ARCHED_DOME */
  | 'ARCHED_DOME'
  /** A_FRAME */
  | 'A_FRAME'
  /** BLOCK_BRICK */
  | 'BLOCK_BRICK'
  /** BLOCK_METAL */
  | 'BLOCK_METAL'
  /** BLOCK_STEEL */
  | 'BLOCK_STEEL'
  /** BRICK */
  | 'BRICK'
  /** BRICK_CINDER_BLOCK */
  | 'BRICK_CINDER_BLOCK'
  /** BRICK_CONCRETE */
  | 'BRICK_CONCRETE'
  /** BRICK_FRAME */
  | 'BRICK_FRAME'
  /** BRICK_METAL */
  | 'BRICK_METAL'
  /** BRICK_STEEL */
  | 'BRICK_STEEL'
  /** BRICK_STONE */
  | 'BRICK_STONE'
  /** BRICK_STUCCO */
  | 'BRICK_STUCCO'
  /** BRICK_VENEER */
  | 'BRICK_VENEER'
  /** CINDER_BLOCK */
  | 'CINDER_BLOCK'
  /** CLAPBOARD */
  | 'CLAPBOARD'
  /** COMBINATION */
  | 'COMBINATION'
  /** CONCRETE */
  | 'CONCRETE'
  /** CONCRETE_BLOCK */
  | 'CONCRETE_BLOCK'
  /** CONCRETE_MASONRY */
  | 'CONCRETE_MASONRY'
  /** CONCRETE_STEEL */
  | 'CONCRETE_STEEL'
  /** CUSTOM */
  | 'CUSTOM'
  /** DOME */
  | 'DOME'
  /** FLEXIBLE_FLEXICORE */
  | 'FLEXIBLE_FLEXICORE'
  /** FRAME */
  | 'FRAME'
  /** FRAME_MASONRY */
  | 'FRAME_MASONRY'
  /** FRAME_STEEL */
  | 'FRAME_STEEL'
  /** FRAME_STUCCO */
  | 'FRAME_STUCCO'
  /** GLASS */
  | 'GLASS'
  /** HEAVY */
  | 'HEAVY'
  /** LIGHT */
  | 'LIGHT'
  /** LOG */
  | 'LOG'
  /** MANUFACTURED_MODULAR */
  | 'MANUFACTURED_MODULAR'
  /** MASONRY */
  | 'MASONRY'
  /** MASONRY_TILT_UP */
  | 'MASONRY_TILT_UP'
  /** METAL */
  | 'METAL'
  /** NONE */
  | 'NONE'
  /** POLE_FRAME */
  | 'POLE_FRAME'
  /** PREFAB_METAL */
  | 'PREFAB_METAL'
  /** STEEL */
  | 'STEEL'
  /** STEEL_MASONRY */
  | 'STEEL_MASONRY'
  /** STEEL_STUCCO */
  | 'STEEL_STUCCO'
  /** STEEL_WOOD */
  | 'STEEL_WOOD'
  /** STONE_ROCK */
  | 'STONE_ROCK'
  /** STONE_VENEER */
  | 'STONE_VENEER'
  /** STUCCO */
  | 'STUCCO'
  /** TILT_UP */
  | 'TILT_UP'
  /** TILT_UP_BRICK_METAL */
  | 'TILT_UP_BRICK_METAL'
  /** TILT_UP_CONCRETE */
  | 'TILT_UP_CONCRETE'
  /** TYPE_NOT_SPECIFIED */
  | 'TYPE_NOT_SPECIFIED'
  /** TYPE_UNKNOWN */
  | 'TYPE_UNKNOWN'
  /** WOOD */
  | 'WOOD'
  /** WOOD_BRICK */
  | 'WOOD_BRICK'
  /** WOOD_FRAME */
  | 'WOOD_FRAME'
  /** WOOD_FRAME_CONCRETE_BLOCK */
  | 'WOOD_FRAME_CONCRETE_BLOCK'
  /** WOOD_FRAME_METAL */
  | 'WOOD_FRAME_METAL'
  /** WOOD_STEEL */
  | 'WOOD_STEEL'
  /** WOOD_STONE */
  | 'WOOD_STONE'
  /** WOOD_STUCCO */
  | 'WOOD_STUCCO';

/** An enumeration. */
export type PropertyAssetConstructionQuality =
  /** AVERAGE */
  | 'AVERAGE'
  /** CABIN */
  | 'CABIN'
  /** EXCELLENT */
  | 'EXCELLENT'
  /** FAIR */
  | 'FAIR'
  /** GOOD */
  | 'GOOD'
  /** HIGH_QUALITY_RESIDENTIAL */
  | 'HIGH_QUALITY_RESIDENTIAL'
  /** LOW */
  | 'LOW'
  /** NOT_AVAILABLE */
  | 'NOT_AVAILABLE'
  /** NP */
  | 'NP'
  /** OTHER */
  | 'OTHER'
  /** UNKNOWN */
  | 'UNKNOWN'
  /** VERY_GOOD */
  | 'VERY_GOOD';

/** An enumeration. */
export type PropertyAssetCoolingType =
  /** AC_CENTRAL */
  | 'AC_CENTRAL'
  /** AC_CENTRAL_AND_UNIT */
  | 'AC_CENTRAL_AND_UNIT'
  /** AC_CENTRAL_PARTIAL */
  | 'AC_CENTRAL_PARTIAL'
  /** AC_COMMERCIAL_AC */
  | 'AC_COMMERCIAL_AC'
  /** AC_DUAL_UNIT */
  | 'AC_DUAL_UNIT'
  /** AC_EVAPORATIVE */
  | 'AC_EVAPORATIVE'
  /** AC_HEAT_PUMP */
  | 'AC_HEAT_PUMP'
  /** AC_NONE */
  | 'AC_NONE'
  /** AC_OFFICE_ONLY */
  | 'AC_OFFICE_ONLY'
  /** AC_PACKAGE_ROOF */
  | 'AC_PACKAGE_ROOF'
  /** AC_PARTIAL */
  | 'AC_PARTIAL'
  /** AC_REFRIGERATION */
  | 'AC_REFRIGERATION'
  /** AC_REFRIGERATION_EVAPORATION */
  | 'AC_REFRIGERATION_EVAPORATION'
  /** AC_SEPARATE_SYSTEM */
  | 'AC_SEPARATE_SYSTEM'
  /** AC_SOLAR */
  | 'AC_SOLAR'
  /** AC_SPLIT_SYSTEM */
  | 'AC_SPLIT_SYSTEM'
  /** AC_WALL_UNIT */
  | 'AC_WALL_UNIT'
  /** AC_WALL_WINDOW_UNIT */
  | 'AC_WALL_WINDOW_UNIT'
  /** AC_WINDOW_UNIT */
  | 'AC_WINDOW_UNIT'
  /** BYPASS */
  | 'BYPASS'
  /** CENTRAL */
  | 'CENTRAL'
  /** CHILLED_WATER */
  | 'CHILLED_WATER'
  /** EVAPORATIVE */
  | 'EVAPORATIVE'
  /** EVAPORATIVE_WALL_UNIT */
  | 'EVAPORATIVE_WALL_UNIT'
  /** FAN_COOLING */
  | 'FAN_COOLING'
  /** GEO_THERMAL */
  | 'GEO_THERMAL'
  /** NONE */
  | 'NONE'
  /** NOT_AVAILABLE */
  | 'NOT_AVAILABLE'
  /** NOT_PROVIDED */
  | 'NOT_PROVIDED'
  /** OTHER */
  | 'OTHER'
  /** PACKAGE */
  | 'PACKAGE'
  /** PARTIAL */
  | 'PARTIAL'
  /** REFRIGERATION_WALL_UNIT */
  | 'REFRIGERATION_WALL_UNIT'
  /** REFRIGERATOR */
  | 'REFRIGERATOR'
  /** REFRIGERATOR_EVAPORATIVE */
  | 'REFRIGERATOR_EVAPORATIVE'
  /** SOLAR */
  | 'SOLAR'
  /** UNKNOWN */
  | 'UNKNOWN'
  /** WALL_UNIT */
  | 'WALL_UNIT'
  /** WINDOW_AC */
  | 'WINDOW_AC'
  /** WINDOW_EVAPORATIVE */
  | 'WINDOW_EVAPORATIVE'
  /** YES */
  | 'YES';

/** An enumeration. */
export type PropertyAssetDwellingClass =
  /** AGRICULTURAL */
  | 'AGRICULTURAL'
  /** AMUSEMENT_RECREATION */
  | 'AMUSEMENT_RECREATION'
  /** APARTMENT */
  | 'APARTMENT'
  /** COMMERCIAL */
  | 'COMMERCIAL'
  /** COMMERCIAL_CONDOMINIUM */
  | 'COMMERCIAL_CONDOMINIUM'
  /** CONDOMINIUM_RESIDENTIAL */
  | 'CONDOMINIUM_RESIDENTIAL'
  /** DUPLEX_TRIPLEX_QUADPLEX */
  | 'DUPLEX_TRIPLEX_QUADPLEX'
  /** EXEMPT */
  | 'EXEMPT'
  /** FINANCIAL_INSTITUTION */
  | 'FINANCIAL_INSTITUTION'
  /** HOSPITAL */
  | 'HOSPITAL'
  /** HOTEL_MOTEL */
  | 'HOTEL_MOTEL'
  /** INDUSTRIAL */
  | 'INDUSTRIAL'
  /** INDUSTRIAL_HEAVY */
  | 'INDUSTRIAL_HEAVY'
  /** INDUSTRIAL_LIGHT */
  | 'INDUSTRIAL_LIGHT'
  /** MISCELLANEOUS */
  | 'MISCELLANEOUS'
  /** OFFICE_BUILDING */
  | 'OFFICE_BUILDING'
  /** PARKING */
  | 'PARKING'
  /** RETAIL */
  | 'RETAIL'
  /** SERVICE */
  | 'SERVICE'
  /** SINGLE_FAMILY_RESIDENCE_TOWNHOUSE */
  | 'SINGLE_FAMILY_RESIDENCE_TOWNHOUSE'
  /** TRANSPORT */
  | 'TRANSPORT'
  /** UTILITIES */
  | 'UTILITIES'
  /** VACANT */
  | 'VACANT';

/** An enumeration. */
export type PropertyAssetEnergyType =
  /** ABOVE_STANDARD */
  | 'ABOVE_STANDARD'
  /** AVAILABLE */
  | 'AVAILABLE'
  /** AVERAGE */
  | 'AVERAGE'
  /** BELOW_STANDARD */
  | 'BELOW_STANDARD'
  /** DEVELOPED */
  | 'DEVELOPED'
  /** FAIR */
  | 'FAIR'
  /** GOOD */
  | 'GOOD'
  /** NO */
  | 'NO'
  /** NOT_AVAILABLE */
  | 'NOT_AVAILABLE'
  /** NP */
  | 'NP'
  /** OVERHEAD */
  | 'OVERHEAD'
  /** POOR */
  | 'POOR'
  /** STANDARD */
  | 'STANDARD'
  /** UNDERGROUND */
  | 'UNDERGROUND'
  /** UNKNOWN */
  | 'UNKNOWN'
  /** YES */
  | 'YES';

/** An enumeration. */
export type PropertyAssetFireplaceType =
  /** BACKED */
  | 'BACKED'
  /** CEILING_HIGH_BRICK */
  | 'CEILING_HIGH_BRICK'
  /** CUSTOM */
  | 'CUSTOM'
  /** DOUBLE */
  | 'DOUBLE'
  /** ELECTRIC */
  | 'ELECTRIC'
  /** FLUE_ONLY */
  | 'FLUE_ONLY'
  /** GLASS_LOG */
  | 'GLASS_LOG'
  /** HEATER_CIRCLE */
  | 'HEATER_CIRCLE'
  /** MASONRY */
  | 'MASONRY'
  /** NOT_AVAILABLE */
  | 'NOT_AVAILABLE'
  /** NOT_PROVIDED */
  | 'NOT_PROVIDED'
  /** NP */
  | 'NP'
  /** PREFAB */
  | 'PREFAB'
  /** RAISED_HEARTH */
  | 'RAISED_HEARTH'
  /** SEE_THRU */
  | 'SEE_THRU'
  /** SINGLE */
  | 'SINGLE'
  /** STACKED */
  | 'STACKED'
  /** WOOD_STOVE */
  | 'WOOD_STOVE'
  /** YES */
  | 'YES'
  /** $1_STORY_BRICK */
  | '_1_STORY_BRICK'
  /** $2_STORY */
  | '_2_STORY'
  /** $2_STORY_BRICK */
  | '_2_STORY_BRICK';

/** An enumeration. */
export type PropertyAssetFoundation =
  /** BASEMENT */
  | 'BASEMENT'
  /** BLOCK */
  | 'BLOCK'
  /** BLOCK_UNSPECIFIED */
  | 'BLOCK_UNSPECIFIED'
  /** BRICK */
  | 'BRICK'
  /** BRICK_UNSPECIFIED */
  | 'BRICK_UNSPECIFIED'
  /** CLOSED_PIERS */
  | 'CLOSED_PIERS'
  /** CONCRETE */
  | 'CONCRETE'
  /** CONCRETE_BEAM */
  | 'CONCRETE_BEAM'
  /** CONCRETE_BEAM_SLAB */
  | 'CONCRETE_BEAM_SLAB'
  /** CONCRETE_BLOCK */
  | 'CONCRETE_BLOCK'
  /** CONTINUOUS_FOOTING */
  | 'CONTINUOUS_FOOTING'
  /** CONTINUOUS_WALL */
  | 'CONTINUOUS_WALL'
  /** CROSS_BRIDGED_WALLS */
  | 'CROSS_BRIDGED_WALLS'
  /** DIRT_EARTH */
  | 'DIRT_EARTH'
  /** FOOTING */
  | 'FOOTING'
  /** FOOTING_CONTINUOUS_STRIP */
  | 'FOOTING_CONTINUOUS_STRIP'
  /** FOOTING_SPREAD */
  | 'FOOTING_SPREAD'
  /** GRADE_BEAM */
  | 'GRADE_BEAM'
  /** MASONRY */
  | 'MASONRY'
  /** MASONRY_UNSPECIFIED */
  | 'MASONRY_UNSPECIFIED'
  /** MAT_RAFT_FOUNDATION */
  | 'MAT_RAFT_FOUNDATION'
  /** MUD_SILL */
  | 'MUD_SILL'
  /** NONE */
  | 'NONE'
  /** NOT_STATED */
  | 'NOT_STATED'
  /** NO_FOUNDATION */
  | 'NO_FOUNDATION'
  /** NP */
  | 'NP'
  /** OPEN_PIERS */
  | 'OPEN_PIERS'
  /** PIER */
  | 'PIER'
  /** PIER_POST_BEAM */
  | 'PIER_POST_BEAM'
  /** PIER_POST_CONCRETE */
  | 'PIER_POST_CONCRETE'
  /** PIER_POST_WOOD */
  | 'PIER_POST_WOOD'
  /** PILE */
  | 'PILE'
  /** PILE_CONCRETE */
  | 'PILE_CONCRETE'
  /** PILE_END_BEARING */
  | 'PILE_END_BEARING'
  /** PILE_FRICTION */
  | 'PILE_FRICTION'
  /** PILE_WOOD_TIMBER */
  | 'PILE_WOOD_TIMBER'
  /** PILINGS */
  | 'PILINGS'
  /** PIPE_IRON */
  | 'PIPE_IRON'
  /** PRE_FAB */
  | 'PRE_FAB'
  /** RAISED */
  | 'RAISED'
  /** RAISED_BASEMENT */
  | 'RAISED_BASEMENT'
  /** RAISED_CRAWLSPACE */
  | 'RAISED_CRAWLSPACE'
  /** RAISED_UNSPECIFIED */
  | 'RAISED_UNSPECIFIED'
  /** RETAINING_WALL */
  | 'RETAINING_WALL'
  /** SLAB */
  | 'SLAB'
  /** SPREAD_FOOTING */
  | 'SPREAD_FOOTING'
  /** STANDARD */
  | 'STANDARD'
  /** STEEL */
  | 'STEEL'
  /** STEM_WALL */
  | 'STEM_WALL'
  /** STEM_WALL_CRAWLSPACE */
  | 'STEM_WALL_CRAWLSPACE'
  /** STONE */
  | 'STONE'
  /** STONE_UNSPECIFIED */
  | 'STONE_UNSPECIFIED'
  /** TYPE_NOT_SPECIFIED */
  | 'TYPE_NOT_SPECIFIED'
  /** TYPE_UNKNOWN */
  | 'TYPE_UNKNOWN'
  /** TYPE_UNKNOWN_BASEMENT */
  | 'TYPE_UNKNOWN_BASEMENT'
  /** TYPE_UNKNOWN_CRAWLSPACE */
  | 'TYPE_UNKNOWN_CRAWLSPACE'
  /** TYPE_UNKNOWN_PART_BASEMENT */
  | 'TYPE_UNKNOWN_PART_BASEMENT'
  /** UNAVAILABLE */
  | 'UNAVAILABLE'
  /** UNKNOWN */
  | 'UNKNOWN'
  /** WOOD */
  | 'WOOD'
  /** WOOD_UNSPECIFIED */
  | 'WOOD_UNSPECIFIED';

/** An enumeration. */
export type PropertyAssetFrameType =
  /** ALUMINUM_FRAME */
  | 'ALUMINUM_FRAME'
  /** CONCRETE */
  | 'CONCRETE'
  /** CONCRETE_STEEL */
  | 'CONCRETE_STEEL'
  /** CUSTOM */
  | 'CUSTOM'
  /** FIRE_RESISTANT */
  | 'FIRE_RESISTANT'
  /** MASONRY */
  | 'MASONRY'
  /** PRE_FAB */
  | 'PRE_FAB'
  /** STEEL */
  | 'STEEL'
  /** TYPE_UNKNOWN */
  | 'TYPE_UNKNOWN'
  /** WOOD */
  | 'WOOD'
  /** WOOD_UNSPECIFIED */
  | 'WOOD_UNSPECIFIED';

/** An enumeration. */
export type PropertyAssetGarageType =
  /** ATTACHED_1_CAR */
  | 'ATTACHED_1_CAR'
  /** ATTACHED_2_CAR */
  | 'ATTACHED_2_CAR'
  /** ATTACHED_3_PLUS_CAR */
  | 'ATTACHED_3_PLUS_CAR'
  /** ATTACHED_FINISHED */
  | 'ATTACHED_FINISHED'
  /** ATTACHED_UNFINISHED */
  | 'ATTACHED_UNFINISHED'
  /** CARPORT_1_CAR */
  | 'CARPORT_1_CAR'
  /** CARPORT_2_CAR */
  | 'CARPORT_2_CAR'
  /** CARPORT_3_PLUS_CAR */
  | 'CARPORT_3_PLUS_CAR'
  /** CARPORT_ATTACHED */
  | 'CARPORT_ATTACHED'
  /** CARPORT_DETACHED */
  | 'CARPORT_DETACHED'
  /** CARPORT_DETACHED_FINISHED */
  | 'CARPORT_DETACHED_FINISHED'
  /** CARPORT_DETACHED_UNFINISHED */
  | 'CARPORT_DETACHED_UNFINISHED'
  /** CARPORT_ENCLOSED */
  | 'CARPORT_ENCLOSED'
  /** CARPORT_FINISHED */
  | 'CARPORT_FINISHED'
  /** CARPORT_OPEN */
  | 'CARPORT_OPEN'
  /** CARPORT_UNFINISHED */
  | 'CARPORT_UNFINISHED'
  /** CARPORT_UNSPECIFIED */
  | 'CARPORT_UNSPECIFIED'
  /** COVERED */
  | 'COVERED'
  /** DETACHED_1_CAR */
  | 'DETACHED_1_CAR'
  /** DETACHED_2_CAR */
  | 'DETACHED_2_CAR'
  /** DETACHED_3_PLUS_CAR */
  | 'DETACHED_3_PLUS_CAR'
  /** DETACHED_FINISHED */
  | 'DETACHED_FINISHED'
  /** DETACHED_UNFINISHED */
  | 'DETACHED_UNFINISHED'
  /** DETACHED_UNSPECIFIED */
  | 'DETACHED_UNSPECIFIED'
  /** GARAGE_1_CAR */
  | 'GARAGE_1_CAR'
  /** GARAGE_2_CAR */
  | 'GARAGE_2_CAR'
  /** GARAGE_3_PLUS_CAR */
  | 'GARAGE_3_PLUS_CAR'
  /** GARAGE_AND_CARPORT */
  | 'GARAGE_AND_CARPORT'
  /** GARAGE_ATTACHED */
  | 'GARAGE_ATTACHED'
  /** GARAGE_BASEMENT */
  | 'GARAGE_BASEMENT'
  /** GARAGE_BASEMENT_1_CAR */
  | 'GARAGE_BASEMENT_1_CAR'
  /** GARAGE_BASEMENT_2_CAR */
  | 'GARAGE_BASEMENT_2_CAR'
  /** GARAGE_BASEMENT_3_PLUS_CAR */
  | 'GARAGE_BASEMENT_3_PLUS_CAR'
  /** GARAGE_BASEMENT_FINISHED */
  | 'GARAGE_BASEMENT_FINISHED'
  /** GARAGE_BASEMENT_FINISHED_1_CAR */
  | 'GARAGE_BASEMENT_FINISHED_1_CAR'
  /** GARAGE_BASEMENT_FINISHED_2_CAR */
  | 'GARAGE_BASEMENT_FINISHED_2_CAR'
  /** GARAGE_BASEMENT_FINISHED_3_PLUS_CAR */
  | 'GARAGE_BASEMENT_FINISHED_3_PLUS_CAR'
  /** GARAGE_BASEMENT_UNFINISHED */
  | 'GARAGE_BASEMENT_UNFINISHED'
  /** GARAGE_BASEMENT_UNFINISHED_1_CAR */
  | 'GARAGE_BASEMENT_UNFINISHED_1_CAR'
  /** GARAGE_BASEMENT_UNFINISHED_2_CAR */
  | 'GARAGE_BASEMENT_UNFINISHED_2_CAR'
  /** GARAGE_BASEMENT_UNFINISHED_3_PLUS_CAR */
  | 'GARAGE_BASEMENT_UNFINISHED_3_PLUS_CAR'
  /** GARAGE_BUILT_IN */
  | 'GARAGE_BUILT_IN'
  /** GARAGE_BUILT_IN_1_CAR */
  | 'GARAGE_BUILT_IN_1_CAR'
  /** GARAGE_BUILT_IN_2_CAR */
  | 'GARAGE_BUILT_IN_2_CAR'
  /** GARAGE_BUILT_IN_FINISHED */
  | 'GARAGE_BUILT_IN_FINISHED'
  /** GARAGE_BUILT_IN_UNFINISHED */
  | 'GARAGE_BUILT_IN_UNFINISHED'
  /** GARAGE_DETACHED */
  | 'GARAGE_DETACHED'
  /** GARAGE_ENCLOSED */
  | 'GARAGE_ENCLOSED'
  /** GARAGE_FINISHED */
  | 'GARAGE_FINISHED'
  /** GARAGE_HEATED */
  | 'GARAGE_HEATED'
  /** GARAGE_OPEN */
  | 'GARAGE_OPEN'
  /** GARAGE_TUCKUNDER */
  | 'GARAGE_TUCKUNDER'
  /** GARAGE_UNFINISHED */
  | 'GARAGE_UNFINISHED'
  /** GARAGE_UNFINISHED_1_CAR */
  | 'GARAGE_UNFINISHED_1_CAR'
  /** GARAGE_UNFINISHED_2_CAR */
  | 'GARAGE_UNFINISHED_2_CAR'
  /** GARAGE_UNFINISHED_3_PLUS_CAR */
  | 'GARAGE_UNFINISHED_3_PLUS_CAR'
  /** MIXED */
  | 'MIXED'
  /** NOT_AVAILABLE */
  | 'NOT_AVAILABLE'
  /** NOT_PROVIDED */
  | 'NOT_PROVIDED'
  /** NOT_STATED */
  | 'NOT_STATED'
  /** NO_GARAGE */
  | 'NO_GARAGE'
  /** NP */
  | 'NP'
  /** PARKING_STRUCTURE */
  | 'PARKING_STRUCTURE'
  /** POLE_BUILDING_GARAGE */
  | 'POLE_BUILDING_GARAGE'
  /** TYPE_NOT_SPECIFIED */
  | 'TYPE_NOT_SPECIFIED'
  /** UNKNOWN */
  | 'UNKNOWN';

/** An enumeration. */
export type PropertyAssetHeatingFuel =
  /** COAL */
  | 'COAL'
  /** ELECTRIC */
  | 'ELECTRIC'
  /** ELECTRIC_HOT_WATER */
  | 'ELECTRIC_HOT_WATER'
  /** GAS */
  | 'GAS'
  /** GEO_THERMAL */
  | 'GEO_THERMAL'
  /** HEAT_PUMP */
  | 'HEAT_PUMP'
  /** LIQUEFIED_PETROLEUM_GAS */
  | 'LIQUEFIED_PETROLEUM_GAS'
  /** NONE */
  | 'NONE'
  /** NOT_AVAILABLE */
  | 'NOT_AVAILABLE'
  /** NOT_PROVIDED */
  | 'NOT_PROVIDED'
  /** OIL */
  | 'OIL'
  /** OTHER */
  | 'OTHER'
  /** PROPANE */
  | 'PROPANE'
  /** SOLAR */
  | 'SOLAR'
  /** SOLID */
  | 'SOLID'
  /** TYPE_UNKNOWN */
  | 'TYPE_UNKNOWN'
  /** WOOD */
  | 'WOOD';

/** An enumeration. */
export type PropertyAssetHeatingType =
  /** BASEBOARD */
  | 'BASEBOARD'
  /** CEILING_CABLE */
  | 'CEILING_CABLE'
  /** CEILING_FURNACE */
  | 'CEILING_FURNACE'
  /** CENTRAL */
  | 'CENTRAL'
  /** COAL */
  | 'COAL'
  /** CONVECTION */
  | 'CONVECTION'
  /** ELECTRIC */
  | 'ELECTRIC'
  /** FIREPLACE */
  | 'FIREPLACE'
  /** FLOOR_FURNACE */
  | 'FLOOR_FURNACE'
  /** FLOOR_WALL_FURNACE */
  | 'FLOOR_WALL_FURNACE'
  /** FORCED_AIR */
  | 'FORCED_AIR'
  /** FORCED_AIR_WITH_AIR_CONDITIONING */
  | 'FORCED_AIR_WITH_AIR_CONDITIONING'
  /** GAS */
  | 'GAS'
  /** GEO_THERMAL */
  | 'GEO_THERMAL'
  /** GRAVITY */
  | 'GRAVITY'
  /** HEAT_PUMP */
  | 'HEAT_PUMP'
  /** HOT_WATER */
  | 'HOT_WATER'
  /** NONE */
  | 'NONE'
  /** NOT_AVAILABLE */
  | 'NOT_AVAILABLE'
  /** NP */
  | 'NP'
  /** OIL */
  | 'OIL'
  /** OTHER */
  | 'OTHER'
  /** PACKAGE */
  | 'PACKAGE'
  /** PARTIAL */
  | 'PARTIAL'
  /** PROPANE */
  | 'PROPANE'
  /** RADIANT */
  | 'RADIANT'
  /** SOLAR */
  | 'SOLAR'
  /** SPACE */
  | 'SPACE'
  /** STEAM */
  | 'STEAM'
  /** STOVE */
  | 'STOVE'
  /** UNKNOWN */
  | 'UNKNOWN'
  /** WALL_GAS */
  | 'WALL_GAS'
  /** WOOD_FURNACE */
  | 'WOOD_FURNACE'
  /** YES */
  | 'YES'
  /** ZONE */
  | 'ZONE';

export type PropertyAssetInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  construction?: InputMaybe<ConstructionType>;
  deductibleHome?: InputMaybe<HomeDeductibleLimitType>;
  deductibleWind?: InputMaybe<WindDeductibleLimitType>;
  electricalUpdated?: InputMaybe<Scalars['Int']>;
  fireAlarm?: InputMaybe<Scalars['Boolean']>;
  fireAlarmType?: InputMaybe<SecurityTypeType>;
  foundation?: InputMaybe<FoundationType>;
  hasDogs?: InputMaybe<Scalars['Boolean']>;
  hasPool?: InputMaybe<Scalars['Boolean']>;
  hasTrampoline?: InputMaybe<Scalars['Boolean']>;
  heatingAndCoolingUpdated?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  isGatedCommunity?: InputMaybe<Scalars['Boolean']>;
  numBathsFull?: InputMaybe<Scalars['Int']>;
  numBathsPartial?: InputMaybe<Scalars['Int']>;
  numBeds?: InputMaybe<Scalars['Int']>;
  numStories?: InputMaybe<Scalars['Decimal']>;
  occupancyInfo?: InputMaybe<Scalars['String']>;
  plumbingUpdated?: InputMaybe<Scalars['Int']>;
  policyShopReason?: InputMaybe<ShopReasonType>;
  poolHasCage?: InputMaybe<Scalars['Boolean']>;
  poolHasDivingBoard?: InputMaybe<Scalars['Boolean']>;
  poolHasFence?: InputMaybe<Scalars['Boolean']>;
  poolHasSlide?: InputMaybe<Scalars['Boolean']>;
  poolType?: InputMaybe<PoolType>;
  previousCarrier?: InputMaybe<Scalars['String']>;
  previousCarrierYears?: InputMaybe<Scalars['Int']>;
  previousPolicyExpiry?: InputMaybe<Scalars['Date']>;
  previousPremium?: InputMaybe<Scalars['Decimal']>;
  propertyCity?: InputMaybe<Scalars['String']>;
  propertyState?: InputMaybe<Scalars['UUID']>;
  propertyZipCode?: InputMaybe<Scalars['String']>;
  purchaseDate?: InputMaybe<Scalars['Date']>;
  roof?: InputMaybe<RoofType>;
  roofYearBuilt?: InputMaybe<Scalars['Int']>;
  securitySystem?: InputMaybe<Scalars['Boolean']>;
  securitySystemType?: InputMaybe<SecurityTypeType>;
  squareFootage?: InputMaybe<Scalars['Int']>;
  trampolineSafetyNet?: InputMaybe<Scalars['Boolean']>;
  typeOfProperty?: InputMaybe<PropertyTypeType>;
  typeOfResidence?: InputMaybe<ResidenceType>;
  yearBuilt?: InputMaybe<Scalars['Int']>;
};

/** An enumeration. */
export type PropertyAssetPolicyShopReason =
  /** I'm buying new property (Closing on a new property soon) */
  | 'BUY'
  /** I'm making a change (Looking for better coverage or rates) */
  | 'CHANGE';

/** An enumeration. */
export type PropertyAssetRoof =
  /** ALUMINUM */
  | 'ALUMINUM'
  /** ASBESTOS */
  | 'ASBESTOS'
  /** ASPHALT */
  | 'ASPHALT'
  /** AVERAGE_COMPOSITION_SHINGLE */
  | 'AVERAGE_COMPOSITION_SHINGLE'
  /** BAR_TILE_SPANISH_STYLE */
  | 'BAR_TILE_SPANISH_STYLE'
  /** BI_METAL_TWO_PLY */
  | 'BI_METAL_TWO_PLY'
  /** BUILTUP_LAYERED_ASPHALT */
  | 'BUILTUP_LAYERED_ASPHALT'
  /** CLAY */
  | 'CLAY'
  /** CLAY_TILE */
  | 'CLAY_TILE'
  /** COMPOSITION_SHINGLE */
  | 'COMPOSITION_SHINGLE'
  /** CONCRETE */
  | 'CONCRETE'
  /** CONCRETE_TILE */
  | 'CONCRETE_TILE'
  /** ENAMEL */
  | 'ENAMEL'
  /** FIBERGLASS */
  | 'FIBERGLASS'
  /** FLAT_ROOF */
  | 'FLAT_ROOF'
  /** GALVANIZED */
  | 'GALVANIZED'
  /** GYPSUM */
  | 'GYPSUM'
  /** HEAVY_COMPOSITION_SHINGLE */
  | 'HEAVY_COMPOSITION_SHINGLE'
  /** LIGHT_COMPOSITION_SHINGLE */
  | 'LIGHT_COMPOSITION_SHINGLE'
  /** MASONITE_CEMENT_SHAKE */
  | 'MASONITE_CEMENT_SHAKE'
  /** MEDIUM_SHAKE */
  | 'MEDIUM_SHAKE'
  /** METAL */
  | 'METAL'
  /** NOT_AVAILABLE */
  | 'NOT_AVAILABLE'
  /** NP */
  | 'NP'
  /** OTHER */
  | 'OTHER'
  /** OTHER_NOT_CLASSIFIED */
  | 'OTHER_NOT_CLASSIFIED'
  /** ROCK_GRAVEL */
  | 'ROCK_GRAVEL'
  /** ROLL_COMPOSITION_ROLLED_MINERAL_ROOF */
  | 'ROLL_COMPOSITION_ROLLED_MINERAL_ROOF'
  /** ROLL_PAPER_ROLLED_SMOOTH_ROOF */
  | 'ROLL_PAPER_ROLLED_SMOOTH_ROOF'
  /** ROLL_TAR_GRAVEL */
  | 'ROLL_TAR_GRAVEL'
  /** RUBBER_ELASTOMETRIC */
  | 'RUBBER_ELASTOMETRIC'
  /** SHAKE */
  | 'SHAKE'
  /** SHINGLE */
  | 'SHINGLE'
  /** SHINGLES */
  | 'SHINGLES'
  /** SLATE */
  | 'SLATE'
  /** SLATE_TILE */
  | 'SLATE_TILE'
  /** STEEL_METAL */
  | 'STEEL_METAL'
  /** SYNTHETIC_TILE */
  | 'SYNTHETIC_TILE'
  /** TILE */
  | 'TILE'
  /** UNKNOWN */
  | 'UNKNOWN'
  /** UNKNOWN_OR_NOT_PROVIDED */
  | 'UNKNOWN_OR_NOT_PROVIDED'
  /** URETHANE */
  | 'URETHANE'
  /** WOOD */
  | 'WOOD'
  /** WOOD_SHAKE_SHINGLE */
  | 'WOOD_SHAKE_SHINGLE'
  /** WOOD_SHINGLE */
  | 'WOOD_SHINGLE';

/** An enumeration. */
export type PropertyAssetRoofShape =
  /** ARCHED */
  | 'ARCHED'
  /** A_FRAME */
  | 'A_FRAME'
  /** BARN */
  | 'BARN'
  /** BARREL */
  | 'BARREL'
  /** BOWSTRING_TRUSS */
  | 'BOWSTRING_TRUSS'
  /** BUBBLE */
  | 'BUBBLE'
  /** BUTTERFLY */
  | 'BUTTERFLY'
  /** CANOPY */
  | 'CANOPY'
  /** CATHEDRAL_CLERESTORY */
  | 'CATHEDRAL_CLERESTORY'
  /** COMPLEX_CUSTOM */
  | 'COMPLEX_CUSTOM'
  /** CONTEMPORARY */
  | 'CONTEMPORARY'
  /** DORMER */
  | 'DORMER'
  /** FLAT */
  | 'FLAT'
  /** FRAME */
  | 'FRAME'
  /** GABLE */
  | 'GABLE'
  /** GABLE_HIP */
  | 'GABLE_HIP'
  /** GAMBREL */
  | 'GAMBREL'
  /** GAMBREL_MANSARD */
  | 'GAMBREL_MANSARD'
  /** GEODESIC_DOME */
  | 'GEODESIC_DOME'
  /** HIP */
  | 'HIP'
  /** MANSARD */
  | 'MANSARD'
  /** MONITOR */
  | 'MONITOR'
  /** OTHER */
  | 'OTHER'
  /** PITCHED */
  | 'PITCHED'
  /** PRESTRESS_CONCRETE */
  | 'PRESTRESS_CONCRETE'
  /** PYRAMID */
  | 'PYRAMID'
  /** REINFORCED_CONCRETE */
  | 'REINFORCED_CONCRETE'
  /** RIGID_FRM_BAR_JT */
  | 'RIGID_FRM_BAR_JT'
  /** SAWTOOTH */
  | 'SAWTOOTH'
  /** SHED */
  | 'SHED'
  /** STEEL_FRM_TRUSS */
  | 'STEEL_FRM_TRUSS'
  /** SWISS_CHALET_ALPINE */
  | 'SWISS_CHALET_ALPINE'
  /** WOOD_TRUSS */
  | 'WOOD_TRUSS';

/** An enumeration. */
export type PropertyAssetSewerType =
  /** BYPASS */
  | 'BYPASS'
  /** CESSPOOL */
  | 'CESSPOOL'
  /** COMMERCIAL */
  | 'COMMERCIAL'
  /** DEVELOPED */
  | 'DEVELOPED'
  /** MUNICIPAL */
  | 'MUNICIPAL'
  /** NONE */
  | 'NONE'
  /** NOT_AVAILABLE */
  | 'NOT_AVAILABLE'
  /** NP */
  | 'NP'
  /** PRIVATE */
  | 'PRIVATE'
  /** PUBLIC */
  | 'PUBLIC'
  /** PUBLIC_SEPTIC */
  | 'PUBLIC_SEPTIC'
  /** SANITARY */
  | 'SANITARY'
  /** SEPTIC */
  | 'SEPTIC'
  /** STORM */
  | 'STORM'
  /** UNKNOWN */
  | 'UNKNOWN'
  /** YES */
  | 'YES';

/** An enumeration. */
export type PropertyAssetSubType =
  /** AGRICULTURE_FARMING */
  | 'AGRICULTURE_FARMING'
  /** COMMERCIAL */
  | 'COMMERCIAL'
  /** INDUSTRIAL */
  | 'INDUSTRIAL'
  /** OTHER */
  | 'OTHER'
  /** OTHER_UNKNOWN */
  | 'OTHER_UNKNOWN'
  /** PUBLIC_WORKS */
  | 'PUBLIC_WORKS'
  /** RESIDENTIAL */
  | 'RESIDENTIAL'
  /** VACANT_LAND */
  | 'VACANT_LAND';

/** An enumeration. */
export type PropertyAssetTypeOfProperty =
  /** House */
  | 'HO3'
  /** Condo */
  | 'HO6';

/** An enumeration. */
export type PropertyAssetTypeOfResidence =
  /** Primary */
  | 'PRIMARY'
  /** Rented */
  | 'RENTED'
  /** Secondary */
  | 'SECONDARY'
  /** Vacant */
  | 'VACANT';

/** An enumeration. */
export type PropertyAssetWallType =
  /** ADOBE */
  | 'ADOBE'
  /** ALUMINUM_LAP */
  | 'ALUMINUM_LAP'
  /** ALUMINUM_SIDING */
  | 'ALUMINUM_SIDING'
  /** ALUMINUM_VINYL */
  | 'ALUMINUM_VINYL'
  /** ASBESTOS */
  | 'ASBESTOS'
  /** ASBESTOS_FRAME */
  | 'ASBESTOS_FRAME'
  /** ASPHT_SHINGLE */
  | 'ASPHT_SHINGLE'
  /** BAKED_ENAMEL */
  | 'BAKED_ENAMEL'
  /** BAT_BOARD */
  | 'BAT_BOARD'
  /** BEVEL_FINISHING_STYLE */
  | 'BEVEL_FINISHING_STYLE'
  /** BLOCK */
  | 'BLOCK'
  /** BLOCK_MASONRY */
  | 'BLOCK_MASONRY'
  /** BOARD_BATTEN */
  | 'BOARD_BATTEN'
  /** BRICK */
  | 'BRICK'
  /** BRICK_FRAME_STONE */
  | 'BRICK_FRAME_STONE'
  /** BRICK_STONE_BRICK_AND_OR_STONE */
  | 'BRICK_STONE_BRICK_AND_OR_STONE'
  /** BRICK_VENEER */
  | 'BRICK_VENEER'
  /** BRICK_WOOD */
  | 'BRICK_WOOD'
  /** BUTTRESSED */
  | 'BUTTRESSED'
  /** CEDAR */
  | 'CEDAR'
  /** CERAMIC_TILE */
  | 'CERAMIC_TILE'
  /** CHANNEL */
  | 'CHANNEL'
  /** CINDER_BLOCK */
  | 'CINDER_BLOCK'
  /** CLAY_TILE */
  | 'CLAY_TILE'
  /** COMB */
  | 'COMB'
  /** COMBINATION */
  | 'COMBINATION'
  /** COMPOSITION_COMPOSITE */
  | 'COMPOSITION_COMPOSITE'
  /** CONCRETE */
  | 'CONCRETE'
  /** CONCRETE_BLOCK */
  | 'CONCRETE_BLOCK'
  /** CONCRETE_BLOCK_STUCCO */
  | 'CONCRETE_BLOCK_STUCCO'
  /** CONCRETE_CINDER_BLOCK */
  | 'CONCRETE_CINDER_BLOCK'
  /** CONCRETE_TILE */
  | 'CONCRETE_TILE'
  /** CURTAIN */
  | 'CURTAIN'
  /** DIAGONAL */
  | 'DIAGONAL'
  /** DROP */
  | 'DROP'
  /** EIFS_SYNTHETIC_STUCCO */
  | 'EIFS_SYNTHETIC_STUCCO'
  /** FARM_SINGLE */
  | 'FARM_SINGLE'
  /** FIBER_CEMENT_SIDING_HARDI_BOARD_HARDI_PLANK */
  | 'FIBER_CEMENT_SIDING_HARDI_BOARD_HARDI_PLANK'
  /** FRAME_ALUMINUM */
  | 'FRAME_ALUMINUM'
  /** FRAME_BRICK */
  | 'FRAME_BRICK'
  /** FRAME_MASONRY */
  | 'FRAME_MASONRY'
  /** FRAME_MASONRY_VENEER */
  | 'FRAME_MASONRY_VENEER'
  /** FRAME_SHINGLE_SIDING */
  | 'FRAME_SHINGLE_SIDING'
  /** FRAME_SIDING */
  | 'FRAME_SIDING'
  /** FRAME_STONE */
  | 'FRAME_STONE'
  /** FRAME_STUCCO */
  | 'FRAME_STUCCO'
  /** FRAME_VINYL */
  | 'FRAME_VINYL'
  /** FRAME_WOOD */
  | 'FRAME_WOOD'
  /** GLASS */
  | 'GLASS'
  /** HARDWOOD_SIDING */
  | 'HARDWOOD_SIDING'
  /** HORIZONTAL */
  | 'HORIZONTAL'
  /** LAP */
  | 'LAP'
  /** LOGS */
  | 'LOGS'
  /** LOG_1_2_ROUND */
  | 'LOG_1_2_ROUND'
  /** MARBLE */
  | 'MARBLE'
  /** MARBLECRETE */
  | 'MARBLECRETE'
  /** MASONITE */
  | 'MASONITE'
  /** MASONRY_STUCCO */
  | 'MASONRY_STUCCO'
  /** METAL */
  | 'METAL'
  /** METAL_SIDING */
  | 'METAL_SIDING'
  /** MODULAR */
  | 'MODULAR'
  /** NONE */
  | 'NONE'
  /** NOT_AVAILABLE */
  | 'NOT_AVAILABLE'
  /** NP */
  | 'NP'
  /** OTHER */
  | 'OTHER'
  /** OTHER_NOT_CLASSIFIED */
  | 'OTHER_NOT_CLASSIFIED'
  /** PANEL */
  | 'PANEL'
  /** PAPER */
  | 'PAPER'
  /** PLYWOOD */
  | 'PLYWOOD'
  /** POLE */
  | 'POLE'
  /** PRECAST_CONCRETE_PANEL */
  | 'PRECAST_CONCRETE_PANEL'
  /** PREFAB_WOOD */
  | 'PREFAB_WOOD'
  /** PRE_CAST */
  | 'PRE_CAST'
  /** PROTECTIVE_TREATMENT */
  | 'PROTECTIVE_TREATMENT'
  /** RIBBED */
  | 'RIBBED'
  /** RIBBED_ALUMINUM */
  | 'RIBBED_ALUMINUM'
  /** RUSTIC */
  | 'RUSTIC'
  /** SHAKE */
  | 'SHAKE'
  /** SHINGLES */
  | 'SHINGLES'
  /** SIDING */
  | 'SIDING'
  /** SIDING_ALUM_VINYL */
  | 'SIDING_ALUM_VINYL'
  /** SIDING_NOT_SPECIFIED */
  | 'SIDING_NOT_SPECIFIED'
  /** SINGLE_WALL */
  | 'SINGLE_WALL'
  /** SLUMP_BLOCK */
  | 'SLUMP_BLOCK'
  /** STEEL_PANEL */
  | 'STEEL_PANEL'
  /** STONE */
  | 'STONE'
  /** STONE_VENEER */
  | 'STONE_VENEER'
  /** STONE_WOOD_FRAME */
  | 'STONE_WOOD_FRAME'
  /** STRUT_FRAME */
  | 'STRUT_FRAME'
  /** STUCCO */
  | 'STUCCO'
  /** T111 */
  | 'T111'
  /** TBD */
  | 'TBD'
  /** TILE */
  | 'TILE'
  /** TONG_GROOVE */
  | 'TONG_GROOVE'
  /** UNKNOWN */
  | 'UNKNOWN'
  /** VERTICAL */
  | 'VERTICAL'
  /** VINYL */
  | 'VINYL'
  /** WOOD */
  | 'WOOD'
  /** WOOD_FRAME */
  | 'WOOD_FRAME'
  /** WOOD_FRAME_SIDING */
  | 'WOOD_FRAME_SIDING'
  /** WOOD_SHINGLE */
  | 'WOOD_SHINGLE'
  /** WOOD_SIDING */
  | 'WOOD_SIDING'
  /** WOOD_STEEL_STUD */
  | 'WOOD_STEEL_STUD'
  /** $2X2_FRAME */
  | '_2X2_FRAME'
  /** $2X3_FRAME */
  | '_2X3_FRAME'
  /** $2X4_FRAME */
  | '_2X4_FRAME'
  /** $2X6_FRAME */
  | '_2X6_FRAME'
  /** $8_INCH_PAINT */
  | '_8_INCH_PAINT';

/** An enumeration. */
export type PropertyDamageCoverageType =
  | 'A_10000'
  | 'A_15000'
  | 'A_25000'
  | 'A_50000'
  | 'A_100000'
  | 'A_250000'
  | 'A_500000'
  | 'A_NoSPACECoverage'
  | 'A_StateSPACEMinimum';

export type PropertyOrRentalAddressInput = {
  addressLine: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  category: HomeCategoryType;
  city: Scalars['String'];
  state: Scalars['UUID'];
  userId?: InputMaybe<Scalars['UUID']>;
  zipCode: Scalars['String'];
};

export type PropertyOrRentalAddressType = {
  __typename: 'PropertyOrRentalAddressType';
  address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
};

export type PropertyType = {
  __typename: 'PropertyType';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  apn?: Maybe<Scalars['String']>;
  assessedImprovementValue?: Maybe<Scalars['Float']>;
  assessedLandValue?: Maybe<Scalars['Float']>;
  assessedTotalValue?: Maybe<Scalars['Float']>;
  buildingShape?: Maybe<PropertyAssetBuildingShape>;
  canopyId?: Maybe<Scalars['UUID']>;
  cashValue?: Maybe<Scalars['Float']>;
  construction?: Maybe<PropertyAssetConstruction>;
  constructionQuality?: Maybe<PropertyAssetConstructionQuality>;
  coolingType?: Maybe<PropertyAssetCoolingType>;
  created?: Maybe<Scalars['DateTime']>;
  deductibleHome?: Maybe<HomeDeductibleLimitType>;
  deductibleWind?: Maybe<WindDeductibleLimitType>;
  dwellingClass?: Maybe<PropertyAssetDwellingClass>;
  electricalUpdated?: Maybe<Scalars['Int']>;
  energyType?: Maybe<PropertyAssetEnergyType>;
  fireAlarm?: Maybe<Scalars['Boolean']>;
  fireAlarmType?: Maybe<SecurityTypeType>;
  fireplaceType?: Maybe<PropertyAssetFireplaceType>;
  firstMortgageAmount?: Maybe<Scalars['Float']>;
  firstMortgageLender?: Maybe<Scalars['String']>;
  foundation?: Maybe<PropertyAssetFoundation>;
  frameType?: Maybe<PropertyAssetFrameType>;
  garageSquareFt?: Maybe<Scalars['Int']>;
  garageType?: Maybe<PropertyAssetGarageType>;
  hasDogs?: Maybe<Scalars['Boolean']>;
  hasFireplace?: Maybe<Scalars['Boolean']>;
  hasPool?: Maybe<Scalars['Boolean']>;
  hasTrampoline?: Maybe<Scalars['Boolean']>;
  heatingAndCoolingUpdated?: Maybe<Scalars['Int']>;
  heatingFuel?: Maybe<PropertyAssetHeatingFuel>;
  heatingType?: Maybe<PropertyAssetHeatingType>;
  id: Scalars['UUID'];
  isGatedCommunity?: Maybe<Scalars['Boolean']>;
  marketImprovementValue?: Maybe<Scalars['Float']>;
  marketLandValue?: Maybe<Scalars['Float']>;
  modified?: Maybe<Scalars['DateTime']>;
  numBathsFull?: Maybe<Scalars['Int']>;
  numBathsPartial?: Maybe<Scalars['Int']>;
  numBeds?: Maybe<Scalars['Int']>;
  numFireplaces?: Maybe<Scalars['Int']>;
  numParkingSpaces?: Maybe<Scalars['Int']>;
  numStories?: Maybe<Scalars['Float']>;
  numUnits?: Maybe<Scalars['Int']>;
  occupancyInfo?: Maybe<Scalars['String']>;
  owner1FirstName?: Maybe<Scalars['String']>;
  owner1LastName?: Maybe<Scalars['String']>;
  owner2FirstName?: Maybe<Scalars['String']>;
  owner2LastName?: Maybe<Scalars['String']>;
  owner3FirstName?: Maybe<Scalars['String']>;
  owner3LastName?: Maybe<Scalars['String']>;
  owner4FirstName?: Maybe<Scalars['String']>;
  owner4LastName?: Maybe<Scalars['String']>;
  plumbingUpdated?: Maybe<Scalars['Int']>;
  policies: Array<HomePolicyType>;
  policyShopReason?: Maybe<PropertyAssetPolicyShopReason>;
  poolHasCage?: Maybe<Scalars['Boolean']>;
  poolHasDivingBoard?: Maybe<Scalars['Boolean']>;
  poolHasFence?: Maybe<Scalars['Boolean']>;
  poolHasSlide?: Maybe<Scalars['Boolean']>;
  poolType?: Maybe<PoolType>;
  previousCarrier?: Maybe<Scalars['String']>;
  previousCarrierYears?: Maybe<Scalars['Int']>;
  previousPolicyExpiry?: Maybe<Scalars['Date']>;
  previousPremium?: Maybe<Scalars['Float']>;
  propertyCity?: Maybe<Scalars['String']>;
  propertyState?: Maybe<StateType>;
  propertyZipCode?: Maybe<Scalars['String']>;
  purchaseDate?: Maybe<Scalars['Date']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  replacementCost?: Maybe<Scalars['Float']>;
  roof?: Maybe<PropertyAssetRoof>;
  roofShape?: Maybe<PropertyAssetRoofShape>;
  roofYearBuilt?: Maybe<Scalars['Int']>;
  secondMortgageAmount?: Maybe<Scalars['Float']>;
  secondMortgageLender?: Maybe<Scalars['String']>;
  securitySystem?: Maybe<Scalars['Boolean']>;
  securitySystemType?: Maybe<SecurityTypeType>;
  sewerType?: Maybe<PropertyAssetSewerType>;
  shoppingCarts: Array<ShoppingCartType>;
  squareFootage?: Maybe<Scalars['Int']>;
  subType?: Maybe<PropertyAssetSubType>;
  trampolineSafetyNet?: Maybe<Scalars['Boolean']>;
  typeOfProperty?: Maybe<PropertyAssetTypeOfProperty>;
  typeOfResidence?: Maybe<PropertyAssetTypeOfResidence>;
  user: UserType;
  wallType?: Maybe<PropertyAssetWallType>;
  yearBuilt?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export type PropertyTypeType =
  | 'HO3'
  | 'HO6';

export type Query = {
  __typename: 'Query';
  activities?: Maybe<Array<ActivityType>>;
  appUpdateReminder?: Maybe<AppUpdateReminderType>;
  appleWalletPolicyCard?: Maybe<Scalars['String']>;
  areCarrierCredentialsValid?: Maybe<Scalars['Boolean']>;
  banners?: Maybe<Array<BannerType>>;
  bindableOffers?: Maybe<Array<BindableOfferType>>;
  canopyPoll?: Maybe<CanopyConnectResponseType>;
  canopyTermsOfService?: Maybe<CanopyTosType>;
  carrierReviews?: Maybe<Array<Maybe<CarrierReviewType>>>;
  carriers?: Maybe<CarrierPaginatedType>;
  coverageItemsInfo?: Maybe<Array<CoverageItemInfoType>>;
  documentUrl?: Maybe<Scalars['String']>;
  drivers?: Maybe<Array<Maybe<DriverType>>>;
  engagementCards?: Maybe<Array<EngagementCardType>>;
  featureItems?: Maybe<Array<FeatureItemType>>;
  feedbackQuestions?: Maybe<Array<FeedbackQuestionType>>;
  healthCarriers?: Maybe<Array<Maybe<HealthCarrierType>>>;
  healthInsureds?: Maybe<Array<Maybe<HealthInsuredType>>>;
  healthPolicies?: Maybe<Array<Maybe<HealthPolicyType>>>;
  homeOwners?: Maybe<Array<Maybe<HomeOwnerType>>>;
  impressionGroups?: Maybe<Array<ImpressionGroupType>>;
  impressions?: Maybe<Array<ImpressionType>>;
  isCarrierCheckable?: Maybe<Scalars['Boolean']>;
  marketingLandingData?: Maybe<MarketingLandingDataType>;
  me?: Maybe<UserType>;
  namedInsureds?: Maybe<Array<Maybe<NamedInsuredType>>>;
  otherPolicies?: Maybe<Array<OtherPolicyType>>;
  paginatedActivities?: Maybe<ActivityPaginatedType>;
  partnerOffers?: Maybe<Array<PartnerOfferType>>;
  partnersLandingData?: Maybe<Array<Scalars['String']>>;
  paymentPageDetails?: Maybe<PaymentPageType>;
  petOwners?: Maybe<Array<Maybe<PetOwnerType>>>;
  pets?: Maybe<Array<Maybe<PetType>>>;
  policies?: Maybe<Array<Maybe<PolicyUnionType>>>;
  policyDocuments?: Maybe<Array<PolicyDocumentType>>;
  products?: Maybe<Array<Maybe<RedemptionProductType>>>;
  properties?: Maybe<Array<Maybe<PropertyType>>>;
  rateFilings?: Maybe<Array<RateFilingType>>;
  redemptions?: Maybe<Array<Maybe<RedemptionRequestType>>>;
  reminders?: Maybe<Array<ReminderType>>;
  renewalDocumentUrl?: Maybe<Scalars['String']>;
  rentals?: Maybe<Array<Maybe<RentalType>>>;
  renters?: Maybe<Array<Maybe<RenterType>>>;
  rewards?: Maybe<Array<RewardType>>;
  shareablePolicy?: Maybe<ShareablePolicyType>;
  shopUserAssetsAndNamedInsureds?: Maybe<ShopUserProfileType>;
  shoppingCarts?: Maybe<Array<ShoppingCartType>>;
  siteConfiguration?: Maybe<SiteConfigurationType>;
  states?: Maybe<Array<StateType>>;
  vehicles?: Maybe<Array<Maybe<VehicleType>>>;
};


export type QueryAppUpdateReminderArgs = {
  buildVersion: Scalars['Int'];
};


export type QueryAppleWalletPolicyCardArgs = {
  policyId: Scalars['UUID'];
};


export type QueryAreCarrierCredentialsValidArgs = {
  carrierId: Scalars['UUID'];
  password: Scalars['String'];
  username: Scalars['String'];
};


export type QueryBannersArgs = {
  source: SourceType;
};


export type QueryCanopyPollArgs = {
  category: CategoryType;
  email?: InputMaybe<Scalars['String']>;
  insurerName: Scalars['String'];
  policyId?: InputMaybe<Scalars['UUID']>;
  pullId: Scalars['String'];
  pullJwt: Scalars['String'];
};


export type QueryCarriersArgs = {
  canopyCarrier?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<CategoryType>;
  insuranceInsider?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByInputType>>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  searchByIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryDocumentUrlArgs = {
  documentId: Scalars['UUID'];
};


export type QueryFeedbackQuestionsArgs = {
  path: Scalars['String'];
};


export type QueryHealthCarriersArgs = {
  category?: InputMaybe<HealthCategoryType>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryHealthPoliciesArgs = {
  isCurrent?: InputMaybe<Scalars['Boolean']>;
};


export type QueryImpressionsArgs = {
  category?: InputMaybe<ShoppingCategoryType>;
  creditScore?: InputMaybe<CreditScoreType>;
  dob?: InputMaybe<Scalars['Date']>;
  gender?: InputMaybe<GenderType>;
  isHomeOwner?: InputMaybe<Scalars['Boolean']>;
  isInsuredForAuto?: InputMaybe<Scalars['Boolean']>;
  petBreed?: InputMaybe<Scalars['String']>;
  petGender?: InputMaybe<PetGenderType>;
  petType?: InputMaybe<PetTypeType>;
  policyId?: InputMaybe<Scalars['UUID']>;
  usesTobacco?: InputMaybe<Scalars['Boolean']>;
  zipCode: Scalars['String'];
};


export type QueryIsCarrierCheckableArgs = {
  carrierId: Scalars['UUID'];
};


export type QueryMarketingLandingDataArgs = {
  partnerSlug: Scalars['String'];
};


export type QueryPaginatedActivitiesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryPartnerOffersArgs = {
  category?: InputMaybe<ShoppingCategoryType>;
};


export type QueryPaymentPageDetailsArgs = {
  offerId: Scalars['UUID'];
};


export type QueryPoliciesArgs = {
  isCurrent?: InputMaybe<Scalars['Boolean']>;
};


export type QueryProductsArgs = {
  iosActive?: InputMaybe<Scalars['Boolean']>;
};


export type QueryRemindersArgs = {
  reminderCategory?: InputMaybe<ReminderCategoryType>;
};


export type QueryRenewalDocumentUrlArgs = {
  renewalDocumentId: Scalars['UUID'];
};


export type QueryRewardsArgs = {
  isFirstStep?: InputMaybe<Scalars['Boolean']>;
};


export type QueryShareablePolicyArgs = {
  shareableId: Scalars['UUID'];
};


export type QueryShopUserAssetsAndNamedInsuredsArgs = {
  category: CategoryType;
  userId: Scalars['UUID'];
};

/** An enumeration. */
export type RateFilingCategoryType =
  | 'ALL'
  | 'AUTO'
  | 'HOME'
  | 'LIFE'
  | 'PET'
  | 'RENTER';

export type RateFilingType = {
  __typename: 'RateFilingType';
  carrier?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  dateOfFiling?: Maybe<Scalars['Date']>;
  effectiveDate: Scalars['Date'];
  id: Scalars['UUID'];
  modified?: Maybe<Scalars['DateTime']>;
  policyCategory?: Maybe<RateFilingCategoryType>;
  rateChange: Scalars['String'];
  states?: Maybe<Array<Scalars['String']>>;
};

export type ReadAllFeatureItems = {
  __typename: 'ReadAllFeatureItems';
  ok?: Maybe<Scalars['Boolean']>;
};

export type ReadFeatureItem = {
  __typename: 'ReadFeatureItem';
  ok?: Maybe<Scalars['Boolean']>;
};

export type RedemptionProductType = {
  __typename: 'RedemptionProductType';
  active: Scalars['Boolean'];
  /** How many marbles are $1 for this redemption offer? */
  conversionRatio?: Maybe<Scalars['Int']>;
  id: Scalars['UUID'];
  isDonation?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Scalars['String']>;
  logoCard?: Maybe<Scalars['String']>;
  maximumAmount?: Maybe<Scalars['Int']>;
  minimumAmount?: Maybe<Scalars['Int']>;
  productName: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type RedemptionRequestInput = {
  amountRedeemed: Scalars['Int'];
  code?: InputMaybe<Scalars['String']>;
  productId: Scalars['String'];
};

export type RedemptionRequestType = {
  __typename: 'RedemptionRequestType';
  amountRedeemed: Scalars['Int'];
  created?: Maybe<Scalars['DateTime']>;
  fees?: Maybe<Scalars['Float']>;
  id: Scalars['UUID'];
  message?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  providerReferenceId?: Maybe<Scalars['String']>;
  providerStatus?: Maybe<Scalars['String']>;
  redemptionCode?: Maybe<Scalars['String']>;
  redemptionCodeType?: Maybe<Scalars['String']>;
  redemptionInstructions?: Maybe<Scalars['String']>;
  redemptionOption: RedemptionProductType;
  redemptionUrl?: Maybe<Scalars['String']>;
  status: RequestStatus;
  timeOfFulfillment?: Maybe<Scalars['DateTime']>;
  timeOfRedemption?: Maybe<Scalars['DateTime']>;
  user: UserType;
};

export type ReferralEmail = {
  __typename: 'ReferralEmail';
  ok?: Maybe<Scalars['Boolean']>;
};

export type ReferralEmailInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
};

export type ReferralText = {
  __typename: 'ReferralText';
  ok?: Maybe<Scalars['Boolean']>;
};

export type ReferralTextInput = {
  phone?: InputMaybe<Scalars['String']>;
};

export type ReferralType = {
  __typename: 'ReferralType';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  memberSince?: Maybe<Scalars['Date']>;
};

export type RegisterInput = {
  captchaValue?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  entrySource?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  insuranceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lastName?: InputMaybe<Scalars['String']>;
  motivations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  password: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  referralCode?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<SourceType>;
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  utmTerm?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export type RelationShipToMarbleMemberType =
  | 'CHILD'
  | 'DOMESTIC_PARTNER'
  | 'OTHER'
  | 'PARENT'
  | 'ROOMMATE'
  | 'SELF'
  | 'SPOUSE';

/** An enumeration. */
export type RelationshipToPrimaryType =
  | 'CHILD'
  | 'DOMESTIC_PARTNER'
  | 'OTHER'
  | 'PARENT'
  | 'SPOUSE';

/** An enumeration. */
export type ReminderCategoryType =
  | 'SHOPPING';

/** An enumeration. */
export type ReminderMethodType =
  | 'EMAIL'
  | 'TEXT';

export type ReminderType = {
  __typename: 'ReminderType';
  created?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  modified?: Maybe<Scalars['DateTime']>;
  notes?: Maybe<Scalars['String']>;
  policy?: Maybe<PolicyType>;
  policyCategory?: Maybe<CategoryType>;
  reminderCategory?: Maybe<ReminderCategoryType>;
  reminderDate: Scalars['DateTime'];
  reminderMethod: ReminderMethodType;
  user: UserType;
};

export type RemoveDriver = {
  __typename: 'RemoveDriver';
  ok?: Maybe<Scalars['Boolean']>;
};

export type RemoveDriverInput = {
  id: Scalars['UUID'];
};

export type RemoveHomeOwner = {
  __typename: 'RemoveHomeOwner';
  ok?: Maybe<Scalars['Boolean']>;
};

export type RemoveHomeOwnerInput = {
  id: Scalars['UUID'];
};

export type RemovePetAsset = {
  __typename: 'RemovePetAsset';
  ok?: Maybe<Scalars['Boolean']>;
};

export type RemovePetAssetInput = {
  id: Scalars['UUID'];
};

export type RemovePetOwner = {
  __typename: 'RemovePetOwner';
  ok?: Maybe<Scalars['Boolean']>;
};

export type RemovePetOwnerInput = {
  id: Scalars['UUID'];
};

export type RemovePropertyAsset = {
  __typename: 'RemovePropertyAsset';
  ok?: Maybe<Scalars['Boolean']>;
};

export type RemovePropertyAssetInput = {
  id: Scalars['UUID'];
};

export type RemoveRentalAsset = {
  __typename: 'RemoveRentalAsset';
  ok?: Maybe<Scalars['Boolean']>;
};

export type RemoveRentalAssetInput = {
  id: Scalars['UUID'];
};

export type RemoveRenter = {
  __typename: 'RemoveRenter';
  ok?: Maybe<Scalars['Boolean']>;
};

export type RemoveRenterInput = {
  id: Scalars['UUID'];
};

export type RemoveShareableId = {
  __typename: 'RemoveShareableId';
  ok?: Maybe<Scalars['Boolean']>;
};

export type RemoveSharedAccess = {
  __typename: 'RemoveSharedAccess';
  ok?: Maybe<Scalars['Boolean']>;
};

export type RemoveVehicleAsset = {
  __typename: 'RemoveVehicleAsset';
  ok?: Maybe<Scalars['Boolean']>;
};

export type RemoveVehicleAssetInput = {
  id: Scalars['UUID'];
};

export type RenameDocumentInput = {
  id: Scalars['UUID'];
  name: Scalars['String'];
};

export type RenewalOfferInput = {
  document?: InputMaybe<OfferDocumentInput>;
  offerId?: InputMaybe<Scalars['UUID']>;
  policyId: Scalars['UUID'];
  premium: Scalars['Float'];
  termMonths?: InputMaybe<Scalars['Int']>;
};

export type RentalAssetInput = {
  addressLine?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  commercialUse?: InputMaybe<Scalars['Boolean']>;
  currentUnit?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  state?: InputMaybe<Scalars['UUID']>;
  typeOfProperty?: InputMaybe<RentalPropertyType>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export type RentalAssetTypeOfProperty =
  /** Apartment */
  | 'APARTMENT'
  /** Condo */
  | 'CONDO'
  /** House */
  | 'HOUSE'
  /** Other */
  | 'OTHER';

/** An enumeration. */
export type RentalCoverageType =
  | 'A_20SLASH600'
  | 'A_30SLASH900'
  | 'A_40SLASH1200'
  | 'A_50SLASH1500'
  | 'A_75SLASH2250'
  | 'A_NoSPACECoverage';

/** An enumeration. */
export type RentalPropertyType =
  | 'APARTMENT'
  | 'CONDO'
  | 'HOUSE'
  | 'OTHER';

export type RentalType = {
  __typename: 'RentalType';
  address?: Maybe<Scalars['String']>;
  addressLine?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  commercialUse?: Maybe<Scalars['Boolean']>;
  created?: Maybe<Scalars['DateTime']>;
  currentUnit?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  modified?: Maybe<Scalars['DateTime']>;
  policies: Array<RenterPolicyType>;
  shoppingCarts: Array<ShoppingCartType>;
  state?: Maybe<StateType>;
  typeOfProperty?: Maybe<RentalAssetTypeOfProperty>;
  user: UserType;
  zipCode?: Maybe<Scalars['String']>;
};

export type RenterInput = {
  address?: InputMaybe<Scalars['String']>;
  careerStatus?: InputMaybe<CareerStatusType>;
  city?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['Date']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<GenderType>;
  id?: InputMaybe<Scalars['UUID']>;
  lastName?: InputMaybe<Scalars['String']>;
  maritalStatus?: InputMaybe<MaritalStatusType>;
  phone?: InputMaybe<Scalars['String']>;
  relationToMarbleMember?: InputMaybe<RelationShipToMarbleMemberType>;
  relationshipToPrimaryRenter?: InputMaybe<RelationshipToPrimaryType>;
  state?: InputMaybe<Scalars['UUID']>;
  usePrimaryAddress?: InputMaybe<Scalars['Boolean']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type RenterPolicyType = {
  __typename: 'RenterPolicyType';
  address?: Maybe<Scalars['String']>;
  archiveDate?: Maybe<Scalars['DateTime']>;
  basicSyncFailed: Scalars['Boolean'];
  canopyEmbeddedCarrier?: Maybe<Scalars['String']>;
  carrier?: Maybe<CarrierType>;
  category?: Maybe<CategoryType>;
  continuous: Scalars['Boolean'];
  coverageSynced: Scalars['Boolean'];
  deductible?: Maybe<Scalars['Float']>;
  documents?: Maybe<Array<PolicyDocumentType>>;
  endDate?: Maybe<Scalars['Date']>;
  fees?: Maybe<Scalars['Float']>;
  historyId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  isOnRenewal?: Maybe<Scalars['Boolean']>;
  isPolicyOwner?: Maybe<Scalars['Boolean']>;
  lossUse?: Maybe<Scalars['Float']>;
  medicalOthers?: Maybe<Scalars['Float']>;
  namedInsured?: Maybe<Array<Scalars['String']>>;
  nextPaymentDue?: Maybe<Scalars['Date']>;
  personalLiability?: Maybe<Scalars['Float']>;
  personalProperty?: Maybe<Scalars['Float']>;
  policyHistory?: Maybe<Array<PolicyHistoryType>>;
  policyNumber?: Maybe<Scalars['String']>;
  policyPremium?: Maybe<Scalars['Float']>;
  premiumPeriod?: Maybe<PremiumPeriodType>;
  rentals: Array<RentalType>;
  renters: Array<RenterType>;
  shareableId?: Maybe<Scalars['UUID']>;
  sharedAccess?: Maybe<Array<SharedAccessType>>;
  showSyncAnimation: Scalars['Boolean'];
  startDate?: Maybe<Scalars['Date']>;
  syncFailureReason?: Maybe<SyncFailureReasonType>;
  synced: Scalars['Boolean'];
  total?: Maybe<Scalars['Float']>;
  user: UserType;
  wrongDocumentType?: Maybe<WrongDocumentTypeType>;
};

export type RenterType = {
  __typename: 'RenterType';
  address?: Maybe<Scalars['String']>;
  aiqData?: Maybe<Scalars['Boolean']>;
  altNames?: Maybe<Array<Scalars['String']>>;
  careerStatus?: Maybe<NamedInsuredBaseCareerStatus>;
  city?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  dob?: Maybe<Scalars['Date']>;
  driversLicenseNumber?: Maybe<Scalars['String']>;
  driversLicenseState?: Maybe<StateType>;
  educationLevel?: Maybe<NamedInsuredBaseEducationLevel>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<GenderType>;
  id: Scalars['UUID'];
  lastName?: Maybe<Scalars['String']>;
  maritalStatus?: Maybe<NamedInsuredBaseMaritalStatus>;
  modified?: Maybe<Scalars['DateTime']>;
  namedinsuredbasePtr: NamedInsuredReturnType;
  parentId?: Maybe<Scalars['UUID']>;
  relationToMarbleMember?: Maybe<NamedInsuredBaseRelationToMarbleMember>;
  renterPolicies: Array<RenterPolicyType>;
  shoppingCarts: Array<ShoppingCartType>;
  state?: Maybe<StateType>;
  usePrimaryAddress?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserType>;
  zipCode?: Maybe<Scalars['String']>;
};

export type RequestPhoneVerificationCode = {
  __typename: 'RequestPhoneVerificationCode';
  ok?: Maybe<Scalars['Boolean']>;
};

export type RequestQuoteInfo = {
  __typename: 'RequestQuoteInfo';
  ok?: Maybe<Scalars['Boolean']>;
};

export type RequestQuoteInfoInput = {
  method?: InputMaybe<MethodType>;
  offerId: Scalars['UUID'];
  phone?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export type RequestStatus =
  /** Pending */
  | 'PENDING'
  /** Processed */
  | 'PROCESSED'
  /** Rejected */
  | 'REJECTED';

export type ResetPasswordInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
};

export type ResetPasswordPayload = {
  __typename: 'ResetPasswordPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

/** An enumeration. */
export type ResidenceType =
  | 'PRIMARY'
  | 'RENTED'
  | 'SECONDARY'
  | 'VACANT';

export type RestoreOffer = {
  __typename: 'RestoreOffer';
  ok?: Maybe<Scalars['Boolean']>;
};

export type RewardType = {
  __typename: 'RewardType';
  completed: Scalars['Boolean'];
  cta: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  discarded: Scalars['Boolean'];
  featured: Scalars['Boolean'];
  firstStepsOrder?: Maybe<Scalars['Int']>;
  id: Scalars['UUID'];
  /** Unique 4 letter code for this reward. */
  identifier: Scalars['String'];
  marbleValue: Scalars['Int'];
  /** Relative URL for redirecting to. For example: /policies/new */
  redirectUrl?: Maybe<Scalars['String']>;
  remainingEarnings: Scalars['Int'];
  title: Scalars['String'];
};

/** An enumeration. */
export type RoofType =
  | 'ALUMINUM'
  | 'ASBESTOS'
  | 'ASPHALT'
  | 'AVERAGE_COMPOSITION_SHINGLE'
  | 'BAR_TILE_SPANISH_STYLE'
  | 'BI_METAL_TWO_PLY'
  | 'BUILTUP_LAYERED_ASPHALT'
  | 'CLAY'
  | 'CLAY_TILE'
  | 'COMPOSITION_SHINGLE'
  | 'CONCRETE'
  | 'CONCRETE_TILE'
  | 'ENAMEL'
  | 'FIBERGLASS'
  | 'FLAT_ROOF'
  | 'GALVANIZED'
  | 'GYPSUM'
  | 'HEAVY_COMPOSITION_SHINGLE'
  | 'LIGHT_COMPOSITION_SHINGLE'
  | 'MASONITE_CEMENT_SHAKE'
  | 'MEDIUM_SHAKE'
  | 'METAL'
  | 'NOT_AVAILABLE'
  | 'NP'
  | 'OTHER'
  | 'OTHER_NOT_CLASSIFIED'
  | 'ROCK_GRAVEL'
  | 'ROLL_COMPOSITION_ROLLED_MINERAL_ROOF'
  | 'ROLL_PAPER_ROLLED_SMOOTH_ROOF'
  | 'ROLL_TAR_GRAVEL'
  | 'RUBBER_ELASTOMETRIC'
  | 'SHAKE'
  | 'SHINGLE'
  | 'SHINGLES'
  | 'SLATE'
  | 'SLATE_TILE'
  | 'STEEL_METAL'
  | 'SYNTHETIC_TILE'
  | 'TILE'
  | 'UNKNOWN'
  | 'UNKNOWN_OR_NOT_PROVIDED'
  | 'URETHANE'
  | 'WOOD'
  | 'WOOD_SHAKE_SHINGLE'
  | 'WOOD_SHINGLE';

export type SamsungWalletType = {
  __typename: 'SamsungWalletType';
  cardId?: Maybe<Scalars['String']>;
  cdata?: Maybe<Scalars['String']>;
  partnerCode?: Maybe<Scalars['String']>;
  rdClickUrl?: Maybe<Scalars['String']>;
  rdImpressionUrl?: Maybe<Scalars['String']>;
};

export type SavePaymentToken = {
  __typename: 'SavePaymentToken';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SaveShopFlowProgress = {
  __typename: 'SaveShopFlowProgress';
  ok?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export type SecurityTypeType =
  | 'CENTRAL'
  | 'DIRECT'
  | 'LOCAL';

export type SetPasswordInput = {
  password: Scalars['String'];
  repeatPassword: Scalars['String'];
  token: Scalars['String'];
};

export type ShareablePolicyType = {
  __typename: 'ShareablePolicyType';
  address?: Maybe<Scalars['String']>;
  carrier?: Maybe<CarrierType>;
  category?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  namedInsureds?: Maybe<Array<Scalars['String']>>;
  petName?: Maybe<Scalars['String']>;
  petType?: Maybe<Scalars['String']>;
  planType?: Maybe<Scalars['String']>;
  policyNumber?: Maybe<Scalars['String']>;
  shareableId?: Maybe<Scalars['UUID']>;
  startDate?: Maybe<Scalars['Date']>;
  vehicles?: Maybe<Array<Scalars['String']>>;
};

export type SharedAccessInput = {
  email: Scalars['String'];
  namedInsuredId?: InputMaybe<Scalars['UUID']>;
  policyId: Scalars['UUID'];
};

/** An enumeration. */
export type SharedAccessStatusType =
  | 'ACCEPTED'
  | 'CANCELLED'
  | 'PENDING';

export type SharedAccessType = {
  __typename: 'SharedAccessType';
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  namedInsuredId?: Maybe<Scalars['UUID']>;
  status?: Maybe<SharedAccessStatusType>;
};

export type ShopAssetType = {
  __typename: 'ShopAssetType';
  address?: Maybe<Scalars['String']>;
  drivers?: Maybe<Array<ShopDriverType>>;
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};

export type ShopDriverType = {
  __typename: 'ShopDriverType';
  id?: Maybe<Scalars['UUID']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type ShopFormPath = {
  __typename: 'ShopFormPath';
  ok?: Maybe<Scalars['Boolean']>;
};

export type ShopNamedInsuredType = {
  __typename: 'ShopNamedInsuredType';
  dob?: Maybe<Scalars['Date']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<GenderType>;
  id?: Maybe<Scalars['UUID']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export type ShopReasonType =
  | 'BUY'
  | 'CHANGE';

export type ShopSetPasswordInput = {
  captchaValue?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
};

export type ShopUserInput = {
  category: CategoryType;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  userId: Scalars['UUID'];
};

export type ShopUserProfileType = {
  __typename: 'ShopUserProfileType';
  assets?: Maybe<Array<ShopAssetType>>;
  namedInsureds?: Maybe<Array<ShopNamedInsuredType>>;
};

export type ShoppingBeneficiaryType = {
  __typename: 'ShoppingBeneficiaryType';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['Decimal']>;
};

export type ShoppingCartAssetType = {
  __typename: 'ShoppingCartAssetType';
  addressLine?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  breed?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  construction?: Maybe<ConstructionType>;
  dob?: Maybe<Scalars['Date']>;
  fireAlarm?: Maybe<Scalars['Boolean']>;
  foundation?: Maybe<FoundationType>;
  hasBitten?: Maybe<Scalars['Boolean']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ownership?: Maybe<OwnershipStatusType>;
  primaryUse?: Maybe<PrimaryUseType>;
  roof?: Maybe<RoofType>;
  roofYearBuilt?: Maybe<Scalars['Int']>;
  sex?: Maybe<PetGenderType>;
  squareFootage?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['UUID']>;
  typeOfProperty?: Maybe<PropertyTypeType>;
  typeOfResidence?: Maybe<ResidenceType>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
  yearBuilt?: Maybe<Scalars['Int']>;
  zipCode?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export type ShoppingCartCategory =
  /** Auto */
  | 'AUTO'
  /** Home */
  | 'HOME'
  /** Life */
  | 'LIFE'
  /** Pet */
  | 'PET'
  /** Renter */
  | 'RENTER';

export type ShoppingCartDbInput = {
  category: CategoryType;
  isInterestedInBundling?: InputMaybe<Scalars['Boolean']>;
};

export type ShoppingCartInput = {
  category?: InputMaybe<CategoryType>;
  id?: InputMaybe<Scalars['UUID']>;
  policyId?: InputMaybe<Scalars['UUID']>;
  zipCode: Scalars['String'];
};

export type ShoppingCartNamedInsuredType = {
  __typename: 'ShoppingCartNamedInsuredType';
  ageFirstLicensed?: Maybe<Scalars['Int']>;
  currentOccupation?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  driversLicenseNumber?: Maybe<Scalars['String']>;
  driversLicenseState?: Maybe<Scalars['UUID']>;
  educationLevel?: Maybe<EducationLevelType>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<GenderType>;
  id?: Maybe<Scalars['UUID']>;
  lastName?: Maybe<Scalars['String']>;
  maritalStatus?: Maybe<MaritalStatusType>;
};

export type ShoppingCartPolicyType = {
  __typename: 'ShoppingCartPolicyType';
  assets?: Maybe<Array<Maybe<ShoppingCartAssetType>>>;
  continuous?: Maybe<Scalars['Boolean']>;
  coverageDetails?: Maybe<Array<Maybe<CoverageDetailsType>>>;
  endDate?: Maybe<Scalars['Date']>;
  namedInsureds?: Maybe<Array<Maybe<ShoppingCartNamedInsuredType>>>;
  policyId?: Maybe<Scalars['UUID']>;
  policyNumber?: Maybe<Scalars['String']>;
  premiumPeriod?: Maybe<PremiumPeriodType>;
  startDate?: Maybe<Scalars['Date']>;
  total?: Maybe<Scalars['Decimal']>;
};

export type ShoppingCartShopFlowInput = {
  category: CategoryType;
  drivers?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  homeOwners?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  isInterestedInBundling?: InputMaybe<Scalars['Boolean']>;
  petOwners?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  pets?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  properties?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rentals?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  renters?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userId?: InputMaybe<Scalars['UUID']>;
  vehicles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

export type ShoppingCartType = {
  __typename: 'ShoppingCartType';
  category: ShoppingCartCategory;
  dismissedOffers?: Maybe<Array<Maybe<OfferType>>>;
  drivers: Array<DriverType>;
  homeOwners: Array<HomeOwnerType>;
  id: Scalars['UUID'];
  isActive?: Maybe<Scalars['Boolean']>;
  isExistingCart?: Maybe<Scalars['Boolean']>;
  isInterestedInBundling?: Maybe<Scalars['Boolean']>;
  isOnboardingCart: Scalars['Boolean'];
  isUserCreatedCart: Scalars['Boolean'];
  offers?: Maybe<Array<Maybe<OfferType>>>;
  petOwners: Array<PetOwnerType>;
  pets: Array<PetType>;
  policy?: Maybe<ShoppingCartPolicyType>;
  properties: Array<PropertyType>;
  rentals: Array<RentalType>;
  renters: Array<RenterType>;
  user: UserType;
  vehicles: Array<VehicleType>;
  zipCode?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export type ShoppingCategoryType =
  | 'AUTO'
  | 'HOME'
  | 'LIFE'
  | 'OTHER'
  | 'PET'
  | 'RENTER';

export type SiteConfigurationType = {
  __typename: 'SiteConfigurationType';
  appleStoreLink?: Maybe<Scalars['String']>;
  featureToggles: Array<FeatureToggleType>;
  googleStoreLink?: Maybe<Scalars['String']>;
  mobileAppLive: Scalars['Boolean'];
};

export type SocialLoginInput = {
  entrySource?: InputMaybe<Scalars['String']>;
  insuranceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  motivations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  provider?: InputMaybe<Scalars['String']>;
  referralCode?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<SourceType>;
  token: Scalars['String'];
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  utmTerm?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export type SourceType =
  | 'MOBILE_APP'
  | 'WEB_APP';

export type SplitNamedInsuredsInput = {
  nameToSplit: Scalars['String'];
  namedInsuredId: Scalars['UUID'];
};

export type StateType = {
  __typename: 'StateType';
  abbreviation?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
};

/** An enumeration. */
export type StatusType =
  | 'PENDING'
  | 'PROCESSED'
  | 'REJECTED';

export type Subscription = {
  __typename: 'Subscription';
  onPolicyDataPullCompleted?: Maybe<OnPolicyDataPullCompleted>;
  onPolicySynced?: Maybe<OnPolicySynced>;
  onUserMarblesChanged?: Maybe<OnUserMarblesChanged>;
};

/** An enumeration. */
export type SyncFailureReasonType =
  | 'SYNC_FAILED_CANOPY_CAPABLE'
  | 'SYNC_FAILED_CANOPY_NOT_ENOUGH_DATA'
  | 'SYNC_FAILED_DOCUMENT_TYPE'
  | 'SYNC_FAILED_DUPLICATED_AUTOMATED'
  | 'SYNC_FAILED_DUPLICATED_RENEWAL'
  | 'SYNC_FAILED_EMBEDDED_LOGIN'
  | 'SYNC_FAILED_EMBEDDED_LOGIN_AUTOMATED'
  | 'SYNC_FAILED_EXPIRED_POLICY'
  | 'SYNC_FAILED_FAKE_DOCUMENTS'
  | 'SYNC_FAILED_FRONT_EMAIL'
  | 'SYNC_FAILED_OTHER'
  | 'SYNC_FAILED_PROTECTED_PDF'
  | 'SYNC_FAILED_SCREENSHOTS'
  | 'SYNC_FAILED_TYPE_NOT_FOUND'
  | 'SYNC_FAILED_UNSUPPORTED_TYPE';

export type TestimonialType = {
  __typename: 'TestimonialType';
  image?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  /** 1 = Half star */
  rating: Scalars['Int'];
  text: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type TextMe = {
  __typename: 'TextMe';
  ok?: Maybe<Scalars['Boolean']>;
};

export type TextMeInput = {
  messageType: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export type TowingCoverageType =
  | 'A_25'
  | 'A_50'
  | 'A_75'
  | 'A_100'
  | 'A_200'
  | 'A_NoSPACECoverage'
  | 'A_Unlimited';

/** An enumeration. */
export type UnAndUnderInsuredCoverageType =
  | 'A_25SLASH50'
  | 'A_50SLASH50'
  | 'A_50SLASH100'
  | 'A_100SLASH100'
  | 'A_100SLASH300'
  | 'A_100SPACECSL'
  | 'A_250SLASH500'
  | 'A_300SLASH300'
  | 'A_300SPACECSL'
  | 'A_500SLASH500'
  | 'A_500SPACECSL'
  | 'A_1000SLASH1000'
  | 'A_Reject'
  | 'A_StateSPACEMinimum';

export type UpdateNamedInsuredInput = {
  address?: InputMaybe<Scalars['String']>;
  careerStatus?: InputMaybe<CareerStatusType>;
  city?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['Date']>;
  driversLicenseNumber?: InputMaybe<Scalars['String']>;
  driversLicenseState?: InputMaybe<Scalars['UUID']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<GenderType>;
  id: Scalars['UUID'];
  lastName?: InputMaybe<Scalars['String']>;
  maritalStatus?: InputMaybe<MaritalStatusType>;
  relationToMarbleMember?: InputMaybe<RelationShipToMarbleMemberType>;
  state?: InputMaybe<Scalars['UUID']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UpdateSavedOffer = {
  __typename: 'UpdateSavedOffer';
  ok?: Maybe<Scalars['Boolean']>;
};

export type UploadHealthPolicyDocumentsInput = {
  documentSize: Scalars['Int'];
  documentType: DocumentTypeType;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  policyId: Scalars['UUID'];
  urlFile: Scalars['String'];
};

export type UploadInput = {
  contentType: Scalars['String'];
  filename: Scalars['String'];
  private: Scalars['Boolean'];
};

export type UploadOtherPolicyDocumentsInput = {
  category: OtherCategoryType;
  documents: Array<InputMaybe<DocumentInput>>;
  otherCategory?: InputMaybe<Scalars['String']>;
};

export type UploadPolicyDocumentsInput = {
  carrier?: InputMaybe<Scalars['UUID']>;
  category: CategoryType;
  documents: Array<InputMaybe<DocumentInput>>;
  policy?: InputMaybe<Scalars['UUID']>;
  renewal?: InputMaybe<Scalars['Boolean']>;
};

export type UserCarrierInput = {
  carrier: Scalars['UUID'];
  category: CategoryType;
  password: Scalars['String'];
  policyId?: InputMaybe<Scalars['UUID']>;
  renewal?: InputMaybe<Scalars['Boolean']>;
  username: Scalars['String'];
};

export type UserEngagementCardActionType = {
  __typename: 'UserEngagementCardActionType';
  actionTaken?: Maybe<Scalars['Boolean']>;
  booleanAnswer?: Maybe<Scalars['Boolean']>;
  choicesAnswer: Array<EngagementCardAnswerChoiceType>;
  dateAnswer?: Maybe<Scalars['Date']>;
  textAnswer?: Maybe<Scalars['String']>;
};

export type UserType = {
  __typename: 'UserType';
  address?: Maybe<Scalars['String']>;
  appDownloaded: Scalars['Boolean'];
  avatar?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  creditScore?: Maybe<CreditScoreType>;
  dob?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: Maybe<GenderType>;
  id: Scalars['UUID'];
  insuranceTypes?: Maybe<Array<Scalars['String']>>;
  isAmbassador: Scalars['Boolean'];
  isHomeOwner?: Maybe<Scalars['Boolean']>;
  isInsuredForAuto?: Maybe<Scalars['Boolean']>;
  isNewUser?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  legalNameConfirmed: Scalars['Boolean'];
  marbleAvailable?: Maybe<Scalars['Int']>;
  marbleAvailableConverted?: Maybe<Scalars['Float']>;
  marbleEarned?: Maybe<Scalars['Int']>;
  moveInDate?: Maybe<Scalars['Date']>;
  ownership?: Maybe<OwnershipType>;
  petGender?: Maybe<PetGenderType>;
  petType?: Maybe<PetTypeType>;
  phone?: Maybe<Scalars['String']>;
  policyUploadRewards?: Maybe<Array<Maybe<PolicyUploadRewardType>>>;
  preferredName?: Maybe<Scalars['String']>;
  previousAddress?: Maybe<Scalars['String']>;
  previousCity?: Maybe<Scalars['String']>;
  previousState?: Maybe<Scalars['UUID']>;
  previousZipCode?: Maybe<Scalars['String']>;
  progressBar?: Maybe<Array<ProgressBarType>>;
  referralCode?: Maybe<Scalars['String']>;
  referrals?: Maybe<Array<ReferralType>>;
  shoppingZipCode?: Maybe<Scalars['String']>;
  signupBonus?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['UUID']>;
  token?: Maybe<Scalars['String']>;
  totalMarblesRedeemed?: Maybe<Scalars['Int']>;
  totalReferralsBalance?: Maybe<Scalars['Int']>;
  usesTobaccoProducts?: Maybe<Scalars['Boolean']>;
  viewedAsBy?: Maybe<Scalars['String']>;
  zendeskToken?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type ValidatePhoneVerificationCode = {
  __typename: 'ValidatePhoneVerificationCode';
  ok?: Maybe<Scalars['Boolean']>;
};

export type ValidateResetTokenInput = {
  token: Scalars['String'];
};

export type VehicleAssetDetailInput = {
  address?: InputMaybe<Scalars['String']>;
  make: Scalars['String'];
  model: Scalars['String'];
  userId?: InputMaybe<Scalars['UUID']>;
  year: Scalars['Int'];
};

export type VehicleAssetInput = {
  accident?: InputMaybe<Scalars['Boolean']>;
  antiTheftProtection?: InputMaybe<Scalars['Boolean']>;
  antiTheftProtections?: InputMaybe<Array<InputMaybe<AntiTheftProtectionsType>>>;
  boughtNew?: InputMaybe<Scalars['Boolean']>;
  collisionDeductible?: InputMaybe<Scalars['Int']>;
  commercialUse?: InputMaybe<Scalars['Boolean']>;
  comprehensiveCoverage?: InputMaybe<Scalars['Boolean']>;
  comprehensiveDeductible?: InputMaybe<Scalars['Int']>;
  dateOfPurchase?: InputMaybe<Scalars['Date']>;
  deliveryUse?: InputMaybe<Scalars['Boolean']>;
  desiredCoverages?: InputMaybe<DesiredCoveragesInput>;
  driverMonitoringProgram?: InputMaybe<Scalars['Boolean']>;
  drivers?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  garagedAddress?: InputMaybe<Scalars['String']>;
  hasExistingDamage?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  milesPerYear?: InputMaybe<Scalars['Int']>;
  monitoredDrivingDiscount?: InputMaybe<Scalars['Boolean']>;
  ownership?: InputMaybe<OwnershipStatusType>;
  primaryDriver?: InputMaybe<Scalars['UUID']>;
  primaryUse?: InputMaybe<PrimaryUseType>;
  rideshareUse?: InputMaybe<Scalars['Boolean']>;
  vehicleVin?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export type VehicleAssetOwnership =
  /** Financed (still making payments) */
  | 'FINANCED'
  /** Leased */
  | 'LEASED'
  /** Owned */
  | 'OWNED';

/** An enumeration. */
export type VehicleAssetPrimaryUse =
  /** Business */
  | 'BUSINESS'
  /** Commute to School/Work */
  | 'COMMUTE'
  /** Pleasure */
  | 'PLEASURE';

export type VehicleAssetType = {
  __typename: 'VehicleAssetType';
  collisionDeductible?: Maybe<Scalars['Float']>;
  collisionValue?: Maybe<Scalars['String']>;
  comprehensiveDeductible?: Maybe<Scalars['Float']>;
  comprehensiveValue?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  othersBodilyAccident?: Maybe<Scalars['Float']>;
  othersBodilyPerson?: Maybe<Scalars['Float']>;
  othersMedicalPayments?: Maybe<Scalars['Float']>;
  othersPropertyAccident?: Maybe<Scalars['Float']>;
  ownership?: Maybe<Scalars['String']>;
  personalProtectionPerson?: Maybe<Scalars['Float']>;
  policy: AutoPolicyType;
  primaryUse?: Maybe<Scalars['String']>;
  reimbursementDay?: Maybe<Scalars['Float']>;
  roadsideAssistance: Scalars['Boolean'];
  roadsideAssistanceValue?: Maybe<Scalars['Float']>;
  totalPremium?: Maybe<Scalars['Float']>;
  uninsuredMotoristAccident?: Maybe<Scalars['Float']>;
  uninsuredMotoristPerson?: Maybe<Scalars['Float']>;
  uninsuredPropertyAccident?: Maybe<Scalars['Float']>;
  uninsuredPropertyDeductible?: Maybe<Scalars['Float']>;
  vehicleInfo?: Maybe<Scalars['String']>;
  vehicleVin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

export type VehicleAssetVinInput = {
  address?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
  vehicleVin: Scalars['String'];
};

export type VehicleDriversInput = {
  drivers: Array<InputMaybe<Scalars['UUID']>>;
  primaryDriver: Scalars['UUID'];
  userId?: InputMaybe<Scalars['UUID']>;
  vehicleId: Scalars['UUID'];
};

export type VehicleType = {
  __typename: 'VehicleType';
  accident?: Maybe<Scalars['Boolean']>;
  antiTheftProtection?: Maybe<Scalars['Boolean']>;
  antiTheftProtections: Array<Scalars['String']>;
  autoPolicies: Array<AutoPolicyType>;
  boughtNew?: Maybe<Scalars['Boolean']>;
  collisionDeductible?: Maybe<Scalars['Int']>;
  commercialUse?: Maybe<Scalars['Boolean']>;
  comprehensiveCoverage?: Maybe<Scalars['Boolean']>;
  comprehensiveDeductible?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['DateTime']>;
  dateOfPurchase?: Maybe<Scalars['Date']>;
  deliveryUse?: Maybe<Scalars['Boolean']>;
  desiredCoverages: Array<DesiredCoveragesType>;
  driverMonitoringProgram?: Maybe<Scalars['Boolean']>;
  drivers: Array<DriverType>;
  garagedAddress?: Maybe<Scalars['String']>;
  hasExistingDamage?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  make?: Maybe<Scalars['String']>;
  milesPerYear?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  monitoredDrivingDiscount?: Maybe<Scalars['Boolean']>;
  ownership?: Maybe<VehicleAssetOwnership>;
  policies: Array<VehicleAssetType>;
  primaryDriver?: Maybe<DriverType>;
  primaryUse?: Maybe<VehicleAssetPrimaryUse>;
  rideshareUse?: Maybe<Scalars['Boolean']>;
  shoppingCarts: Array<ShoppingCartType>;
  user: UserType;
  vehicleInfo?: Maybe<Scalars['String']>;
  vehicleVin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export type WindDeductibleLimitType =
  | 'A_1PERCENT'
  | 'A_2PERCENT'
  | 'A_3PERCENT'
  | 'A_4PERCENT'
  | 'A_5PERCENT'
  | 'A_100'
  | 'A_250'
  | 'A_500'
  | 'A_750'
  | 'A_1000'
  | 'A_1500';

/** An enumeration. */
export type WrongDocumentTypeType =
  | 'WRONG_DOCTYPE_AD_D'
  | 'WRONG_DOCTYPE_APPLICATION'
  | 'WRONG_DOCTYPE_BILLS'
  | 'WRONG_DOCTYPE_BOAT'
  | 'WRONG_DOCTYPE_COVERAGE'
  | 'WRONG_DOCTYPE_GROUP'
  | 'WRONG_DOCTYPE_HEALTH'
  | 'WRONG_DOCTYPE_ID_CARDS'
  | 'WRONG_DOCTYPE_INCOMPLETE'
  | 'WRONG_DOCTYPE_INSURANCE'
  | 'WRONG_DOCTYPE_LIFE'
  | 'WRONG_DOCTYPE_LIFE_DOC'
  | 'WRONG_DOCTYPE_MOTORCYCLE'
  | 'WRONG_DOCTYPE_OTHER'
  | 'WRONG_DOCTYPE_POLICY_PACKAGE'
  | 'WRONG_DOCTYPE_TRAVEL'
  | 'WRONG_DOCTYPE_UMBRELLA';

export type ActivityPartsFragment = { __typename: 'ActivityType', id: string, activityType: ActivityTypeType, concept: string, status?: StatusType, marbles: number, money: number, date: string, message?: string, isDonation?: boolean };

export type DesiredCoveragePartsFragment = { __typename: 'DesiredCoveragesType', comprehensiveDeductible?: ComprehensiveAndCollisionDeductibleType, collisionDeductible?: ComprehensiveAndCollisionDeductibleType, towing?: TowingCoverageType, rental?: RentalCoverageType, bodilyInjury?: BodilyInjuryCoverageType, propertyDamage?: PropertyDamageCoverageType, uninsuredMotorist?: UnAndUnderInsuredCoverageType, uninsuredMotoristPropertyDamage?: PropertyDamageCoverageType, underinsuredMotorist?: UnAndUnderInsuredCoverageType };

export type VehicleTypePartsFragment = { __typename: 'VehicleType', id: string, ownership?: VehicleAssetOwnership, primaryUse?: VehicleAssetPrimaryUse, vehicleInfo?: string, vehicleVin?: string, hasExistingDamage?: boolean, deliveryUse?: boolean, rideshareUse?: boolean, monitoredDrivingDiscount?: boolean, primaryDriver?: { __typename: 'DriverType', id: string }, drivers: Array<{ __typename: 'DriverType', id: string }>, desiredCoverages: Array<{ __typename: 'DesiredCoveragesType', comprehensiveDeductible?: ComprehensiveAndCollisionDeductibleType, collisionDeductible?: ComprehensiveAndCollisionDeductibleType, towing?: TowingCoverageType, rental?: RentalCoverageType, bodilyInjury?: BodilyInjuryCoverageType, propertyDamage?: PropertyDamageCoverageType, uninsuredMotorist?: UnAndUnderInsuredCoverageType, uninsuredMotoristPropertyDamage?: PropertyDamageCoverageType, underinsuredMotorist?: UnAndUnderInsuredCoverageType }> };

export type VehicleCartTypePartsFragment = { __typename: 'VehicleType', id: string, make?: string, model?: string, ownership?: VehicleAssetOwnership, vehicleInfo?: string, vehicleVin?: string, year?: number };

export type PropertyTypePartsFragment = { __typename: 'PropertyType', id: string, addressLine1?: string, addressLine2?: string, propertyCity?: string, propertyZipCode?: string, numBeds?: number, squareFootage?: number, yearBuilt?: number, numBathsFull?: number, numBathsPartial?: number, numStories?: number, roofYearBuilt?: number, heatingAndCoolingUpdated?: number, electricalUpdated?: number, plumbingUpdated?: number, securitySystem?: boolean, securitySystemType?: SecurityTypeType, fireAlarm?: boolean, fireAlarmType?: SecurityTypeType, isGatedCommunity?: boolean, hasTrampoline?: boolean, trampolineSafetyNet?: boolean, hasPool?: boolean, poolType?: PoolType, poolHasSlide?: boolean, poolHasDivingBoard?: boolean, poolHasFence?: boolean, poolHasCage?: boolean, hasDogs?: boolean, deductibleHome?: HomeDeductibleLimitType, deductibleWind?: WindDeductibleLimitType, previousCarrier?: string, previousCarrierYears?: number, previousPolicyExpiry?: string, previousPremium?: number, purchaseDate?: string, policyShopReason?: PropertyAssetPolicyShopReason, propertyState?: { __typename: 'StateType', id: string, abbreviation?: string, name: string } };

export type PropertyCartTypePartsFragment = { __typename: 'PropertyType', addressLine1?: string, addressLine2?: string, propertyCity?: string, propertyZipCode?: string, canopyId?: string };

export type RentalTypePartsFragment = { __typename: 'RentalType', addressLine?: string, city?: string };

export type PetTypePartsFragment = { __typename: 'PetType', name?: string, breed?: string };

export type BeneficiaryPartsFragment = { __typename: 'BeneficiaryType', firstName?: string, lastName?: string, percentage?: number };

export type CarrierPartsFragment = { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> };

export type CoverageItemInfoExamplePartsFragment = { __typename: 'CoverageItemInfoExampleType', id: string, exampleType: ExampleTypeType, title: string, icon?: string, videoUrl?: string, order: number };

export type CoverageItemInfoPartsFragment = { __typename: 'CoverageItemInfoType', id: string, coverageItem: CoverageItemType, definition: string, examples: Array<{ __typename: 'CoverageItemInfoExampleType', id: string, exampleType: ExampleTypeType, title: string, icon?: string, videoUrl?: string, order: number }> };

export type DocumentPartsFragment = { __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number };

export type FeaturePartsFragment = { __typename: 'FeatureItemType', id: string, title: string, description: string, image?: string, imageBgcolor?: string, featureType: FeatureTypeType, date?: string, featured: boolean, read: boolean };

export type HealthPolicyFragment = { __typename: 'HealthPolicyType', id: string, category?: HealthCategoryType, planName: string, groupId?: string, memberId?: string, namedInsureds: Array<{ __typename: 'HealthInsuredType', firstName?: string, lastName?: string }>, carrier: { __typename: 'HealthCarrierType', id: string, name: string, logo?: string, contactUrl?: string, claimUrl?: string }, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, name: string, documentType: DocumentTypeType, documentSize: number, created?: string }> };

export type MarketingLandingPartsFragment = { __typename: 'MarketingLandingDataType', id: string, partnerSlug: string, pageType: PageTypeType, partnerLogo?: string, title?: string, subtitle?: string, metadata?: string, popupTitle?: string, popupSubtitle?: string, popupCta?: string, popupRedirect?: string, commonData: { __typename: 'CommonLandingDataType', mainImage?: string, headerTitle?: string, subheader1Title?: string, subheader1Text?: string, subheader2Title?: string, subheader2Text?: string, subheader3Title?: string, subheader3Text?: string, subheader4Title?: string, subheader4Text?: string, footerTitle?: string, footerCta?: string, testimonials?: Array<{ __typename: 'TestimonialType', image?: string, location?: string, rating: number, text: string, title?: string, userName?: string }> } };

export type MarketingLandingTestimonialsPartsFragment = { __typename: 'TestimonialType', image?: string, location?: string, rating: number, text: string, title?: string, userName?: string };

export type MarketingLandingCommonPartsFragment = { __typename: 'CommonLandingDataType', mainImage?: string, headerTitle?: string, subheader1Title?: string, subheader1Text?: string, subheader2Title?: string, subheader2Text?: string, subheader3Title?: string, subheader3Text?: string, subheader4Title?: string, subheader4Text?: string, footerTitle?: string, footerCta?: string, testimonials?: Array<{ __typename: 'TestimonialType', image?: string, location?: string, rating: number, text: string, title?: string, userName?: string }> };

export type MePartsFragment = { __typename: 'UserType', id: string, firstName: string, lastName: string, preferredName?: string, legalNameConfirmed: boolean, address?: string, city?: string, zipCode?: string, state?: string, phone?: string, avatar?: string, email: string, created?: string, token?: string, gender?: GenderType, dob?: string, marbleEarned?: number, marbleAvailable?: number, marbleAvailableConverted?: number, referralCode?: string, totalReferralsBalance?: number, viewedAsBy?: string, signupBonus?: number, isAmbassador: boolean, insuranceTypes?: Array<string>, appDownloaded: boolean, shoppingZipCode?: string, creditScore?: CreditScoreType, isHomeOwner?: boolean, isInsuredForAuto?: boolean, isNewUser?: boolean, usesTobaccoProducts?: boolean, petType?: PetTypeType, petGender?: PetGenderType, zendeskToken?: string, moveInDate?: string, previousAddress?: string, previousCity?: string, previousZipCode?: string, previousState?: string, ownership?: OwnershipType, progressBar?: Array<{ __typename: 'ProgressBarType', action?: string, status?: string }>, referrals?: Array<{ __typename: 'ReferralType', firstName?: string, lastName?: string, memberSince?: string }>, policyUploadRewards?: Array<{ __typename: 'PolicyUploadRewardType', category?: string, marbleCount?: number }> };

export type DriverPartsFragment = { __typename: 'DriverType', id: string, created?: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, careerStatus?: NamedInsuredBaseCareerStatus, educationLevel?: NamedInsuredBaseEducationLevel, ageFirstLicensed?: number, driversLicenseNumber?: string, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseState?: { __typename: 'StateType', id: string, name: string } };

export type HomeOwnerPartsFragment = { __typename: 'HomeOwnerType', id: string, created?: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, educationLevel?: NamedInsuredBaseEducationLevel, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } };

export type RenterPartsFragment = { __typename: 'RenterType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } };

export type PetOwnerPartsFragment = { __typename: 'PetOwnerType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } };

export type LifeInsuredPartsFragment = { __typename: 'LifeInsuredType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, educationLevel?: NamedInsuredBaseEducationLevel, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } };

export type SharedAccessPartsFragment = { __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string };

export type NameInsuredPartsFragment = { __typename: 'NamedInsuredType', id: string, gender?: NamedInsuredBaseGender, dob?: string, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } };

export type SplitNameInsuredPartsFragment = { __typename: 'NamedInsuredType', id: string };

export type MergeNameInsuredPartsFragment = { __typename: 'NamedInsuredType', id: string };

export type OfferPartsFragment = { __typename: 'OfferType', id: string, partner?: string, policyIds?: Array<string>, premium?: number, policyType?: Array<ShoppingCategoryType>, termMonths?: number, offerDocument?: string, link?: string, carrier?: string, expiryDate?: string, logo?: string, savings?: number, partnerQuoteId?: string, shoppingCartId?: string, userSavedDate?: string, tier?: OfferTier, status?: OfferStatusType, template?: { __typename: 'OfferTemplateType', headline?: string, description?: string, logo?: string, ctaCopy?: string, ctaIcon?: OfferTemplateCtaIcon, finePrint?: string }, coverages?: { __typename: 'OfferCoverageType', othersBodilyPerson?: number, othersBodilyAccident?: number, othersPropertyAccident?: number, othersMedicalPayments?: number, uninsuredMotoristPerson?: number, comprehensiveDeductible?: number, collisionDeductible?: number, aDwelling?: number, bOtherStructures?: number, cPersonalProperty?: number, dLossUse?: number, ePersonalLiability?: number, fMedicalOthers?: number, deductibleWind?: number, deductible?: number, coinsurancePercentage?: number, reimbursementPercentage?: number, deathBenefit?: number, cashValue?: number, comparisonData?: { __typename: 'OfferCoverageComparisonDataType', othersBodilyPerson?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, othersBodilyAccident?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, othersPropertyAccident?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, othersMedicalPayments?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, uninsuredMotoristPerson?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, comprehensiveDeductible?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, collisionDeductible?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, aDwelling?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, bOtherStructures?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, cPersonalProperty?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, dLossUse?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, ePersonalLiability?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, fMedicalOthers?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, deductibleWind?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, deductible?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, coinsurancePercentage?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, reimbursementPercentage?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, deathBenefit?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, cashValue?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any } } } };

export type OnPolicyDataPullCompletedPartsFragment = { __typename: 'OnPolicyDataPullCompleted', policyId?: string };

export type OnPolicySyncedPartsFragment = { __typename: 'OnPolicySynced', policyId?: string, showSyncAnimation?: boolean };

export type OnUserMarblesChangedPartsFragment = { __typename: 'OnUserMarblesChanged', marbleAvailable?: number, marbleAvailableConverted?: number, balanceAnimationValue?: number };

export type OtherPolicyPartsFragment = { __typename: 'OtherPolicyType', id: string, category?: OtherCategoryType, otherCategory?: string, documents: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }> };

export type PaymentDetailsPartsFragment = { __typename: 'PaymentDetailsType', paymentToken?: string, paymentMethod?: PaymentMethodType, accountNumber?: string, routingNumber?: string, expiryYear?: number, expiryMonth?: number, cardBrand?: string, cardType?: string };

export type PaymentPagePartsFragment = { __typename: 'PaymentPageType', offerId?: string, email?: string, isPaymentSubmitted?: boolean, termMonths?: number, expiryDate?: string, category?: ShoppingCategoryType, carrier?: string, carrierLogo?: string, offerDetails?: string, namedInsureds?: string, assetName?: string, monthlyPremium?: any, paymentDetails?: { __typename: 'PaymentDetailsType', paymentToken?: string, paymentMethod?: PaymentMethodType, accountNumber?: string, routingNumber?: string, expiryYear?: number, expiryMonth?: number, cardBrand?: string, cardType?: string } };

export type AutoPolicyPartsFragment = { __typename: 'AutoPolicyType', basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, namedInsured?: Array<string>, address?: string, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, vehicles: Array<{ __typename: 'VehicleAssetType', id: string, vehicleInfo?: string, vehicleVin?: string, year?: number, make?: string, model?: string, ownership?: string, primaryUse?: string, othersBodilyPerson?: number, othersBodilyAccident?: number, othersMedicalPayments?: number, othersPropertyAccident?: number, personalProtectionPerson?: number, uninsuredMotoristPerson?: number, uninsuredMotoristAccident?: number, uninsuredPropertyAccident?: number, uninsuredPropertyDeductible?: number, comprehensiveValue?: string, comprehensiveDeductible?: number, collisionValue?: string, collisionDeductible?: number, reimbursementDay?: number, roadsideAssistance: boolean, roadsideAssistanceValue?: number, totalPremium?: number }>, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, drivers: Array<{ __typename: 'DriverType', id: string, created?: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, careerStatus?: NamedInsuredBaseCareerStatus, educationLevel?: NamedInsuredBaseEducationLevel, ageFirstLicensed?: number, driversLicenseNumber?: string, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }> };

export type HomePolicyPartsFragment = { __typename: 'HomePolicyType', namedInsured?: Array<string>, address?: string, dwelling?: number, otherStructures?: number, personalProperty?: number, lossUse?: number, personalLiability?: number, medicalOthers?: number, deductible?: number, deductibleWind?: number, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, homeOwners: Array<{ __typename: 'HomeOwnerType', id: string, created?: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, educationLevel?: NamedInsuredBaseEducationLevel, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }>, properties: Array<{ __typename: 'PropertyType', id: string, addressLine1?: string, addressLine2?: string, propertyCity?: string, propertyZipCode?: string, typeOfProperty?: PropertyAssetTypeOfProperty, typeOfResidence?: PropertyAssetTypeOfResidence, yearBuilt?: number, squareFootage?: number, construction?: PropertyAssetConstruction, foundation?: PropertyAssetFoundation, roof?: PropertyAssetRoof, roofYearBuilt?: number, fireAlarm?: boolean, propertyState?: { __typename: 'StateType', id: string, name: string } }> };

export type LifePolicyPartsFragment = { __typename: 'LifePolicyType', namedInsured?: Array<string>, address?: string, planType?: LifePolicyPlanType, otherTermYears?: number, deathBenefit?: number, conversionDate?: string, riders?: string, isGroup: boolean, cashValue?: number, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, beneficiaries: Array<{ __typename: 'BeneficiaryType', firstName?: string, lastName?: string, percentage?: number }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, lifeInsureds: Array<{ __typename: 'LifeInsuredType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, educationLevel?: NamedInsuredBaseEducationLevel, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }> };

export type PetPolicyPartsFragment = { __typename: 'PetPolicyType', address?: string, petParent?: string, petParentAddress?: string, petName?: string, petType?: string, petBreed?: string, petDob?: string, petSex?: PetGenderType, hasBitten?: boolean, coinsurance?: number, reimbursement?: number, annualDeductible?: number, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, petOwners: Array<{ __typename: 'PetOwnerType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember }> };

export type RenterPolicyPartsFragment = { __typename: 'RenterPolicyType', namedInsured?: Array<string>, address?: string, personalProperty?: number, lossUse?: number, personalLiability?: number, medicalOthers?: number, deductible?: number, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, renters: Array<{ __typename: 'RenterType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }>, rentals: Array<{ __typename: 'RentalType', id: string, address?: string, addressLine?: string, city?: string, zipCode?: string, typeOfProperty?: RentalAssetTypeOfProperty, state?: { __typename: 'StateType', id: string, name: string } }> };

type PolicyParts_AutoPolicyType_Fragment = { __typename: 'AutoPolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, namedInsured?: Array<string>, address?: string, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, vehicles: Array<{ __typename: 'VehicleAssetType', id: string, vehicleInfo?: string, vehicleVin?: string, year?: number, make?: string, model?: string, ownership?: string, primaryUse?: string, othersBodilyPerson?: number, othersBodilyAccident?: number, othersMedicalPayments?: number, othersPropertyAccident?: number, personalProtectionPerson?: number, uninsuredMotoristPerson?: number, uninsuredMotoristAccident?: number, uninsuredPropertyAccident?: number, uninsuredPropertyDeductible?: number, comprehensiveValue?: string, comprehensiveDeductible?: number, collisionValue?: string, collisionDeductible?: number, reimbursementDay?: number, roadsideAssistance: boolean, roadsideAssistanceValue?: number, totalPremium?: number }>, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, drivers: Array<{ __typename: 'DriverType', id: string, created?: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, careerStatus?: NamedInsuredBaseCareerStatus, educationLevel?: NamedInsuredBaseEducationLevel, ageFirstLicensed?: number, driversLicenseNumber?: string, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }> };

type PolicyParts_HomePolicyType_Fragment = { __typename: 'HomePolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, namedInsured?: Array<string>, address?: string, dwelling?: number, otherStructures?: number, personalProperty?: number, lossUse?: number, personalLiability?: number, medicalOthers?: number, deductible?: number, deductibleWind?: number, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, homeOwners: Array<{ __typename: 'HomeOwnerType', id: string, created?: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, educationLevel?: NamedInsuredBaseEducationLevel, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }>, properties: Array<{ __typename: 'PropertyType', id: string, addressLine1?: string, addressLine2?: string, propertyCity?: string, propertyZipCode?: string, typeOfProperty?: PropertyAssetTypeOfProperty, typeOfResidence?: PropertyAssetTypeOfResidence, yearBuilt?: number, squareFootage?: number, construction?: PropertyAssetConstruction, foundation?: PropertyAssetFoundation, roof?: PropertyAssetRoof, roofYearBuilt?: number, fireAlarm?: boolean, propertyState?: { __typename: 'StateType', id: string, name: string } }> };

type PolicyParts_LifePolicyType_Fragment = { __typename: 'LifePolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, namedInsured?: Array<string>, address?: string, planType?: LifePolicyPlanType, otherTermYears?: number, deathBenefit?: number, conversionDate?: string, riders?: string, isGroup: boolean, cashValue?: number, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, beneficiaries: Array<{ __typename: 'BeneficiaryType', firstName?: string, lastName?: string, percentage?: number }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, lifeInsureds: Array<{ __typename: 'LifeInsuredType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, educationLevel?: NamedInsuredBaseEducationLevel, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }> };

type PolicyParts_PetPolicyType_Fragment = { __typename: 'PetPolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, address?: string, petParent?: string, petParentAddress?: string, petName?: string, petType?: string, petBreed?: string, petDob?: string, petSex?: PetGenderType, hasBitten?: boolean, coinsurance?: number, reimbursement?: number, annualDeductible?: number, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, petOwners: Array<{ __typename: 'PetOwnerType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember }> };

type PolicyParts_PolicyType_Fragment = { __typename: 'PolicyType', id: string, address?: string, isPolicyOwner?: boolean, isOnRenewal?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }> };

type PolicyParts_RenterPolicyType_Fragment = { __typename: 'RenterPolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, namedInsured?: Array<string>, address?: string, personalProperty?: number, lossUse?: number, personalLiability?: number, medicalOthers?: number, deductible?: number, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, renters: Array<{ __typename: 'RenterType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }>, rentals: Array<{ __typename: 'RentalType', id: string, address?: string, addressLine?: string, city?: string, zipCode?: string, typeOfProperty?: RentalAssetTypeOfProperty, state?: { __typename: 'StateType', id: string, name: string } }> };

export type PolicyPartsFragment = PolicyParts_AutoPolicyType_Fragment | PolicyParts_HomePolicyType_Fragment | PolicyParts_LifePolicyType_Fragment | PolicyParts_PetPolicyType_Fragment | PolicyParts_PolicyType_Fragment | PolicyParts_RenterPolicyType_Fragment;

export type ProductPartsFragment = { __typename: 'RedemptionProductType', id: string, productName: string, title?: string, subtitle?: string, active: boolean, maximumAmount?: number, minimumAmount?: number, conversionRatio?: number, logo?: string, logoCard?: string, isDonation?: boolean, provider?: string };

export type ShoppingCartPartsFragment = { __typename: 'ShoppingCartType', id: string, isActive?: boolean, category: ShoppingCartCategory, zipCode?: string, isInterestedInBundling?: boolean, isOnboardingCart: boolean, isUserCreatedCart: boolean, user: { __typename: 'UserType', id: string, firstName: string, lastName: string, preferredName?: string, legalNameConfirmed: boolean, address?: string, city?: string, zipCode?: string, state?: string, phone?: string, avatar?: string, email: string, created?: string, token?: string, gender?: GenderType, dob?: string, marbleEarned?: number, marbleAvailable?: number, marbleAvailableConverted?: number, referralCode?: string, totalReferralsBalance?: number, viewedAsBy?: string, signupBonus?: number, isAmbassador: boolean, insuranceTypes?: Array<string>, appDownloaded: boolean, shoppingZipCode?: string, creditScore?: CreditScoreType, isHomeOwner?: boolean, isInsuredForAuto?: boolean, isNewUser?: boolean, usesTobaccoProducts?: boolean, petType?: PetTypeType, petGender?: PetGenderType, zendeskToken?: string, moveInDate?: string, previousAddress?: string, previousCity?: string, previousZipCode?: string, previousState?: string, ownership?: OwnershipType, progressBar?: Array<{ __typename: 'ProgressBarType', action?: string, status?: string }>, referrals?: Array<{ __typename: 'ReferralType', firstName?: string, lastName?: string, memberSince?: string }>, policyUploadRewards?: Array<{ __typename: 'PolicyUploadRewardType', category?: string, marbleCount?: number }> }, drivers: Array<{ __typename: 'DriverType', id: string, created?: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, careerStatus?: NamedInsuredBaseCareerStatus, educationLevel?: NamedInsuredBaseEducationLevel, ageFirstLicensed?: number, driversLicenseNumber?: string, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }>, homeOwners: Array<{ __typename: 'HomeOwnerType', id: string, created?: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, educationLevel?: NamedInsuredBaseEducationLevel, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }>, renters: Array<{ __typename: 'RenterType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }>, petOwners: Array<{ __typename: 'PetOwnerType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }>, vehicles: Array<{ __typename: 'VehicleType', id: string, make?: string, model?: string, ownership?: VehicleAssetOwnership, vehicleInfo?: string, vehicleVin?: string, year?: number }>, properties: Array<{ __typename: 'PropertyType', addressLine1?: string, addressLine2?: string, propertyCity?: string, propertyZipCode?: string, canopyId?: string }>, rentals: Array<{ __typename: 'RentalType', addressLine?: string, city?: string }>, pets: Array<{ __typename: 'PetType', name?: string, breed?: string }>, policy?: { __typename: 'ShoppingCartPolicyType', policyId?: string, policyNumber?: string, endDate?: string, continuous?: boolean, assets?: Array<{ __typename: 'ShoppingCartAssetType', name?: string, addressLine?: string, ownership?: OwnershipStatusType, model?: string, make?: string, year?: number }>, namedInsureds?: Array<{ __typename: 'ShoppingCartNamedInsuredType', firstName?: string, lastName?: string }>, coverageDetails?: Array<{ __typename: 'CoverageDetailsType', planType?: LifePolicyPlanType, otherTermYears?: number }> }, offers?: Array<{ __typename: 'OfferType', id: string, partner?: string, policyIds?: Array<string>, premium?: number, policyType?: Array<ShoppingCategoryType>, termMonths?: number, offerDocument?: string, link?: string, carrier?: string, expiryDate?: string, logo?: string, savings?: number, partnerQuoteId?: string, shoppingCartId?: string, userSavedDate?: string, tier?: OfferTier, status?: OfferStatusType, template?: { __typename: 'OfferTemplateType', headline?: string, description?: string, logo?: string, ctaCopy?: string, ctaIcon?: OfferTemplateCtaIcon, finePrint?: string }, coverages?: { __typename: 'OfferCoverageType', othersBodilyPerson?: number, othersBodilyAccident?: number, othersPropertyAccident?: number, othersMedicalPayments?: number, uninsuredMotoristPerson?: number, comprehensiveDeductible?: number, collisionDeductible?: number, aDwelling?: number, bOtherStructures?: number, cPersonalProperty?: number, dLossUse?: number, ePersonalLiability?: number, fMedicalOthers?: number, deductibleWind?: number, deductible?: number, coinsurancePercentage?: number, reimbursementPercentage?: number, deathBenefit?: number, cashValue?: number, comparisonData?: { __typename: 'OfferCoverageComparisonDataType', othersBodilyPerson?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, othersBodilyAccident?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, othersPropertyAccident?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, othersMedicalPayments?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, uninsuredMotoristPerson?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, comprehensiveDeductible?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, collisionDeductible?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, aDwelling?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, bOtherStructures?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, cPersonalProperty?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, dLossUse?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, ePersonalLiability?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, fMedicalOthers?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, deductibleWind?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, deductible?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, coinsurancePercentage?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, reimbursementPercentage?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, deathBenefit?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, cashValue?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any } } } }>, dismissedOffers?: Array<{ __typename: 'OfferType', id: string, partner?: string, policyIds?: Array<string>, premium?: number, policyType?: Array<ShoppingCategoryType>, termMonths?: number, offerDocument?: string, link?: string, carrier?: string, expiryDate?: string, logo?: string, savings?: number, partnerQuoteId?: string, shoppingCartId?: string, userSavedDate?: string, tier?: OfferTier, status?: OfferStatusType, template?: { __typename: 'OfferTemplateType', headline?: string, description?: string, logo?: string, ctaCopy?: string, ctaIcon?: OfferTemplateCtaIcon, finePrint?: string }, coverages?: { __typename: 'OfferCoverageType', othersBodilyPerson?: number, othersBodilyAccident?: number, othersPropertyAccident?: number, othersMedicalPayments?: number, uninsuredMotoristPerson?: number, comprehensiveDeductible?: number, collisionDeductible?: number, aDwelling?: number, bOtherStructures?: number, cPersonalProperty?: number, dLossUse?: number, ePersonalLiability?: number, fMedicalOthers?: number, deductibleWind?: number, deductible?: number, coinsurancePercentage?: number, reimbursementPercentage?: number, deathBenefit?: number, cashValue?: number, comparisonData?: { __typename: 'OfferCoverageComparisonDataType', othersBodilyPerson?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, othersBodilyAccident?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, othersPropertyAccident?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, othersMedicalPayments?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, uninsuredMotoristPerson?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, comprehensiveDeductible?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, collisionDeductible?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, aDwelling?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, bOtherStructures?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, cPersonalProperty?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, dLossUse?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, ePersonalLiability?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, fMedicalOthers?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, deductibleWind?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, deductible?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, coinsurancePercentage?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, reimbursementPercentage?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, deathBenefit?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, cashValue?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any } } } }> };

export type StatePartsFragment = { __typename: 'StateType', id: string, name: string, abbreviation?: string };

export type UserPartsFragment = { __typename: 'UserType', email: string, firstName: string, lastName: string };

export type ArchiveShoppingCartMutationVariables = Exact<{
  id: Scalars['UUID'];
  archiveReason: ArchiveShoppingCartType;
}>;


export type ArchiveShoppingCartMutation = { archiveShoppingCart?: { __typename: 'ArchiveShoppingCart', ok?: boolean } };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { login?: { __typename: 'UserType', id: string, firstName: string, lastName: string, preferredName?: string, legalNameConfirmed: boolean, address?: string, city?: string, zipCode?: string, state?: string, phone?: string, avatar?: string, email: string, created?: string, token?: string, gender?: GenderType, dob?: string, marbleEarned?: number, marbleAvailable?: number, marbleAvailableConverted?: number, referralCode?: string, totalReferralsBalance?: number, viewedAsBy?: string, signupBonus?: number, isAmbassador: boolean, insuranceTypes?: Array<string>, appDownloaded: boolean, shoppingZipCode?: string, creditScore?: CreditScoreType, isHomeOwner?: boolean, isInsuredForAuto?: boolean, isNewUser?: boolean, usesTobaccoProducts?: boolean, petType?: PetTypeType, petGender?: PetGenderType, zendeskToken?: string, moveInDate?: string, previousAddress?: string, previousCity?: string, previousZipCode?: string, previousState?: string, ownership?: OwnershipType, progressBar?: Array<{ __typename: 'ProgressBarType', action?: string, status?: string }>, referrals?: Array<{ __typename: 'ReferralType', firstName?: string, lastName?: string, memberSince?: string }>, policyUploadRewards?: Array<{ __typename: 'PolicyUploadRewardType', category?: string, marbleCount?: number }> } };

export type SocialLoginMutationVariables = Exact<{
  input: SocialLoginInput;
}>;


export type SocialLoginMutation = { socialLogin?: { __typename: 'UserType', id: string, firstName: string, lastName: string, preferredName?: string, legalNameConfirmed: boolean, address?: string, city?: string, zipCode?: string, state?: string, phone?: string, avatar?: string, email: string, created?: string, token?: string, gender?: GenderType, dob?: string, marbleEarned?: number, marbleAvailable?: number, marbleAvailableConverted?: number, referralCode?: string, totalReferralsBalance?: number, viewedAsBy?: string, signupBonus?: number, isAmbassador: boolean, insuranceTypes?: Array<string>, appDownloaded: boolean, shoppingZipCode?: string, creditScore?: CreditScoreType, isHomeOwner?: boolean, isInsuredForAuto?: boolean, isNewUser?: boolean, usesTobaccoProducts?: boolean, petType?: PetTypeType, petGender?: PetGenderType, zendeskToken?: string, moveInDate?: string, previousAddress?: string, previousCity?: string, previousZipCode?: string, previousState?: string, ownership?: OwnershipType, progressBar?: Array<{ __typename: 'ProgressBarType', action?: string, status?: string }>, referrals?: Array<{ __typename: 'ReferralType', firstName?: string, lastName?: string, memberSince?: string }>, policyUploadRewards?: Array<{ __typename: 'PolicyUploadRewardType', category?: string, marbleCount?: number }> } };

export type RegisterMutationVariables = Exact<{
  input: RegisterInput;
}>;


export type RegisterMutation = { register?: { __typename: 'UserType', id: string, firstName: string, lastName: string, preferredName?: string, legalNameConfirmed: boolean, address?: string, city?: string, zipCode?: string, state?: string, phone?: string, avatar?: string, email: string, created?: string, token?: string, gender?: GenderType, dob?: string, marbleEarned?: number, marbleAvailable?: number, marbleAvailableConverted?: number, referralCode?: string, totalReferralsBalance?: number, viewedAsBy?: string, signupBonus?: number, isAmbassador: boolean, insuranceTypes?: Array<string>, appDownloaded: boolean, shoppingZipCode?: string, creditScore?: CreditScoreType, isHomeOwner?: boolean, isInsuredForAuto?: boolean, isNewUser?: boolean, usesTobaccoProducts?: boolean, petType?: PetTypeType, petGender?: PetGenderType, zendeskToken?: string, moveInDate?: string, previousAddress?: string, previousCity?: string, previousZipCode?: string, previousState?: string, ownership?: OwnershipType, progressBar?: Array<{ __typename: 'ProgressBarType', action?: string, status?: string }>, referrals?: Array<{ __typename: 'ReferralType', firstName?: string, lastName?: string, memberSince?: string }>, policyUploadRewards?: Array<{ __typename: 'PolicyUploadRewardType', category?: string, marbleCount?: number }> } };

export type RequestResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type RequestResetPasswordMutation = { requestResetPassword?: { __typename: 'ResetPasswordPayload', email: string } };

export type ResetPasswordMutationVariables = Exact<{
  input: SetPasswordInput;
}>;


export type ResetPasswordMutation = { resetPassword?: boolean };

export type ValidateResetTokenMutationVariables = Exact<{
  input: ValidateResetTokenInput;
}>;


export type ValidateResetTokenMutation = { validateResetToken?: boolean };

export type SetPasswordShopFlowMutationVariables = Exact<{
  input: ShopSetPasswordInput;
}>;


export type SetPasswordShopFlowMutation = { setPasswordShopFlow?: { __typename: 'UserType', id: string, firstName: string, lastName: string, preferredName?: string, legalNameConfirmed: boolean, address?: string, city?: string, zipCode?: string, state?: string, phone?: string, avatar?: string, email: string, created?: string, token?: string, gender?: GenderType, dob?: string, marbleEarned?: number, marbleAvailable?: number, marbleAvailableConverted?: number, referralCode?: string, totalReferralsBalance?: number, viewedAsBy?: string, signupBonus?: number, isAmbassador: boolean, insuranceTypes?: Array<string>, appDownloaded: boolean, shoppingZipCode?: string, creditScore?: CreditScoreType, isHomeOwner?: boolean, isInsuredForAuto?: boolean, isNewUser?: boolean, usesTobaccoProducts?: boolean, petType?: PetTypeType, petGender?: PetGenderType, zendeskToken?: string, moveInDate?: string, previousAddress?: string, previousCity?: string, previousZipCode?: string, previousState?: string, ownership?: OwnershipType, progressBar?: Array<{ __typename: 'ProgressBarType', action?: string, status?: string }>, referrals?: Array<{ __typename: 'ReferralType', firstName?: string, lastName?: string, memberSince?: string }>, policyUploadRewards?: Array<{ __typename: 'PolicyUploadRewardType', category?: string, marbleCount?: number }> } };

export type CanopyConsentMutationVariables = Exact<{
  input: CanopyConsentInput;
}>;


export type CanopyConsentMutation = { canopyConsent?: { __typename: 'CanopyConnectResponseType', status?: string, pullId?: string, pullJwt?: string, mfaOptions?: any, loginErrorMessage?: string, mfaHelperText?: string, email?: string, firstName?: string, lastName?: string, phone?: string } };

export type CanopyMfaOptionMutationVariables = Exact<{
  input: CanopyMfaOptionInput;
}>;


export type CanopyMfaOptionMutation = { canopyMfaOption?: { __typename: 'CanopyMFAOption', ok?: boolean } };

export type CanopyMfaAnswerMutationVariables = Exact<{
  input: CanopyMfaAnswerInput;
}>;


export type CanopyMfaAnswerMutation = { canopyMfaAnswer?: { __typename: 'CanopyMFAAnswer', shouldPoll?: boolean } };

export type CanopyReconnectMutationVariables = Exact<{
  input: CanopyAuthInput;
}>;


export type CanopyReconnectMutation = { canopyReconnect?: { __typename: 'CanopyReconnect', shouldPoll?: boolean } };

export type SendComparisonEmailMutationVariables = Exact<{
  input: InsuranceInsiderComparisonInput;
}>;


export type SendComparisonEmailMutation = { sendComparisonEmail?: { __typename: 'InsuranceInsiderComparisonEmail', ok?: boolean } };

export type CreateLeadEmailOnlyMutationVariables = Exact<{
  input: LeadGenEmailOnlyInput;
}>;


export type CreateLeadEmailOnlyMutation = { createLeadEmailOnly?: { __typename: 'CreateLeadGenEmailOnly', ok?: boolean } };

export type CreateShoppingCartMutationVariables = Exact<{
  input: ShoppingCartInput;
}>;


export type CreateShoppingCartMutation = { createShoppingCart?: { __typename: 'ShoppingCartType', id: string, isActive?: boolean, category: ShoppingCartCategory, zipCode?: string, isInterestedInBundling?: boolean, isOnboardingCart: boolean, isUserCreatedCart: boolean, user: { __typename: 'UserType', id: string, firstName: string, lastName: string, preferredName?: string, legalNameConfirmed: boolean, address?: string, city?: string, zipCode?: string, state?: string, phone?: string, avatar?: string, email: string, created?: string, token?: string, gender?: GenderType, dob?: string, marbleEarned?: number, marbleAvailable?: number, marbleAvailableConverted?: number, referralCode?: string, totalReferralsBalance?: number, viewedAsBy?: string, signupBonus?: number, isAmbassador: boolean, insuranceTypes?: Array<string>, appDownloaded: boolean, shoppingZipCode?: string, creditScore?: CreditScoreType, isHomeOwner?: boolean, isInsuredForAuto?: boolean, isNewUser?: boolean, usesTobaccoProducts?: boolean, petType?: PetTypeType, petGender?: PetGenderType, zendeskToken?: string, moveInDate?: string, previousAddress?: string, previousCity?: string, previousZipCode?: string, previousState?: string, ownership?: OwnershipType, progressBar?: Array<{ __typename: 'ProgressBarType', action?: string, status?: string }>, referrals?: Array<{ __typename: 'ReferralType', firstName?: string, lastName?: string, memberSince?: string }>, policyUploadRewards?: Array<{ __typename: 'PolicyUploadRewardType', category?: string, marbleCount?: number }> }, drivers: Array<{ __typename: 'DriverType', id: string, created?: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, careerStatus?: NamedInsuredBaseCareerStatus, educationLevel?: NamedInsuredBaseEducationLevel, ageFirstLicensed?: number, driversLicenseNumber?: string, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }>, homeOwners: Array<{ __typename: 'HomeOwnerType', id: string, created?: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, educationLevel?: NamedInsuredBaseEducationLevel, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }>, renters: Array<{ __typename: 'RenterType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }>, petOwners: Array<{ __typename: 'PetOwnerType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }>, vehicles: Array<{ __typename: 'VehicleType', id: string, make?: string, model?: string, ownership?: VehicleAssetOwnership, vehicleInfo?: string, vehicleVin?: string, year?: number }>, properties: Array<{ __typename: 'PropertyType', addressLine1?: string, addressLine2?: string, propertyCity?: string, propertyZipCode?: string, canopyId?: string }>, rentals: Array<{ __typename: 'RentalType', addressLine?: string, city?: string }>, pets: Array<{ __typename: 'PetType', name?: string, breed?: string }>, policy?: { __typename: 'ShoppingCartPolicyType', policyId?: string, policyNumber?: string, endDate?: string, continuous?: boolean, assets?: Array<{ __typename: 'ShoppingCartAssetType', name?: string, addressLine?: string, ownership?: OwnershipStatusType, model?: string, make?: string, year?: number }>, namedInsureds?: Array<{ __typename: 'ShoppingCartNamedInsuredType', firstName?: string, lastName?: string }>, coverageDetails?: Array<{ __typename: 'CoverageDetailsType', planType?: LifePolicyPlanType, otherTermYears?: number }> }, offers?: Array<{ __typename: 'OfferType', id: string, partner?: string, policyIds?: Array<string>, premium?: number, policyType?: Array<ShoppingCategoryType>, termMonths?: number, offerDocument?: string, link?: string, carrier?: string, expiryDate?: string, logo?: string, savings?: number, partnerQuoteId?: string, shoppingCartId?: string, userSavedDate?: string, tier?: OfferTier, status?: OfferStatusType, template?: { __typename: 'OfferTemplateType', headline?: string, description?: string, logo?: string, ctaCopy?: string, ctaIcon?: OfferTemplateCtaIcon, finePrint?: string }, coverages?: { __typename: 'OfferCoverageType', othersBodilyPerson?: number, othersBodilyAccident?: number, othersPropertyAccident?: number, othersMedicalPayments?: number, uninsuredMotoristPerson?: number, comprehensiveDeductible?: number, collisionDeductible?: number, aDwelling?: number, bOtherStructures?: number, cPersonalProperty?: number, dLossUse?: number, ePersonalLiability?: number, fMedicalOthers?: number, deductibleWind?: number, deductible?: number, coinsurancePercentage?: number, reimbursementPercentage?: number, deathBenefit?: number, cashValue?: number, comparisonData?: { __typename: 'OfferCoverageComparisonDataType', othersBodilyPerson?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, othersBodilyAccident?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, othersPropertyAccident?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, othersMedicalPayments?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, uninsuredMotoristPerson?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, comprehensiveDeductible?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, collisionDeductible?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, aDwelling?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, bOtherStructures?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, cPersonalProperty?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, dLossUse?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, ePersonalLiability?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, fMedicalOthers?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, deductibleWind?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, deductible?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, coinsurancePercentage?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, reimbursementPercentage?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, deathBenefit?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, cashValue?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any } } } }>, dismissedOffers?: Array<{ __typename: 'OfferType', id: string, partner?: string, policyIds?: Array<string>, premium?: number, policyType?: Array<ShoppingCategoryType>, termMonths?: number, offerDocument?: string, link?: string, carrier?: string, expiryDate?: string, logo?: string, savings?: number, partnerQuoteId?: string, shoppingCartId?: string, userSavedDate?: string, tier?: OfferTier, status?: OfferStatusType, template?: { __typename: 'OfferTemplateType', headline?: string, description?: string, logo?: string, ctaCopy?: string, ctaIcon?: OfferTemplateCtaIcon, finePrint?: string }, coverages?: { __typename: 'OfferCoverageType', othersBodilyPerson?: number, othersBodilyAccident?: number, othersPropertyAccident?: number, othersMedicalPayments?: number, uninsuredMotoristPerson?: number, comprehensiveDeductible?: number, collisionDeductible?: number, aDwelling?: number, bOtherStructures?: number, cPersonalProperty?: number, dLossUse?: number, ePersonalLiability?: number, fMedicalOthers?: number, deductibleWind?: number, deductible?: number, coinsurancePercentage?: number, reimbursementPercentage?: number, deathBenefit?: number, cashValue?: number, comparisonData?: { __typename: 'OfferCoverageComparisonDataType', othersBodilyPerson?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, othersBodilyAccident?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, othersPropertyAccident?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, othersMedicalPayments?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, uninsuredMotoristPerson?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, comprehensiveDeductible?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, collisionDeductible?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, aDwelling?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, bOtherStructures?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, cPersonalProperty?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, dLossUse?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, ePersonalLiability?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, fMedicalOthers?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, deductibleWind?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, deductible?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, coinsurancePercentage?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, reimbursementPercentage?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, deathBenefit?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, cashValue?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any } } } }> } };

export type CreateShoppingCartFromShopFlowMutationVariables = Exact<{
  input: ShoppingCartShopFlowInput;
}>;


export type CreateShoppingCartFromShopFlowMutation = { createShoppingCartFromShopFlow?: { __typename: 'ShoppingCartType', id: string, isExistingCart?: boolean } };

export type CreateShoppingCartFromDbMutationVariables = Exact<{
  input: ShoppingCartDbInput;
}>;


export type CreateShoppingCartFromDbMutation = { createShoppingCartFromDb?: { __typename: 'ShoppingCartType', id: string } };

export type RemoveDocumentMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type RemoveDocumentMutation = { deleteDocument?: { __typename: 'DeletePolicyDocument', ok?: boolean } };

export type RenameDocumentMutationVariables = Exact<{
  input: RenameDocumentInput;
}>;


export type RenameDocumentMutation = { renameDocument?: { __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number } };

export type AddEngagementCardActionMutationVariables = Exact<{
  input: EngagementCardActionInput;
}>;


export type AddEngagementCardActionMutation = { addEngagementCardAction?: { __typename: 'AddEngagementCardAction', ok?: boolean } };

export type ReadAllFeaturesMutationVariables = Exact<{ [key: string]: never; }>;


export type ReadAllFeaturesMutation = { readAllFeatureItems?: { __typename: 'ReadAllFeatureItems', ok?: boolean } };

export type ReadFeatureMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ReadFeatureMutation = { readFeatureItem?: { __typename: 'ReadFeatureItem', ok?: boolean } };

export type AnswerFeedbackQuestionMutationVariables = Exact<{
  input: FeedbackAnswerInput;
}>;


export type AnswerFeedbackQuestionMutation = { answerFeedbackQuestion?: { __typename: 'AnswerFeedbackQuestion', ok?: boolean } };

export type FinalizeQuoteMutationVariables = Exact<{
  input: FinalizeQuoteInput;
}>;


export type FinalizeQuoteMutation = { finalizeQuote?: { __typename: 'FinalizeQuote', ok?: boolean } };

export type RequestQuoteInfoMutationVariables = Exact<{
  input: RequestQuoteInfoInput;
}>;


export type RequestQuoteInfoMutation = { requestQuoteInfo?: { __typename: 'RequestQuoteInfo', ok?: boolean } };

export type GetTzPrepopLinkMutationVariables = Exact<{
  offerId: Scalars['UUID'];
}>;


export type GetTzPrepopLinkMutation = { getTzPrepopLink?: { __typename: 'OfferType', link?: string } };

export type GetUploadUrlMutationVariables = Exact<{
  input: UploadInput;
}>;


export type GetUploadUrlMutation = { getUploadUrl?: { __typename: 'CreateLink', retrieveUrl?: string, uploadUrl?: string } };

export type CreateHealthPolicyMutationVariables = Exact<{
  input: HealthPolicyInput;
}>;


export type CreateHealthPolicyMutation = { createHealthPolicy?: { __typename: 'HealthPolicyType', id: string, category?: HealthCategoryType, planName: string, groupId?: string, memberId?: string, namedInsureds: Array<{ __typename: 'HealthInsuredType', firstName?: string, lastName?: string }>, carrier: { __typename: 'HealthCarrierType', id: string, name: string, logo?: string, contactUrl?: string, claimUrl?: string }, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, name: string, documentType: DocumentTypeType, documentSize: number, created?: string }> } };

export type ArchiveHealthPolicyMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ArchiveHealthPolicyMutation = { archiveHealthPolicy?: { __typename: 'ArchiveHealthPolicy', ok?: boolean } };

export type CreateHealthPolicyDocumentMutationVariables = Exact<{
  input: UploadHealthPolicyDocumentsInput;
}>;


export type CreateHealthPolicyDocumentMutation = { createHealthPolicyDocument?: { __typename: 'HealthPolicyType', id: string, category?: HealthCategoryType, planName: string, groupId?: string, memberId?: string, namedInsureds: Array<{ __typename: 'HealthInsuredType', firstName?: string, lastName?: string }>, carrier: { __typename: 'HealthCarrierType', id: string, name: string, logo?: string, contactUrl?: string, claimUrl?: string }, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, name: string, documentType: DocumentTypeType, documentSize: number, created?: string }> } };

export type PostAgentContactMutationVariables = Exact<{
  quoteGid: Scalars['String'];
}>;


export type PostAgentContactMutation = { postAgentContact?: { __typename: 'PostAgentContact', ok?: boolean } };

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangePasswordMutation = { changePassword?: { __typename: 'UserType', id: string, firstName: string, lastName: string, preferredName?: string, legalNameConfirmed: boolean, address?: string, city?: string, zipCode?: string, state?: string, phone?: string, avatar?: string, email: string, created?: string, token?: string, gender?: GenderType, dob?: string, marbleEarned?: number, marbleAvailable?: number, marbleAvailableConverted?: number, referralCode?: string, totalReferralsBalance?: number, viewedAsBy?: string, signupBonus?: number, isAmbassador: boolean, insuranceTypes?: Array<string>, appDownloaded: boolean, shoppingZipCode?: string, creditScore?: CreditScoreType, isHomeOwner?: boolean, isInsuredForAuto?: boolean, isNewUser?: boolean, usesTobaccoProducts?: boolean, petType?: PetTypeType, petGender?: PetGenderType, zendeskToken?: string, moveInDate?: string, previousAddress?: string, previousCity?: string, previousZipCode?: string, previousState?: string, ownership?: OwnershipType, progressBar?: Array<{ __typename: 'ProgressBarType', action?: string, status?: string }>, referrals?: Array<{ __typename: 'ReferralType', firstName?: string, lastName?: string, memberSince?: string }>, policyUploadRewards?: Array<{ __typename: 'PolicyUploadRewardType', category?: string, marbleCount?: number }> } };

export type CreateCarrierReviewMutationVariables = Exact<{
  input: CarrierReviewInput;
}>;


export type CreateCarrierReviewMutation = { createCarrierReview?: { __typename: 'CreateCarrierReview', ok?: boolean } };

export type TextReferralLinkMutationVariables = Exact<{
  input?: InputMaybe<ReferralTextInput>;
}>;


export type TextReferralLinkMutation = { textReferralLink?: { __typename: 'ReferralText', ok?: boolean } };

export type EmailReferralLinkMutationVariables = Exact<{
  input: ReferralEmailInput;
}>;


export type EmailReferralLinkMutation = { emailReferralLink?: { __typename: 'ReferralEmail', ok?: boolean } };

export type UpdateMeMutationVariables = Exact<{
  input: ProfileInput;
}>;


export type UpdateMeMutation = { user?: { __typename: 'UserType', id: string, firstName: string, lastName: string, preferredName?: string, legalNameConfirmed: boolean, address?: string, city?: string, zipCode?: string, state?: string, phone?: string, avatar?: string, email: string, created?: string, token?: string, gender?: GenderType, dob?: string, marbleEarned?: number, marbleAvailable?: number, marbleAvailableConverted?: number, referralCode?: string, totalReferralsBalance?: number, viewedAsBy?: string, signupBonus?: number, isAmbassador: boolean, insuranceTypes?: Array<string>, appDownloaded: boolean, shoppingZipCode?: string, creditScore?: CreditScoreType, isHomeOwner?: boolean, isInsuredForAuto?: boolean, isNewUser?: boolean, usesTobaccoProducts?: boolean, petType?: PetTypeType, petGender?: PetGenderType, zendeskToken?: string, moveInDate?: string, previousAddress?: string, previousCity?: string, previousZipCode?: string, previousState?: string, ownership?: OwnershipType, progressBar?: Array<{ __typename: 'ProgressBarType', action?: string, status?: string }>, referrals?: Array<{ __typename: 'ReferralType', firstName?: string, lastName?: string, memberSince?: string }>, policyUploadRewards?: Array<{ __typename: 'PolicyUploadRewardType', category?: string, marbleCount?: number }> } };

export type TextMeMutationVariables = Exact<{
  input?: InputMaybe<TextMeInput>;
}>;


export type TextMeMutation = { textMe?: { __typename: 'TextMe', ok?: boolean } };

export type RequestPhoneVerificationMutationVariables = Exact<{
  phone: Scalars['String'];
}>;


export type RequestPhoneVerificationMutation = { requestPhoneVerification?: { __typename: 'RequestPhoneVerificationCode', ok?: boolean } };

export type ValidatePhoneVerificationMutationVariables = Exact<{
  code: Scalars['Int'];
}>;


export type ValidatePhoneVerificationMutation = { validatePhoneVerification?: { __typename: 'ValidatePhoneVerificationCode', ok?: boolean } };

export type UpdateShopFormPathMutationVariables = Exact<{
  path: Scalars['String'];
}>;


export type UpdateShopFormPathMutation = { updateShopFormPath?: { __typename: 'ShopFormPath', ok?: boolean } };

export type UpdateDriverMutationVariables = Exact<{
  input: DriverInput;
}>;


export type UpdateDriverMutation = { driver?: { __typename: 'DriverType', id: string, created?: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, careerStatus?: NamedInsuredBaseCareerStatus, educationLevel?: NamedInsuredBaseEducationLevel, ageFirstLicensed?: number, driversLicenseNumber?: string, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseState?: { __typename: 'StateType', id: string, name: string } } };

export type UpdateHomeOwnerMutationVariables = Exact<{
  input: HomeOwnerInput;
}>;


export type UpdateHomeOwnerMutation = { homeOwner?: { __typename: 'HomeOwnerType', id: string, created?: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, educationLevel?: NamedInsuredBaseEducationLevel, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } } };

export type UpdateLifeInsuredMutationVariables = Exact<{
  input: LifeInsuredInput;
}>;


export type UpdateLifeInsuredMutation = { lifeInsured?: { __typename: 'LifeInsuredType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, educationLevel?: NamedInsuredBaseEducationLevel, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } } };

export type UpdateRenterMutationVariables = Exact<{
  input: RenterInput;
}>;


export type UpdateRenterMutation = { renter?: { __typename: 'RenterType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } } };

export type UpdateNamedInsuredMutationVariables = Exact<{
  input: UpdateNamedInsuredInput;
}>;


export type UpdateNamedInsuredMutation = { updateNamedInsured?: { __typename: 'NamedInsuredType', id: string, gender?: NamedInsuredBaseGender, dob?: string, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } } };

export type SplitNamedInsuredsMutationVariables = Exact<{
  input: SplitNamedInsuredsInput;
}>;


export type SplitNamedInsuredsMutation = { splitNamedInsureds?: Array<{ __typename: 'NamedInsuredType', id: string }> };

export type MergeNamedInsuredsMutationVariables = Exact<{
  input: MergeNamedInsuredsInput;
}>;


export type MergeNamedInsuredsMutation = { mergeNamedInsureds?: Array<{ __typename: 'NamedInsuredType', id: string }> };

export type CreateOrUpdateNamedInsuredMutationVariables = Exact<{
  input: CreateOrUpdateNamedInsuredInput;
}>;


export type CreateOrUpdateNamedInsuredMutation = { createOrUpdateNamedInsured?: { __typename: 'NamedInsuredReturnType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: NamedInsuredBaseGender, name?: string } };

export type NfpSelectQuoteMutationVariables = Exact<{
  offerId: Scalars['String'];
}>;


export type NfpSelectQuoteMutation = { nfpSelectQuote?: { __typename: 'NotifyNFP', ok?: boolean } };

export type DismissOfferMutationVariables = Exact<{
  input: DismissOfferInput;
}>;


export type DismissOfferMutation = { dismissOffer?: { __typename: 'DismissOffer', ok?: boolean } };

export type UpdateSavedOfferMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type UpdateSavedOfferMutation = { updateSavedOffer?: { __typename: 'UpdateSavedOffer', ok?: boolean } };

export type RestoreOfferMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type RestoreOfferMutation = { restoreOffer?: { __typename: 'RestoreOffer', ok?: boolean } };

export type RemoveOtherPolicyMutationVariables = Exact<{
  input: OtherPolicyDeleteInput;
}>;


export type RemoveOtherPolicyMutation = { deleteOtherPolicy?: { __typename: 'DeleteOtherPolicy', ok?: boolean } };

export type UploadOtherPolicyDocumentMutationVariables = Exact<{
  input: UploadOtherPolicyDocumentsInput;
}>;


export type UploadOtherPolicyDocumentMutation = { uploadOtherPolicyDocument?: { __typename: 'OtherPolicyType', id: string, category?: OtherCategoryType, otherCategory?: string, documents: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }> } };

export type SavePaymentTokenMutationVariables = Exact<{
  paymentTokenId: Scalars['UUID'];
  offerId: Scalars['UUID'];
}>;


export type SavePaymentTokenMutation = { savePaymentToken?: { __typename: 'SavePaymentToken', ok?: boolean } };

export type AuthorizePaymentDisplayMutationVariables = Exact<{
  input: AuthorizePaymentDisplayInput;
}>;


export type AuthorizePaymentDisplayMutation = { authorizePaymentDisplay?: { __typename: 'AuthorizePaymentDisplay', ok?: boolean } };

export type ArchivePolicyMutationVariables = Exact<{
  input: ArchivePolicyInput;
}>;


export type ArchivePolicyMutation = { archivePolicy?: boolean };

export type CreatePolicyUserMutationVariables = Exact<{
  input: UserCarrierInput;
}>;


export type CreatePolicyUserMutation = { createUserCarrier?: { __typename: 'AutoPolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, namedInsured?: Array<string>, address?: string, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, vehicles: Array<{ __typename: 'VehicleAssetType', id: string, vehicleInfo?: string, vehicleVin?: string, year?: number, make?: string, model?: string, ownership?: string, primaryUse?: string, othersBodilyPerson?: number, othersBodilyAccident?: number, othersMedicalPayments?: number, othersPropertyAccident?: number, personalProtectionPerson?: number, uninsuredMotoristPerson?: number, uninsuredMotoristAccident?: number, uninsuredPropertyAccident?: number, uninsuredPropertyDeductible?: number, comprehensiveValue?: string, comprehensiveDeductible?: number, collisionValue?: string, collisionDeductible?: number, reimbursementDay?: number, roadsideAssistance: boolean, roadsideAssistanceValue?: number, totalPremium?: number }>, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, drivers: Array<{ __typename: 'DriverType', id: string, created?: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, careerStatus?: NamedInsuredBaseCareerStatus, educationLevel?: NamedInsuredBaseEducationLevel, ageFirstLicensed?: number, driversLicenseNumber?: string, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }> } | { __typename: 'HomePolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, namedInsured?: Array<string>, address?: string, dwelling?: number, otherStructures?: number, personalProperty?: number, lossUse?: number, personalLiability?: number, medicalOthers?: number, deductible?: number, deductibleWind?: number, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, homeOwners: Array<{ __typename: 'HomeOwnerType', id: string, created?: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, educationLevel?: NamedInsuredBaseEducationLevel, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }>, properties: Array<{ __typename: 'PropertyType', id: string, addressLine1?: string, addressLine2?: string, propertyCity?: string, propertyZipCode?: string, typeOfProperty?: PropertyAssetTypeOfProperty, typeOfResidence?: PropertyAssetTypeOfResidence, yearBuilt?: number, squareFootage?: number, construction?: PropertyAssetConstruction, foundation?: PropertyAssetFoundation, roof?: PropertyAssetRoof, roofYearBuilt?: number, fireAlarm?: boolean, propertyState?: { __typename: 'StateType', id: string, name: string } }> } | { __typename: 'LifePolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, namedInsured?: Array<string>, address?: string, planType?: LifePolicyPlanType, otherTermYears?: number, deathBenefit?: number, conversionDate?: string, riders?: string, isGroup: boolean, cashValue?: number, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, beneficiaries: Array<{ __typename: 'BeneficiaryType', firstName?: string, lastName?: string, percentage?: number }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, lifeInsureds: Array<{ __typename: 'LifeInsuredType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, educationLevel?: NamedInsuredBaseEducationLevel, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }> } | { __typename: 'PetPolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, address?: string, petParent?: string, petParentAddress?: string, petName?: string, petType?: string, petBreed?: string, petDob?: string, petSex?: PetGenderType, hasBitten?: boolean, coinsurance?: number, reimbursement?: number, annualDeductible?: number, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, petOwners: Array<{ __typename: 'PetOwnerType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember }> } | { __typename: 'PolicyType', id: string, address?: string, isPolicyOwner?: boolean, isOnRenewal?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }> } | { __typename: 'RenterPolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, namedInsured?: Array<string>, address?: string, personalProperty?: number, lossUse?: number, personalLiability?: number, medicalOthers?: number, deductible?: number, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, renters: Array<{ __typename: 'RenterType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }>, rentals: Array<{ __typename: 'RentalType', id: string, address?: string, addressLine?: string, city?: string, zipCode?: string, typeOfProperty?: RentalAssetTypeOfProperty, state?: { __typename: 'StateType', id: string, name: string } }> } };

export type UploadPolicyDocumentMutationVariables = Exact<{
  input: UploadPolicyDocumentsInput;
}>;


export type UploadPolicyDocumentMutation = { uploadPolicyDocument?: { __typename: 'AutoPolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, namedInsured?: Array<string>, address?: string, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, vehicles: Array<{ __typename: 'VehicleAssetType', id: string, vehicleInfo?: string, vehicleVin?: string, year?: number, make?: string, model?: string, ownership?: string, primaryUse?: string, othersBodilyPerson?: number, othersBodilyAccident?: number, othersMedicalPayments?: number, othersPropertyAccident?: number, personalProtectionPerson?: number, uninsuredMotoristPerson?: number, uninsuredMotoristAccident?: number, uninsuredPropertyAccident?: number, uninsuredPropertyDeductible?: number, comprehensiveValue?: string, comprehensiveDeductible?: number, collisionValue?: string, collisionDeductible?: number, reimbursementDay?: number, roadsideAssistance: boolean, roadsideAssistanceValue?: number, totalPremium?: number }>, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, drivers: Array<{ __typename: 'DriverType', id: string, created?: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, careerStatus?: NamedInsuredBaseCareerStatus, educationLevel?: NamedInsuredBaseEducationLevel, ageFirstLicensed?: number, driversLicenseNumber?: string, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }> } | { __typename: 'HomePolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, namedInsured?: Array<string>, address?: string, dwelling?: number, otherStructures?: number, personalProperty?: number, lossUse?: number, personalLiability?: number, medicalOthers?: number, deductible?: number, deductibleWind?: number, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, homeOwners: Array<{ __typename: 'HomeOwnerType', id: string, created?: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, educationLevel?: NamedInsuredBaseEducationLevel, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }>, properties: Array<{ __typename: 'PropertyType', id: string, addressLine1?: string, addressLine2?: string, propertyCity?: string, propertyZipCode?: string, typeOfProperty?: PropertyAssetTypeOfProperty, typeOfResidence?: PropertyAssetTypeOfResidence, yearBuilt?: number, squareFootage?: number, construction?: PropertyAssetConstruction, foundation?: PropertyAssetFoundation, roof?: PropertyAssetRoof, roofYearBuilt?: number, fireAlarm?: boolean, propertyState?: { __typename: 'StateType', id: string, name: string } }> } | { __typename: 'LifePolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, namedInsured?: Array<string>, address?: string, planType?: LifePolicyPlanType, otherTermYears?: number, deathBenefit?: number, conversionDate?: string, riders?: string, isGroup: boolean, cashValue?: number, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, beneficiaries: Array<{ __typename: 'BeneficiaryType', firstName?: string, lastName?: string, percentage?: number }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, lifeInsureds: Array<{ __typename: 'LifeInsuredType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, educationLevel?: NamedInsuredBaseEducationLevel, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }> } | { __typename: 'PetPolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, address?: string, petParent?: string, petParentAddress?: string, petName?: string, petType?: string, petBreed?: string, petDob?: string, petSex?: PetGenderType, hasBitten?: boolean, coinsurance?: number, reimbursement?: number, annualDeductible?: number, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, petOwners: Array<{ __typename: 'PetOwnerType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember }> } | { __typename: 'PolicyType', id: string, address?: string, isPolicyOwner?: boolean, isOnRenewal?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }> } | { __typename: 'RenterPolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, namedInsured?: Array<string>, address?: string, personalProperty?: number, lossUse?: number, personalLiability?: number, medicalOthers?: number, deductible?: number, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, renters: Array<{ __typename: 'RenterType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }>, rentals: Array<{ __typename: 'RentalType', id: string, address?: string, addressLine?: string, city?: string, zipCode?: string, typeOfProperty?: RentalAssetTypeOfProperty, state?: { __typename: 'StateType', id: string, name: string } }> } };

export type MarkPolicySyncAnimationShownMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MarkPolicySyncAnimationShownMutation = { markPolicySyncAnimationShown?: { __typename: 'AutoPolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, namedInsured?: Array<string>, address?: string, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, vehicles: Array<{ __typename: 'VehicleAssetType', id: string, vehicleInfo?: string, vehicleVin?: string, year?: number, make?: string, model?: string, ownership?: string, primaryUse?: string, othersBodilyPerson?: number, othersBodilyAccident?: number, othersMedicalPayments?: number, othersPropertyAccident?: number, personalProtectionPerson?: number, uninsuredMotoristPerson?: number, uninsuredMotoristAccident?: number, uninsuredPropertyAccident?: number, uninsuredPropertyDeductible?: number, comprehensiveValue?: string, comprehensiveDeductible?: number, collisionValue?: string, collisionDeductible?: number, reimbursementDay?: number, roadsideAssistance: boolean, roadsideAssistanceValue?: number, totalPremium?: number }>, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, drivers: Array<{ __typename: 'DriverType', id: string, created?: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, careerStatus?: NamedInsuredBaseCareerStatus, educationLevel?: NamedInsuredBaseEducationLevel, ageFirstLicensed?: number, driversLicenseNumber?: string, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }> } | { __typename: 'HomePolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, namedInsured?: Array<string>, address?: string, dwelling?: number, otherStructures?: number, personalProperty?: number, lossUse?: number, personalLiability?: number, medicalOthers?: number, deductible?: number, deductibleWind?: number, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, homeOwners: Array<{ __typename: 'HomeOwnerType', id: string, created?: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, educationLevel?: NamedInsuredBaseEducationLevel, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }>, properties: Array<{ __typename: 'PropertyType', id: string, addressLine1?: string, addressLine2?: string, propertyCity?: string, propertyZipCode?: string, typeOfProperty?: PropertyAssetTypeOfProperty, typeOfResidence?: PropertyAssetTypeOfResidence, yearBuilt?: number, squareFootage?: number, construction?: PropertyAssetConstruction, foundation?: PropertyAssetFoundation, roof?: PropertyAssetRoof, roofYearBuilt?: number, fireAlarm?: boolean, propertyState?: { __typename: 'StateType', id: string, name: string } }> } | { __typename: 'LifePolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, namedInsured?: Array<string>, address?: string, planType?: LifePolicyPlanType, otherTermYears?: number, deathBenefit?: number, conversionDate?: string, riders?: string, isGroup: boolean, cashValue?: number, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, beneficiaries: Array<{ __typename: 'BeneficiaryType', firstName?: string, lastName?: string, percentage?: number }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, lifeInsureds: Array<{ __typename: 'LifeInsuredType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, educationLevel?: NamedInsuredBaseEducationLevel, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }> } | { __typename: 'PetPolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, address?: string, petParent?: string, petParentAddress?: string, petName?: string, petType?: string, petBreed?: string, petDob?: string, petSex?: PetGenderType, hasBitten?: boolean, coinsurance?: number, reimbursement?: number, annualDeductible?: number, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, petOwners: Array<{ __typename: 'PetOwnerType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember }> } | { __typename: 'PolicyType', id: string, address?: string, isPolicyOwner?: boolean, isOnRenewal?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }> } | { __typename: 'RenterPolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, namedInsured?: Array<string>, address?: string, personalProperty?: number, lossUse?: number, personalLiability?: number, medicalOthers?: number, deductible?: number, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, renters: Array<{ __typename: 'RenterType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }>, rentals: Array<{ __typename: 'RentalType', id: string, address?: string, addressLine?: string, city?: string, zipCode?: string, typeOfProperty?: RentalAssetTypeOfProperty, state?: { __typename: 'StateType', id: string, name: string } }> } };

export type AcceptSharedAccessMutationVariables = Exact<{
  sharedAccessId: Scalars['UUID'];
}>;


export type AcceptSharedAccessMutation = { acceptSharedAccess?: { __typename: 'AcceptSharedAccess', ok?: boolean } };

export type CreateHomeFromAddressMutationVariables = Exact<{
  input: PropertyOrRentalAddressInput;
}>;


export type CreateHomeFromAddressMutation = { createHomeFromAddress?: { __typename: 'PropertyOrRentalAddressType', id?: string, address?: string } };

export type CreateOrUpdatePropertyMutationVariables = Exact<{
  input: PropertyAssetInput;
}>;


export type CreateOrUpdatePropertyMutation = { property?: { __typename: 'PropertyType', id: string, addressLine1?: string, addressLine2?: string, propertyCity?: string, propertyZipCode?: string, numBeds?: number, squareFootage?: number, yearBuilt?: number, numBathsFull?: number, numBathsPartial?: number, numStories?: number, roofYearBuilt?: number, heatingAndCoolingUpdated?: number, electricalUpdated?: number, plumbingUpdated?: number, securitySystem?: boolean, securitySystemType?: SecurityTypeType, fireAlarm?: boolean, fireAlarmType?: SecurityTypeType, isGatedCommunity?: boolean, hasTrampoline?: boolean, trampolineSafetyNet?: boolean, hasPool?: boolean, poolType?: PoolType, poolHasSlide?: boolean, poolHasDivingBoard?: boolean, poolHasFence?: boolean, poolHasCage?: boolean, hasDogs?: boolean, deductibleHome?: HomeDeductibleLimitType, deductibleWind?: WindDeductibleLimitType, previousCarrier?: string, previousCarrierYears?: number, previousPolicyExpiry?: string, previousPremium?: number, purchaseDate?: string, policyShopReason?: PropertyAssetPolicyShopReason, propertyState?: { __typename: 'StateType', id: string, abbreviation?: string, name: string } } };

export type RequestRedemptionMutationVariables = Exact<{
  input: RedemptionRequestInput;
}>;


export type RequestRedemptionMutation = { requestRedemption?: { __typename: 'RedemptionRequestType', id: string, message?: string } };

export type CreateReminderMutationVariables = Exact<{
  input: CreateReminderInput;
}>;


export type CreateReminderMutation = { createReminder?: { __typename: 'ReminderType', id: string, notes?: string, reminderCategory?: ReminderCategoryType, reminderDate: string, reminderMethod: ReminderMethodType, policyCategory?: CategoryType, policy?: { __typename: 'PolicyType', id: string } } };

export type DeleteReminderMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteReminderMutation = { deleteReminder?: { __typename: 'DeleteReminder', ok?: boolean } };

export type CreateRenewalOfferMutationVariables = Exact<{
  input: RenewalOfferInput;
}>;


export type CreateRenewalOfferMutation = { createOrUpdateRenewalOffer?: { __typename: 'CreateOrUpdateRenewalOffer', ok?: boolean } };

export type CreateSharedAccessMutationVariables = Exact<{
  input: SharedAccessInput;
}>;


export type CreateSharedAccessMutation = { createSharedAccess?: { __typename: 'SharedAccessType', namedInsuredId?: string, email?: string, fullName?: string, id?: string, status?: SharedAccessStatusType } };

export type RemoveSharedAccessMutationVariables = Exact<{
  sharedAccessId: Scalars['UUID'];
}>;


export type RemoveSharedAccessMutation = { removeSharedAccess?: { __typename: 'RemoveSharedAccess', ok?: boolean } };

export type RemoveSharedPolicyMutationVariables = Exact<{
  policyId: Scalars['UUID'];
}>;


export type RemoveSharedPolicyMutation = { removeSharedAccess?: { __typename: 'RemoveSharedAccess', ok?: boolean } };

export type UpdateShopFirstUserMutationVariables = Exact<{
  input: ShopUserInput;
}>;


export type UpdateShopFirstUserMutation = { shopFirstUser?: { __typename: 'ShopUserProfileType', assets?: Array<{ __typename: 'ShopAssetType', id?: string, name?: string, vin?: string, address?: string, drivers?: Array<{ __typename: 'ShopDriverType', id?: string, name?: string, isPrimary?: boolean }> }>, namedInsureds?: Array<{ __typename: 'ShopNamedInsuredType', id?: string, name?: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType }> } };

export type SaveShopFlowProgressMutationVariables = Exact<{
  returnLink: Scalars['String'];
}>;


export type SaveShopFlowProgressMutation = { saveShopFlowProgress?: { __typename: 'SaveShopFlowProgress', ok?: boolean } };

export type CreateOrUpdateVehicleMutationVariables = Exact<{
  input: VehicleAssetInput;
}>;


export type CreateOrUpdateVehicleMutation = { vehicle?: { __typename: 'VehicleType', id: string, ownership?: VehicleAssetOwnership, primaryUse?: VehicleAssetPrimaryUse, vehicleInfo?: string, vehicleVin?: string, hasExistingDamage?: boolean, deliveryUse?: boolean, rideshareUse?: boolean, monitoredDrivingDiscount?: boolean, primaryDriver?: { __typename: 'DriverType', id: string }, drivers: Array<{ __typename: 'DriverType', id: string }>, desiredCoverages: Array<{ __typename: 'DesiredCoveragesType', comprehensiveDeductible?: ComprehensiveAndCollisionDeductibleType, collisionDeductible?: ComprehensiveAndCollisionDeductibleType, towing?: TowingCoverageType, rental?: RentalCoverageType, bodilyInjury?: BodilyInjuryCoverageType, propertyDamage?: PropertyDamageCoverageType, uninsuredMotorist?: UnAndUnderInsuredCoverageType, uninsuredMotoristPropertyDamage?: PropertyDamageCoverageType, underinsuredMotorist?: UnAndUnderInsuredCoverageType }> } };

export type CreateVehicleFromVinMutationVariables = Exact<{
  input: VehicleAssetVinInput;
}>;


export type CreateVehicleFromVinMutation = { createVehicleFromVin?: { __typename: 'VehicleType', id: string, ownership?: VehicleAssetOwnership, primaryUse?: VehicleAssetPrimaryUse, vehicleInfo?: string, vehicleVin?: string, hasExistingDamage?: boolean, deliveryUse?: boolean, rideshareUse?: boolean, monitoredDrivingDiscount?: boolean, primaryDriver?: { __typename: 'DriverType', id: string }, drivers: Array<{ __typename: 'DriverType', id: string }>, desiredCoverages: Array<{ __typename: 'DesiredCoveragesType', comprehensiveDeductible?: ComprehensiveAndCollisionDeductibleType, collisionDeductible?: ComprehensiveAndCollisionDeductibleType, towing?: TowingCoverageType, rental?: RentalCoverageType, bodilyInjury?: BodilyInjuryCoverageType, propertyDamage?: PropertyDamageCoverageType, uninsuredMotorist?: UnAndUnderInsuredCoverageType, uninsuredMotoristPropertyDamage?: PropertyDamageCoverageType, underinsuredMotorist?: UnAndUnderInsuredCoverageType }> } };

export type CreateVehicleFromDetailsMutationVariables = Exact<{
  input: VehicleAssetDetailInput;
}>;


export type CreateVehicleFromDetailsMutation = { createVehicleFromDetails?: { __typename: 'VehicleType', id: string, ownership?: VehicleAssetOwnership, primaryUse?: VehicleAssetPrimaryUse, vehicleInfo?: string, vehicleVin?: string, hasExistingDamage?: boolean, deliveryUse?: boolean, rideshareUse?: boolean, monitoredDrivingDiscount?: boolean, primaryDriver?: { __typename: 'DriverType', id: string }, drivers: Array<{ __typename: 'DriverType', id: string }>, desiredCoverages: Array<{ __typename: 'DesiredCoveragesType', comprehensiveDeductible?: ComprehensiveAndCollisionDeductibleType, collisionDeductible?: ComprehensiveAndCollisionDeductibleType, towing?: TowingCoverageType, rental?: RentalCoverageType, bodilyInjury?: BodilyInjuryCoverageType, propertyDamage?: PropertyDamageCoverageType, uninsuredMotorist?: UnAndUnderInsuredCoverageType, uninsuredMotoristPropertyDamage?: PropertyDamageCoverageType, underinsuredMotorist?: UnAndUnderInsuredCoverageType }> } };

export type UpdateVehicleDriversMutationVariables = Exact<{
  input: VehicleDriversInput;
}>;


export type UpdateVehicleDriversMutation = { updateVehicleDrivers?: { __typename: 'VehicleType', id: string, primaryDriver?: { __typename: 'DriverType', id: string, name?: string }, drivers: Array<{ __typename: 'DriverType', id: string, name?: string }> } };

export type CreateViuLeadMutationVariables = Exact<{
  offerId: Scalars['UUID'];
}>;


export type CreateViuLeadMutation = { createViuLead?: { __typename: 'NotifyVIU', ok?: boolean } };

export type ActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type ActivitiesQuery = { activities?: Array<{ __typename: 'ActivityType', id: string, activityType: ActivityTypeType, concept: string, status?: StatusType, marbles: number, money: number, date: string, message?: string, isDonation?: boolean }> };

export type VehiclesQueryVariables = Exact<{ [key: string]: never; }>;


export type VehiclesQuery = { vehicles?: Array<{ __typename: 'VehicleType', id: string, ownership?: VehicleAssetOwnership, primaryUse?: VehicleAssetPrimaryUse, vehicleInfo?: string, vehicleVin?: string, hasExistingDamage?: boolean, deliveryUse?: boolean, rideshareUse?: boolean, monitoredDrivingDiscount?: boolean, primaryDriver?: { __typename: 'DriverType', id: string }, drivers: Array<{ __typename: 'DriverType', id: string }>, desiredCoverages: Array<{ __typename: 'DesiredCoveragesType', comprehensiveDeductible?: ComprehensiveAndCollisionDeductibleType, collisionDeductible?: ComprehensiveAndCollisionDeductibleType, towing?: TowingCoverageType, rental?: RentalCoverageType, bodilyInjury?: BodilyInjuryCoverageType, propertyDamage?: PropertyDamageCoverageType, uninsuredMotorist?: UnAndUnderInsuredCoverageType, uninsuredMotoristPropertyDamage?: PropertyDamageCoverageType, underinsuredMotorist?: UnAndUnderInsuredCoverageType }> }> };

export type PropertiesQueryVariables = Exact<{ [key: string]: never; }>;


export type PropertiesQuery = { properties?: Array<{ __typename: 'PropertyType', id: string, addressLine1?: string, addressLine2?: string, propertyCity?: string, propertyZipCode?: string, numBeds?: number, squareFootage?: number, yearBuilt?: number, numBathsFull?: number, numBathsPartial?: number, numStories?: number, roofYearBuilt?: number, heatingAndCoolingUpdated?: number, electricalUpdated?: number, plumbingUpdated?: number, securitySystem?: boolean, securitySystemType?: SecurityTypeType, fireAlarm?: boolean, fireAlarmType?: SecurityTypeType, isGatedCommunity?: boolean, hasTrampoline?: boolean, trampolineSafetyNet?: boolean, hasPool?: boolean, poolType?: PoolType, poolHasSlide?: boolean, poolHasDivingBoard?: boolean, poolHasFence?: boolean, poolHasCage?: boolean, hasDogs?: boolean, deductibleHome?: HomeDeductibleLimitType, deductibleWind?: WindDeductibleLimitType, previousCarrier?: string, previousCarrierYears?: number, previousPolicyExpiry?: string, previousPremium?: number, purchaseDate?: string, policyShopReason?: PropertyAssetPolicyShopReason, propertyState?: { __typename: 'StateType', id: string, abbreviation?: string, name: string } }> };

export type BannersQueryVariables = Exact<{
  sourceType: SourceType;
}>;


export type BannersQuery = { banners?: Array<{ __typename: 'BannerType', page?: BannerPage, text: string }> };

export type CanopyTermsOfServiceQueryVariables = Exact<{ [key: string]: never; }>;


export type CanopyTermsOfServiceQuery = { canopyTermsOfService?: { __typename: 'CanopyTosType', termsVersion?: number } };

export type CanopyPollQueryVariables = Exact<{
  pullId: Scalars['String'];
  pullJwt: Scalars['String'];
  category: CategoryType;
  insurerName: Scalars['String'];
  policyId?: InputMaybe<Scalars['UUID']>;
  email?: InputMaybe<Scalars['String']>;
}>;


export type CanopyPollQuery = { canopyPoll?: { __typename: 'CanopyConnectResponseType', status?: string, pullId?: string, loginErrorMessage?: string, mfaOptions?: any, mfaHelperText?: string, email?: string, firstName?: string, lastName?: string, phone?: string, userId?: string } };

export type IsCarrierCheckableQueryVariables = Exact<{
  carrierId: Scalars['UUID'];
}>;


export type IsCarrierCheckableQuery = { isCarrierCheckable?: boolean };

export type CarriersQueryVariables = Exact<{
  category?: InputMaybe<CategoryType>;
  insuranceInsider?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderByInputType>> | InputMaybe<OrderByInputType>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type CarriersQuery = { carriers?: { __typename: 'CarrierPaginatedType', page?: number, pages?: number, hasNext?: boolean, hasPrev?: boolean, totalResults?: number, objects?: Array<{ __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }> } };

export type CoverageItemInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type CoverageItemInfoQuery = { coverageItemsInfo?: Array<{ __typename: 'CoverageItemInfoType', id: string, coverageItem: CoverageItemType, definition: string, examples: Array<{ __typename: 'CoverageItemInfoExampleType', id: string, exampleType: ExampleTypeType, title: string, icon?: string, videoUrl?: string, order: number }> }> };

export type DocumentUrlQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type DocumentUrlQuery = { documentUrl?: string };

export type EngagementCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type EngagementCardsQuery = { engagementCards?: Array<{ __typename: 'EngagementCardType', id: string, actionType: EngagementCardActionType, actionUrl?: string, ctaCopy?: string, image?: string, isActive: boolean, questionText: string, rewardAmount?: number, answerChoices: Array<{ __typename: 'EngagementCardAnswerChoiceType', id: string, order?: number, text: string }>, userengagementcardactionSet: Array<{ __typename: 'UserEngagementCardActionType', actionTaken?: boolean, booleanAnswer?: boolean, dateAnswer?: string, textAnswer?: string, choicesAnswer: Array<{ __typename: 'EngagementCardAnswerChoiceType', id: string, text: string }> }> }> };

export type FeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type FeaturesQuery = { featureItems?: Array<{ __typename: 'FeatureItemType', id: string, title: string, description: string, image?: string, imageBgcolor?: string, featureType: FeatureTypeType, date?: string, featured: boolean, read: boolean }> };

export type FeedbackQuestionsQueryVariables = Exact<{
  path: Scalars['String'];
}>;


export type FeedbackQuestionsQuery = { feedbackQuestions?: Array<{ __typename: 'FeedbackQuestionType', id: string, questionText: string, feedbackType: FeedbackTypeType, action?: FeedbackActionType, pagePath: string }> };

export type HealthCarriersQueryVariables = Exact<{
  category?: InputMaybe<HealthCategoryType>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type HealthCarriersQuery = { healthCarriers?: Array<{ __typename: 'HealthCarrierType', id: string, name: string, logo?: string, categories?: Array<HealthCategoryType>, healthPlanNames?: Array<string>, visionPlanNames?: Array<string>, dentalPlanNames?: Array<string> }> };

export type HealthPoliciesQueryVariables = Exact<{
  isCurrent?: InputMaybe<Scalars['Boolean']>;
}>;


export type HealthPoliciesQuery = { healthPolicies?: Array<{ __typename: 'HealthPolicyType', id: string, category?: HealthCategoryType, planName: string, groupId?: string, memberId?: string, namedInsureds: Array<{ __typename: 'HealthInsuredType', firstName?: string, lastName?: string }>, carrier: { __typename: 'HealthCarrierType', id: string, name: string, logo?: string, contactUrl?: string, claimUrl?: string }, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, name: string, documentType: DocumentTypeType, documentSize: number, created?: string }> }> };

export type ImpressionGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type ImpressionGroupsQuery = { impressionGroups?: Array<{ __typename: 'ImpressionGroupType', id: string, title: string, insuranceTypes: Array<string>, tags: Array<string>, isActive: boolean, limitPlacements?: number }> };

export type MarketingLandingQueryVariables = Exact<{
  partnerSlug: Scalars['String'];
}>;


export type MarketingLandingQuery = { marketingLandingData?: { __typename: 'MarketingLandingDataType', id: string, partnerSlug: string, pageType: PageTypeType, partnerLogo?: string, title?: string, subtitle?: string, metadata?: string, popupTitle?: string, popupSubtitle?: string, popupCta?: string, popupRedirect?: string, commonData: { __typename: 'CommonLandingDataType', mainImage?: string, headerTitle?: string, subheader1Title?: string, subheader1Text?: string, subheader2Title?: string, subheader2Text?: string, subheader3Title?: string, subheader3Text?: string, subheader4Title?: string, subheader4Text?: string, footerTitle?: string, footerCta?: string, testimonials?: Array<{ __typename: 'TestimonialType', image?: string, location?: string, rating: number, text: string, title?: string, userName?: string }> } } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { me?: { __typename: 'UserType', id: string, firstName: string, lastName: string, preferredName?: string, legalNameConfirmed: boolean, address?: string, city?: string, zipCode?: string, state?: string, phone?: string, avatar?: string, email: string, created?: string, token?: string, gender?: GenderType, dob?: string, marbleEarned?: number, marbleAvailable?: number, marbleAvailableConverted?: number, referralCode?: string, totalReferralsBalance?: number, viewedAsBy?: string, signupBonus?: number, isAmbassador: boolean, insuranceTypes?: Array<string>, appDownloaded: boolean, shoppingZipCode?: string, creditScore?: CreditScoreType, isHomeOwner?: boolean, isInsuredForAuto?: boolean, isNewUser?: boolean, usesTobaccoProducts?: boolean, petType?: PetTypeType, petGender?: PetGenderType, zendeskToken?: string, moveInDate?: string, previousAddress?: string, previousCity?: string, previousZipCode?: string, previousState?: string, ownership?: OwnershipType, progressBar?: Array<{ __typename: 'ProgressBarType', action?: string, status?: string }>, referrals?: Array<{ __typename: 'ReferralType', firstName?: string, lastName?: string, memberSince?: string }>, policyUploadRewards?: Array<{ __typename: 'PolicyUploadRewardType', category?: string, marbleCount?: number }> } };

export type NamedInsuredsQueryVariables = Exact<{ [key: string]: never; }>;


export type NamedInsuredsQuery = { namedInsureds?: Array<{ __typename: 'NamedInsuredType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: NamedInsuredBaseGender, altNames?: Array<string>, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, parentId?: string, namedType?: string, driversLicenseState?: { __typename: 'StateType', abbreviation?: string, id: string, name: string } }> };

export type DriversQueryVariables = Exact<{ [key: string]: never; }>;


export type DriversQuery = { drivers?: Array<{ __typename: 'DriverType', created?: string, id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, educationLevel?: NamedInsuredBaseEducationLevel, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', abbreviation?: string, id: string, name: string } }> };

export type HomeOwnersQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeOwnersQuery = { homeOwners?: Array<{ __typename: 'HomeOwnerType', created?: string, id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, educationLevel?: NamedInsuredBaseEducationLevel, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', abbreviation?: string, id: string, name: string } }> };

export type BindableOffersQueryVariables = Exact<{ [key: string]: never; }>;


export type BindableOffersQuery = { bindableOffers?: Array<{ __typename: 'BindableOfferType', id: string, assetName?: string, paymentDetailsSubmitted?: boolean }> };

export type OtherPoliciesQueryVariables = Exact<{ [key: string]: never; }>;


export type OtherPoliciesQuery = { otherPolicies?: Array<{ __typename: 'OtherPolicyType', id: string, category?: OtherCategoryType, otherCategory?: string, documents: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }> }> };

export type PartnerOffersQueryVariables = Exact<{
  category?: InputMaybe<ShoppingCategoryType>;
}>;


export type PartnerOffersQuery = { partnerOffers?: Array<{ __typename: 'PartnerOfferType', id: string, title: string, cardImage?: string, shortDescription?: string, modalImage?: string, modalContent?: string, ctaUrl?: string, startDate?: string, endDate?: string, active: boolean }> };

export type PaymentPageDetailsQueryVariables = Exact<{
  offerId: Scalars['UUID'];
}>;


export type PaymentPageDetailsQuery = { paymentPageDetails?: { __typename: 'PaymentPageType', offerId?: string, email?: string, isPaymentSubmitted?: boolean, termMonths?: number, expiryDate?: string, category?: ShoppingCategoryType, carrier?: string, carrierLogo?: string, offerDetails?: string, namedInsureds?: string, assetName?: string, monthlyPremium?: any, paymentDetails?: { __typename: 'PaymentDetailsType', paymentToken?: string, paymentMethod?: PaymentMethodType, accountNumber?: string, routingNumber?: string, expiryYear?: number, expiryMonth?: number, cardBrand?: string, cardType?: string } } };

export type PlacementsQueryVariables = Exact<{
  zipCode: Scalars['String'];
  category?: InputMaybe<ShoppingCategoryType>;
  dob?: InputMaybe<Scalars['Date']>;
  isHomeOwner?: InputMaybe<Scalars['Boolean']>;
  isInsuredForAuto?: InputMaybe<Scalars['Boolean']>;
  creditScore?: InputMaybe<CreditScoreType>;
  policyId?: InputMaybe<Scalars['UUID']>;
  usesTobacco?: InputMaybe<Scalars['Boolean']>;
  gender?: InputMaybe<GenderType>;
  petType?: InputMaybe<PetTypeType>;
  petGender?: InputMaybe<PetGenderType>;
  petBreed?: InputMaybe<Scalars['String']>;
}>;


export type PlacementsQuery = { impressions?: Array<{ __typename: 'ImpressionType', id?: string, integrator?: string, carrier?: string, name?: string, headline?: string, description?: string, image?: string, clickUrl?: string, staticUrl?: string, insuranceTypes?: Array<string>, integratorDescription?: string, integratorHeadline?: string, tags?: Array<string> }> };

export type AreCarrierCredentialsValidQueryVariables = Exact<{
  carrierId: Scalars['UUID'];
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type AreCarrierCredentialsValidQuery = { areCarrierCredentialsValid?: boolean };

export type PoliciesQueryVariables = Exact<{
  isCurrent?: InputMaybe<Scalars['Boolean']>;
}>;


export type PoliciesQuery = { policies?: Array<{ __typename: 'AutoPolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, namedInsured?: Array<string>, address?: string, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, vehicles: Array<{ __typename: 'VehicleAssetType', id: string, vehicleInfo?: string, vehicleVin?: string, year?: number, make?: string, model?: string, ownership?: string, primaryUse?: string, othersBodilyPerson?: number, othersBodilyAccident?: number, othersMedicalPayments?: number, othersPropertyAccident?: number, personalProtectionPerson?: number, uninsuredMotoristPerson?: number, uninsuredMotoristAccident?: number, uninsuredPropertyAccident?: number, uninsuredPropertyDeductible?: number, comprehensiveValue?: string, comprehensiveDeductible?: number, collisionValue?: string, collisionDeductible?: number, reimbursementDay?: number, roadsideAssistance: boolean, roadsideAssistanceValue?: number, totalPremium?: number }>, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, drivers: Array<{ __typename: 'DriverType', id: string, created?: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, careerStatus?: NamedInsuredBaseCareerStatus, educationLevel?: NamedInsuredBaseEducationLevel, ageFirstLicensed?: number, driversLicenseNumber?: string, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }> } | { __typename: 'HomePolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, namedInsured?: Array<string>, address?: string, dwelling?: number, otherStructures?: number, personalProperty?: number, lossUse?: number, personalLiability?: number, medicalOthers?: number, deductible?: number, deductibleWind?: number, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, homeOwners: Array<{ __typename: 'HomeOwnerType', id: string, created?: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, educationLevel?: NamedInsuredBaseEducationLevel, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }>, properties: Array<{ __typename: 'PropertyType', id: string, addressLine1?: string, addressLine2?: string, propertyCity?: string, propertyZipCode?: string, typeOfProperty?: PropertyAssetTypeOfProperty, typeOfResidence?: PropertyAssetTypeOfResidence, yearBuilt?: number, squareFootage?: number, construction?: PropertyAssetConstruction, foundation?: PropertyAssetFoundation, roof?: PropertyAssetRoof, roofYearBuilt?: number, fireAlarm?: boolean, propertyState?: { __typename: 'StateType', id: string, name: string } }> } | { __typename: 'LifePolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, namedInsured?: Array<string>, address?: string, planType?: LifePolicyPlanType, otherTermYears?: number, deathBenefit?: number, conversionDate?: string, riders?: string, isGroup: boolean, cashValue?: number, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, beneficiaries: Array<{ __typename: 'BeneficiaryType', firstName?: string, lastName?: string, percentage?: number }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, lifeInsureds: Array<{ __typename: 'LifeInsuredType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, educationLevel?: NamedInsuredBaseEducationLevel, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }> } | { __typename: 'PetPolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, address?: string, petParent?: string, petParentAddress?: string, petName?: string, petType?: string, petBreed?: string, petDob?: string, petSex?: PetGenderType, hasBitten?: boolean, coinsurance?: number, reimbursement?: number, annualDeductible?: number, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, petOwners: Array<{ __typename: 'PetOwnerType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember }> } | { __typename: 'PolicyType', id: string, address?: string, isPolicyOwner?: boolean, isOnRenewal?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }> } | { __typename: 'RenterPolicyType', id: string, isOnRenewal?: boolean, isPolicyOwner?: boolean, policyNumber?: string, policyPremium?: number, premiumPeriod?: PremiumPeriodType, fees?: number, total?: number, startDate?: string, endDate?: string, continuous: boolean, synced: boolean, coverageSynced: boolean, category?: CategoryType, nextPaymentDue?: string, showSyncAnimation: boolean, basicSyncFailed: boolean, canopyEmbeddedCarrier?: string, syncFailureReason?: SyncFailureReasonType, wrongDocumentType?: WrongDocumentTypeType, namedInsured?: Array<string>, address?: string, personalProperty?: number, lossUse?: number, personalLiability?: number, medicalOthers?: number, deductible?: number, carrier?: { __typename: 'CarrierType', avgRating?: number, id: string, name: string, carrierSymbol: string, categories?: Array<string>, claimsRank?: number, claimsScore?: number, claimUrl?: string, considerations?: Array<string>, contactUrl?: string, description?: string, discounts?: Array<string>, goodFor?: Array<string>, hideInsider: boolean, logo?: string, marbleScore?: string, numRatings?: number, rating?: number, canopyId?: string, createAccountUrl?: string, resetPasswordUrl?: string, thirdFieldPlaceholder?: string, usernameFieldPlaceholder?: string, disablePasswordField?: boolean, decTipsUrl?: string, scores?: Array<{ __typename: 'CarrierScoreType', category?: string, score?: string }> }, policyHistory?: Array<{ __typename: 'PolicyHistoryType', id: string, policyNumber?: string, startDate?: string, endDate?: string, total?: number, premiumPeriod?: PremiumPeriodType }>, sharedAccess?: Array<{ __typename: 'SharedAccessType', namedInsuredId?: string, id?: string, status?: SharedAccessStatusType, fullName?: string, email?: string }>, user: { __typename: 'UserType', email: string, firstName: string, lastName: string }, documents?: Array<{ __typename: 'PolicyDocumentType', id: string, created?: string, name: string, documentType: DocumentTypeType, documentSize: number }>, renters: Array<{ __typename: 'RenterType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }>, rentals: Array<{ __typename: 'RentalType', id: string, address?: string, addressLine?: string, city?: string, zipCode?: string, typeOfProperty?: RentalAssetTypeOfProperty, state?: { __typename: 'StateType', id: string, name: string } }> }> };

export type RedemptionOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type RedemptionOptionsQuery = { products?: Array<{ __typename: 'RedemptionProductType', id: string, productName: string, title?: string, subtitle?: string, active: boolean, maximumAmount?: number, minimumAmount?: number, conversionRatio?: number, logo?: string, logoCard?: string, isDonation?: boolean, provider?: string }> };

export type RemindersQueryVariables = Exact<{ [key: string]: never; }>;


export type RemindersQuery = { reminders?: Array<{ __typename: 'ReminderType', id: string, policyCategory?: CategoryType, notes?: string, reminderCategory?: ReminderCategoryType, reminderDate: string, reminderMethod: ReminderMethodType, policy?: { __typename: 'PolicyType', id: string } }> };

export type RewardsQueryVariables = Exact<{ [key: string]: never; }>;


export type RewardsQuery = { rewards?: Array<{ __typename: 'RewardType', title: string, identifier: string, marbleValue: number }> };

export type ShareablePolicyQueryVariables = Exact<{
  shareableId: Scalars['UUID'];
}>;


export type ShareablePolicyQuery = { shareablePolicy?: { __typename: 'ShareablePolicyType', address?: string, category?: string, endDate?: string, namedInsureds?: Array<string>, petName?: string, petType?: string, planType?: string, policyNumber?: string, startDate?: string, vehicles?: Array<string>, carrier?: { __typename: 'CarrierType', name: string, logo?: string, contactUrl?: string, claimUrl?: string } } };

export type ShopUserAssetsAndNamedInsuredsQueryVariables = Exact<{
  category: CategoryType;
  userId: Scalars['UUID'];
}>;


export type ShopUserAssetsAndNamedInsuredsQuery = { shopUserAssetsAndNamedInsureds?: { __typename: 'ShopUserProfileType', assets?: Array<{ __typename: 'ShopAssetType', address?: string, id?: string, vin?: string, name?: string, drivers?: Array<{ __typename: 'ShopDriverType', id?: string, name?: string, isPrimary?: boolean }> }>, namedInsureds?: Array<{ __typename: 'ShopNamedInsuredType', dob?: string, firstName?: string, gender?: GenderType, id?: string, lastName?: string, name?: string }> } };

export type ShoppingCartsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShoppingCartsQuery = { shoppingCarts?: Array<{ __typename: 'ShoppingCartType', id: string, isActive?: boolean, category: ShoppingCartCategory, zipCode?: string, isInterestedInBundling?: boolean, isOnboardingCart: boolean, isUserCreatedCart: boolean, user: { __typename: 'UserType', id: string, firstName: string, lastName: string, preferredName?: string, legalNameConfirmed: boolean, address?: string, city?: string, zipCode?: string, state?: string, phone?: string, avatar?: string, email: string, created?: string, token?: string, gender?: GenderType, dob?: string, marbleEarned?: number, marbleAvailable?: number, marbleAvailableConverted?: number, referralCode?: string, totalReferralsBalance?: number, viewedAsBy?: string, signupBonus?: number, isAmbassador: boolean, insuranceTypes?: Array<string>, appDownloaded: boolean, shoppingZipCode?: string, creditScore?: CreditScoreType, isHomeOwner?: boolean, isInsuredForAuto?: boolean, isNewUser?: boolean, usesTobaccoProducts?: boolean, petType?: PetTypeType, petGender?: PetGenderType, zendeskToken?: string, moveInDate?: string, previousAddress?: string, previousCity?: string, previousZipCode?: string, previousState?: string, ownership?: OwnershipType, progressBar?: Array<{ __typename: 'ProgressBarType', action?: string, status?: string }>, referrals?: Array<{ __typename: 'ReferralType', firstName?: string, lastName?: string, memberSince?: string }>, policyUploadRewards?: Array<{ __typename: 'PolicyUploadRewardType', category?: string, marbleCount?: number }> }, drivers: Array<{ __typename: 'DriverType', id: string, created?: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, careerStatus?: NamedInsuredBaseCareerStatus, educationLevel?: NamedInsuredBaseEducationLevel, ageFirstLicensed?: number, driversLicenseNumber?: string, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }>, homeOwners: Array<{ __typename: 'HomeOwnerType', id: string, created?: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, maritalStatus?: NamedInsuredBaseMaritalStatus, educationLevel?: NamedInsuredBaseEducationLevel, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }>, renters: Array<{ __typename: 'RenterType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }>, petOwners: Array<{ __typename: 'PetOwnerType', id: string, firstName?: string, lastName?: string, dob?: string, gender?: GenderType, relationToMarbleMember?: NamedInsuredBaseRelationToMarbleMember, driversLicenseNumber?: string, driversLicenseState?: { __typename: 'StateType', id: string, name: string } }>, vehicles: Array<{ __typename: 'VehicleType', id: string, make?: string, model?: string, ownership?: VehicleAssetOwnership, vehicleInfo?: string, vehicleVin?: string, year?: number }>, properties: Array<{ __typename: 'PropertyType', addressLine1?: string, addressLine2?: string, propertyCity?: string, propertyZipCode?: string, canopyId?: string }>, rentals: Array<{ __typename: 'RentalType', addressLine?: string, city?: string }>, pets: Array<{ __typename: 'PetType', name?: string, breed?: string }>, policy?: { __typename: 'ShoppingCartPolicyType', policyId?: string, policyNumber?: string, endDate?: string, continuous?: boolean, assets?: Array<{ __typename: 'ShoppingCartAssetType', name?: string, addressLine?: string, ownership?: OwnershipStatusType, model?: string, make?: string, year?: number }>, namedInsureds?: Array<{ __typename: 'ShoppingCartNamedInsuredType', firstName?: string, lastName?: string }>, coverageDetails?: Array<{ __typename: 'CoverageDetailsType', planType?: LifePolicyPlanType, otherTermYears?: number }> }, offers?: Array<{ __typename: 'OfferType', id: string, partner?: string, policyIds?: Array<string>, premium?: number, policyType?: Array<ShoppingCategoryType>, termMonths?: number, offerDocument?: string, link?: string, carrier?: string, expiryDate?: string, logo?: string, savings?: number, partnerQuoteId?: string, shoppingCartId?: string, userSavedDate?: string, tier?: OfferTier, status?: OfferStatusType, template?: { __typename: 'OfferTemplateType', headline?: string, description?: string, logo?: string, ctaCopy?: string, ctaIcon?: OfferTemplateCtaIcon, finePrint?: string }, coverages?: { __typename: 'OfferCoverageType', othersBodilyPerson?: number, othersBodilyAccident?: number, othersPropertyAccident?: number, othersMedicalPayments?: number, uninsuredMotoristPerson?: number, comprehensiveDeductible?: number, collisionDeductible?: number, aDwelling?: number, bOtherStructures?: number, cPersonalProperty?: number, dLossUse?: number, ePersonalLiability?: number, fMedicalOthers?: number, deductibleWind?: number, deductible?: number, coinsurancePercentage?: number, reimbursementPercentage?: number, deathBenefit?: number, cashValue?: number, comparisonData?: { __typename: 'OfferCoverageComparisonDataType', othersBodilyPerson?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, othersBodilyAccident?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, othersPropertyAccident?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, othersMedicalPayments?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, uninsuredMotoristPerson?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, comprehensiveDeductible?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, collisionDeductible?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, aDwelling?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, bOtherStructures?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, cPersonalProperty?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, dLossUse?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, ePersonalLiability?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, fMedicalOthers?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, deductibleWind?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, deductible?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, coinsurancePercentage?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, reimbursementPercentage?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, deathBenefit?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, cashValue?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any } } } }>, dismissedOffers?: Array<{ __typename: 'OfferType', id: string, partner?: string, policyIds?: Array<string>, premium?: number, policyType?: Array<ShoppingCategoryType>, termMonths?: number, offerDocument?: string, link?: string, carrier?: string, expiryDate?: string, logo?: string, savings?: number, partnerQuoteId?: string, shoppingCartId?: string, userSavedDate?: string, tier?: OfferTier, status?: OfferStatusType, template?: { __typename: 'OfferTemplateType', headline?: string, description?: string, logo?: string, ctaCopy?: string, ctaIcon?: OfferTemplateCtaIcon, finePrint?: string }, coverages?: { __typename: 'OfferCoverageType', othersBodilyPerson?: number, othersBodilyAccident?: number, othersPropertyAccident?: number, othersMedicalPayments?: number, uninsuredMotoristPerson?: number, comprehensiveDeductible?: number, collisionDeductible?: number, aDwelling?: number, bOtherStructures?: number, cPersonalProperty?: number, dLossUse?: number, ePersonalLiability?: number, fMedicalOthers?: number, deductibleWind?: number, deductible?: number, coinsurancePercentage?: number, reimbursementPercentage?: number, deathBenefit?: number, cashValue?: number, comparisonData?: { __typename: 'OfferCoverageComparisonDataType', othersBodilyPerson?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, othersBodilyAccident?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, othersPropertyAccident?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, othersMedicalPayments?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, uninsuredMotoristPerson?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, comprehensiveDeductible?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, collisionDeductible?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, aDwelling?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, bOtherStructures?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, cPersonalProperty?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, dLossUse?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, ePersonalLiability?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, fMedicalOthers?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, deductibleWind?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, deductible?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, coinsurancePercentage?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, reimbursementPercentage?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, deathBenefit?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any }, cashValue?: { __typename: 'OfferCoverageComparisonDataDictType', label?: string, value?: any } } } }> }> };

export type SiteConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type SiteConfigurationQuery = { siteConfiguration?: { __typename: 'SiteConfigurationType', appleStoreLink?: string, googleStoreLink?: string, mobileAppLive: boolean, featureToggles: Array<{ __typename: 'FeatureToggleType', name: string, isEnabled: boolean }> } };

export type StatesQueryVariables = Exact<{ [key: string]: never; }>;


export type StatesQuery = { states?: Array<{ __typename: 'StateType', id: string, name: string, abbreviation?: string }> };

export type OnUserMarblesChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnUserMarblesChangedSubscription = { onUserMarblesChanged?: { __typename: 'OnUserMarblesChanged', marbleAvailable?: number, marbleAvailableConverted?: number, balanceAnimationValue?: number } };

export type OnPolicyDataPullCompletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnPolicyDataPullCompletedSubscription = { onPolicyDataPullCompleted?: { __typename: 'OnPolicyDataPullCompleted', policyId?: string } };

export type OnPolicySyncedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnPolicySyncedSubscription = { onPolicySynced?: { __typename: 'OnPolicySynced', policyId?: string, showSyncAnimation?: boolean } };
